/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(147);
	module.exports = __webpack_require__(54);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 =
	/*#__PURE__*/
	__webpack_require__(4);
	
	var _isPlaceholder =
	/*#__PURE__*/
	__webpack_require__(11);
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	
	      case 1:
	        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
	          return fn(a, _b);
	        });
	
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
	          return fn(_a, b);
	        }) : _isPlaceholder(b) ? _curry1(function (_b) {
	          return fn(a, _b);
	        }) : fn(a, b);
	    }
	  };
	}
	
	module.exports = _curry2;

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = whitespace
	
	var fromCode = String.fromCharCode
	var re = /\s/
	
	// Check if the given character code, or the character code at the first
	// character, is a whitespace character.
	function whitespace(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var _isPlaceholder =
	/*#__PURE__*/
	__webpack_require__(11);
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	}
	
	module.exports = _curry1;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(151);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 6 */
/***/ function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var domelementtype_1 = __webpack_require__(12);
	function isTag(node) {
	    return domelementtype_1.isTag(node);
	}
	exports.isTag = isTag;
	function isCDATA(node) {
	    return node.type === "cdata" /* CDATA */;
	}
	exports.isCDATA = isCDATA;
	function isText(node) {
	    return node.type === "text" /* Text */;
	}
	exports.isText = isText;
	function isComment(node) {
	    return node.type === "comment" /* Comment */;
	}
	exports.isComment = isComment;
	function hasChildren(node) {
	    return Object.prototype.hasOwnProperty.call(node, "children");
	}
	exports.hasChildren = hasChildren;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var visitParents = __webpack_require__(204)
	
	var CONTINUE = visitParents.CONTINUE
	var SKIP = visitParents.SKIP
	var EXIT = visitParents.EXIT
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  visitParents(tree, test, overload, reverse)
	
	  function overload(node, parents) {
	    var parent = parents[parents.length - 1]
	    var index = parent ? parent.children.indexOf(node) : null
	    return visitor(node, index, parent)
	  }
	}


/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = decimal
	
	// Check if the given character code, or the character code at the first
	// character, is decimal.
	function decimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return code >= 48 && code <= 57 /* 0-9 */
	}


/***/ },
/* 10 */
/***/ function(module, exports) {

	function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = _has;

/***/ },
/* 11 */
/***/ function(module, exports) {

	function _isPlaceholder(a) {
	  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
	}
	
	module.exports = _isPlaceholder;

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */
	function isTag(elem) {
	    return (elem.type === "tag" /* Tag */ ||
	        elem.type === "script" /* Script */ ||
	        elem.type === "style" /* Style */);
	}
	exports.isTag = isTag;
	// Exports for backwards compatibility
	exports.Text = "text" /* Text */; //Text
	exports.Directive = "directive" /* Directive */; //<? ... ?>
	exports.Comment = "comment" /* Comment */; //<!-- ... -->
	exports.Script = "script" /* Script */; //<script> tags
	exports.Style = "style" /* Style */; //<style> tags
	exports.Tag = "tag" /* Tag */; //Any tag
	exports.CDATA = "cdata" /* CDATA */; //<![CDATA[ ... ]]>
	exports.Doctype = "doctype" /* Doctype */;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(58);
	exports.Node = node_1.Node;
	exports.Element = node_1.Element;
	exports.DataNode = node_1.DataNode;
	exports.NodeWithChildren = node_1.NodeWithChildren;
	var reWhitespace = /\s+/g;
	// Default options
	var defaultOpts = {
	    normalizeWhitespace: false,
	    withStartIndices: false,
	    withEndIndices: false
	};
	var DomHandler = /** @class */ (function () {
	    /**
	     * Initiate a new DomHandler.
	     *
	     * @param callback Called once parsing has completed.
	     * @param options Settings for the handler.
	     * @param elementCB Callback whenever a tag is closed.
	     */
	    function DomHandler(callback, options, elementCB) {
	        /** The constructed DOM */
	        this.dom = [];
	        /** Indicated whether parsing has been completed. */
	        this._done = false;
	        /** Stack of open tags. */
	        this._tagStack = [];
	        /** A data node that is still being written to. */
	        this._lastNode = null;
	        /** Reference to the parser instance. Used for location information. */
	        this._parser = null;
	        // Make it possible to skip arguments, for backwards-compatibility
	        if (typeof options === "function") {
	            elementCB = options;
	            options = defaultOpts;
	        }
	        if (typeof callback === "object") {
	            options = callback;
	            callback = undefined;
	        }
	        this._callback = callback || null;
	        this._options = options || defaultOpts;
	        this._elementCB = elementCB || null;
	    }
	    DomHandler.prototype.onparserinit = function (parser) {
	        this._parser = parser;
	    };
	    // Resets the handler back to starting state
	    DomHandler.prototype.onreset = function () {
	        this.dom = [];
	        this._done = false;
	        this._tagStack = [];
	        this._lastNode = null;
	        this._parser = this._parser || null;
	    };
	    // Signals the handler that parsing is done
	    DomHandler.prototype.onend = function () {
	        if (this._done)
	            return;
	        this._done = true;
	        this._parser = null;
	        this.handleCallback(null);
	    };
	    DomHandler.prototype.onerror = function (error) {
	        this.handleCallback(error);
	    };
	    DomHandler.prototype.onclosetag = function () {
	        this._lastNode = null;
	        // If(this._tagStack.pop().name !== name) this.handleCallback(Error("Tagname didn't match!"));
	        var elem = this._tagStack.pop();
	        if (!elem || !this._parser) {
	            return;
	        }
	        if (this._options.withEndIndices) {
	            elem.endIndex = this._parser.endIndex;
	        }
	        if (this._elementCB)
	            this._elementCB(elem);
	    };
	    DomHandler.prototype.onopentag = function (name, attribs) {
	        var element = new node_1.Element(name, attribs);
	        this.addNode(element);
	        this._tagStack.push(element);
	    };
	    DomHandler.prototype.ontext = function (data) {
	        var normalize = this._options.normalizeWhitespace;
	        var _lastNode = this._lastNode;
	        if (_lastNode && _lastNode.type === "text" /* Text */) {
	            if (normalize) {
	                _lastNode.data = (_lastNode.data + data).replace(reWhitespace, " ");
	            }
	            else {
	                _lastNode.data += data;
	            }
	        }
	        else {
	            if (normalize) {
	                data = data.replace(reWhitespace, " ");
	            }
	            var node = new node_1.DataNode("text" /* Text */, data);
	            this.addNode(node);
	            this._lastNode = node;
	        }
	    };
	    DomHandler.prototype.oncomment = function (data) {
	        if (this._lastNode && this._lastNode.type === "comment" /* Comment */) {
	            this._lastNode.data += data;
	            return;
	        }
	        var node = new node_1.DataNode("comment" /* Comment */, data);
	        this.addNode(node);
	        this._lastNode = node;
	    };
	    DomHandler.prototype.oncommentend = function () {
	        this._lastNode = null;
	    };
	    DomHandler.prototype.oncdatastart = function () {
	        var text = new node_1.DataNode("text" /* Text */, "");
	        var node = new node_1.NodeWithChildren("cdata" /* CDATA */, [text]);
	        this.addNode(node);
	        text.parent = node;
	        this._lastNode = text;
	    };
	    DomHandler.prototype.oncdataend = function () {
	        this._lastNode = null;
	    };
	    DomHandler.prototype.onprocessinginstruction = function (name, data) {
	        var node = new node_1.ProcessingInstruction(name, data);
	        this.addNode(node);
	    };
	    DomHandler.prototype.handleCallback = function (error) {
	        if (typeof this._callback === "function") {
	            this._callback(error, this.dom);
	        }
	        else if (error) {
	            throw error;
	        }
	    };
	    DomHandler.prototype.addNode = function (node) {
	        var parent = this._tagStack[this._tagStack.length - 1];
	        var siblings = parent ? parent.children : this.dom;
	        var previousSibling = siblings[siblings.length - 1];
	        if (this._parser) {
	            if (this._options.withStartIndices) {
	                node.startIndex = this._parser.startIndex;
	            }
	            if (this._options.withEndIndices) {
	                node.endIndex = this._parser.endIndex;
	            }
	        }
	        siblings.push(node);
	        if (previousSibling) {
	            node.prev = previousSibling;
	            previousSibling.next = node;
	        }
	        if (parent) {
	            node.parent = parent;
	        }
	        this._lastNode = null;
	    };
	    DomHandler.prototype.addDataNode = function (node) {
	        this.addNode(node);
	        this._lastNode = node;
	    };
	    return DomHandler;
	}());
	exports.DomHandler = DomHandler;
	exports.default = DomHandler;


/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var legacy = __webpack_require__(84)
	var invalid = __webpack_require__(85)
	var decimal = __webpack_require__(9)
	var hexadecimal = __webpack_require__(81)
	var alphanumerical = __webpack_require__(79)
	var decodeEntity = __webpack_require__(92)
	
	module.exports = parseEntities
	
	var own = {}.hasOwnProperty
	var fromCharCode = String.fromCharCode
	var noop = Function.prototype
	
	// Default settings.
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	}
	
	// Characters.
	var tab = 9 // '\t'
	var lineFeed = 10 // '\n'
	var formFeed = 12 //  '\f'
	var space = 32 // ' '
	var ampersand = 38 //  '&'
	var semicolon = 59 //  ';'
	var lessThan = 60 //  '<'
	var equalsTo = 61 //  '='
	var numberSign = 35 //  '#'
	var uppercaseX = 88 //  'X'
	var lowercaseX = 120 //  'x'
	var replacementCharacter = 65533 // '�'
	
	// Reference types.
	var name = 'named'
	var hexa = 'hexadecimal'
	var deci = 'decimal'
	
	// Map of bases.
	var bases = {}
	
	bases[hexa] = 16
	bases[deci] = 10
	
	// Map of types to tests.
	// Each type of character reference accepts different characters.
	// This test is used to detect whether a reference has ended (as the semicolon
	// is not strictly needed).
	var tests = {}
	
	tests[name] = alphanumerical
	tests[deci] = decimal
	tests[hexa] = hexadecimal
	
	// Warning types.
	var namedNotTerminated = 1
	var numericNotTerminated = 2
	var namedEmpty = 3
	var numericEmpty = 4
	var namedUnknown = 5
	var numericDisallowed = 6
	var numericProhibited = 7
	
	// Warning messages.
	var messages = {}
	
	messages[namedNotTerminated] =
	  'Named character references must be terminated by a semicolon'
	messages[numericNotTerminated] =
	  'Numeric character references must be terminated by a semicolon'
	messages[namedEmpty] = 'Named character references cannot be empty'
	messages[numericEmpty] = 'Numeric character references cannot be empty'
	messages[namedUnknown] = 'Named character references must be known'
	messages[numericDisallowed] =
	  'Numeric character references cannot be disallowed'
	messages[numericProhibited] =
	  'Numeric character references cannot be outside the permissible Unicode range'
	
	// Wrap to ensure clean parameters are given to `parse`.
	function parseEntities(value, options) {
	  var settings = {}
	  var option
	  var key
	
	  if (!options) {
	    options = {}
	  }
	
	  for (key in defaults) {
	    option = options[key]
	    settings[key] =
	      option === null || option === undefined ? defaults[key] : option
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || []
	    settings.position = settings.position.start
	  }
	
	  return parse(value, settings)
	}
	
	// Parse entities.
	// eslint-disable-next-line complexity
	function parse(value, settings) {
	  var additional = settings.additional
	  var nonTerminated = settings.nonTerminated
	  var handleText = settings.text
	  var handleReference = settings.reference
	  var handleWarning = settings.warning
	  var textContext = settings.textContext
	  var referenceContext = settings.referenceContext
	  var warningContext = settings.warningContext
	  var pos = settings.position
	  var indent = settings.indent || []
	  var length = value.length
	  var index = 0
	  var lines = -1
	  var column = pos.column || 1
	  var line = pos.line || 1
	  var queue = ''
	  var result = []
	  var entityCharacters
	  var namedEntity
	  var terminated
	  var characters
	  var character
	  var reference
	  var following
	  var warning
	  var reason
	  var output
	  var entity
	  var begin
	  var start
	  var type
	  var test
	  var prev
	  var next
	  var diff
	  var end
	
	  if (typeof additional === 'string') {
	    additional = additional.charCodeAt(0)
	  }
	
	  // Cache the current point.
	  prev = now()
	
	  // Wrap `handleWarning`.
	  warning = handleWarning ? parseError : noop
	
	  // Ensure the algorithm walks over the first character and the end (inclusive).
	  index--
	  length++
	
	  while (++index < length) {
	    // If the previous character was a newline.
	    if (character === lineFeed) {
	      column = indent[lines] || 1
	    }
	
	    character = value.charCodeAt(index)
	
	    if (character === ampersand) {
	      following = value.charCodeAt(index + 1)
	
	      // The behaviour depends on the identity of the next character.
	      if (
	        following === tab ||
	        following === lineFeed ||
	        following === formFeed ||
	        following === space ||
	        following === ampersand ||
	        following === lessThan ||
	        following !== following ||
	        (additional && following === additional)
	      ) {
	        // Not a character reference.
	        // No characters are consumed, and nothing is returned.
	        // This is not an error, either.
	        queue += fromCharCode(character)
	        column++
	
	        continue
	      }
	
	      start = index + 1
	      begin = start
	      end = start
	
	      if (following === numberSign) {
	        // Numerical entity.
	        end = ++begin
	
	        // The behaviour further depends on the next character.
	        following = value.charCodeAt(end)
	
	        if (following === uppercaseX || following === lowercaseX) {
	          // ASCII hex digits.
	          type = hexa
	          end = ++begin
	        } else {
	          // ASCII digits.
	          type = deci
	        }
	      } else {
	        // Named entity.
	        type = name
	      }
	
	      entityCharacters = ''
	      entity = ''
	      characters = ''
	      test = tests[type]
	      end--
	
	      while (++end < length) {
	        following = value.charCodeAt(end)
	
	        if (!test(following)) {
	          break
	        }
	
	        characters += fromCharCode(following)
	
	        // Check if we can match a legacy named reference.
	        // If so, we cache that as the last viable named reference.
	        // This ensures we do not need to walk backwards later.
	        if (type === name && own.call(legacy, characters)) {
	          entityCharacters = characters
	          entity = legacy[characters]
	        }
	      }
	
	      terminated = value.charCodeAt(end) === semicolon
	
	      if (terminated) {
	        end++
	
	        namedEntity = type === name ? decodeEntity(characters) : false
	
	        if (namedEntity) {
	          entityCharacters = characters
	          entity = namedEntity
	        }
	      }
	
	      diff = 1 + end - start
	
	      if (!terminated && !nonTerminated) {
	        // Empty.
	      } else if (!characters) {
	        // An empty (possible) entity is valid, unless it’s numeric (thus an
	        // ampersand followed by an octothorp).
	        if (type !== name) {
	          warning(numericEmpty, diff)
	        }
	      } else if (type === name) {
	        // An ampersand followed by anything unknown, and not terminated, is
	        // invalid.
	        if (terminated && !entity) {
	          warning(namedUnknown, 1)
	        } else {
	          // If theres something after an entity name which is not known, cap
	          // the reference.
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length
	            diff = 1 + end - begin
	            terminated = false
	          }
	
	          // If the reference is not terminated, warn.
	          if (!terminated) {
	            reason = entityCharacters ? namedNotTerminated : namedEmpty
	
	            if (settings.attribute) {
	              following = value.charCodeAt(end)
	
	              if (following === equalsTo) {
	                warning(reason, diff)
	                entity = null
	              } else if (alphanumerical(following)) {
	                entity = null
	              } else {
	                warning(reason, diff)
	              }
	            } else {
	              warning(reason, diff)
	            }
	          }
	        }
	
	        reference = entity
	      } else {
	        if (!terminated) {
	          // All non-terminated numeric entities are not rendered, and trigger a
	          // warning.
	          warning(numericNotTerminated, diff)
	        }
	
	        // When terminated and number, parse as either hexadecimal or decimal.
	        reference = parseInt(characters, bases[type])
	
	        // Trigger a warning when the parsed number is prohibited, and replace
	        // with replacement character.
	        if (prohibited(reference)) {
	          warning(numericProhibited, diff)
	          reference = fromCharCode(replacementCharacter)
	        } else if (reference in invalid) {
	          // Trigger a warning when the parsed number is disallowed, and replace
	          // by an alternative.
	          warning(numericDisallowed, diff)
	          reference = invalid[reference]
	        } else {
	          // Parse the number.
	          output = ''
	
	          // Trigger a warning when the parsed number should not be used.
	          if (disallowed(reference)) {
	            warning(numericDisallowed, diff)
	          }
	
	          // Stringify the number.
	          if (reference > 0xffff) {
	            reference -= 0x10000
	            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
	            reference = 0xdc00 | (reference & 0x3ff)
	          }
	
	          reference = output + fromCharCode(reference)
	        }
	      }
	
	      // Found it!
	      // First eat the queued characters as normal text, then eat an entity.
	      if (reference) {
	        flush()
	
	        prev = now()
	        index = end - 1
	        column += end - start + 1
	        result.push(reference)
	        next = now()
	        next.offset++
	
	        if (handleReference) {
	          handleReference.call(
	            referenceContext,
	            reference,
	            {start: prev, end: next},
	            value.slice(start - 1, end)
	          )
	        }
	
	        prev = next
	      } else {
	        // If we could not find a reference, queue the checked characters (as
	        // normal characters), and move the pointer to their end.
	        // This is possible because we can be certain neither newlines nor
	        // ampersands are included.
	        characters = value.slice(start - 1, end)
	        queue += characters
	        column += characters.length
	        index = end - 1
	      }
	    } else {
	      // Handle anything other than an ampersand, including newlines and EOF.
	      if (
	        character === 10 // Line feed
	      ) {
	        line++
	        lines++
	        column = 0
	      }
	
	      if (character === character) {
	        queue += fromCharCode(character)
	        column++
	      } else {
	        flush()
	      }
	    }
	  }
	
	  // Return the reduced nodes, and any possible warnings.
	  return result.join('')
	
	  // Get current position.
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    }
	  }
	
	  // “Throw” a parse-error: a warning.
	  function parseError(code, offset) {
	    var position = now()
	
	    position.column += offset
	    position.offset += offset
	
	    handleWarning.call(warningContext, messages[code], position, code)
	  }
	
	  // Flush `queue` (normal text).
	  // Macro invoked before each entity and at the end of `value`.
	  // Does nothing when `queue` is empty.
	  function flush() {
	    if (queue) {
	      result.push(queue)
	
	      if (handleText) {
	        handleText.call(textContext, queue, {start: prev, end: now()})
	      }
	
	      queue = ''
	    }
	  }
	}
	
	// Check if `character` is outside the permissible unicode range.
	function prohibited(code) {
	  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
	}
	
	// Check if `character` is disallowed.
	function disallowed(code) {
	  return (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000b ||
	    (code >= 0x000d && code <= 0x001f) ||
	    (code >= 0x007f && code <= 0x009f) ||
	    (code >= 0xfdd0 && code <= 0xfdef) ||
	    (code & 0xffff) === 0xffff ||
	    (code & 0xffff) === 0xfffe
	  )
	}


/***/ },
/* 18 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 19 */
/***/ function(module, exports) {

	function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0:
	      return function () {
	        return fn.apply(this, arguments);
	      };
	
	    case 1:
	      return function (a0) {
	        return fn.apply(this, arguments);
	      };
	
	    case 2:
	      return function (a0, a1) {
	        return fn.apply(this, arguments);
	      };
	
	    case 3:
	      return function (a0, a1, a2) {
	        return fn.apply(this, arguments);
	      };
	
	    case 4:
	      return function (a0, a1, a2, a3) {
	        return fn.apply(this, arguments);
	      };
	
	    case 5:
	      return function (a0, a1, a2, a3, a4) {
	        return fn.apply(this, arguments);
	      };
	
	    case 6:
	      return function (a0, a1, a2, a3, a4, a5) {
	        return fn.apply(this, arguments);
	      };
	
	    case 7:
	      return function (a0, a1, a2, a3, a4, a5, a6) {
	        return fn.apply(this, arguments);
	      };
	
	    case 8:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
	        return fn.apply(this, arguments);
	      };
	
	    case 9:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	        return fn.apply(this, arguments);
	      };
	
	    case 10:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
	        return fn.apply(this, arguments);
	      };
	
	    default:
	      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	}
	
	module.exports = _arity;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray =
	/*#__PURE__*/
	__webpack_require__(21);
	
	var _isTransformer =
	/*#__PURE__*/
	__webpack_require__(119);
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	
	
	function _dispatchable(methodNames, xf, fn) {
	  return function () {
	    if (arguments.length === 0) {
	      return fn();
	    }
	
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	
	    if (!_isArray(obj)) {
	      var idx = 0;
	
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	
	        idx += 1;
	      }
	
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	
	    return fn.apply(this, arguments);
	  };
	}
	
	module.exports = _dispatchable;

/***/ },
/* 21 */
/***/ function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var _isArrayLike =
	/*#__PURE__*/
	__webpack_require__(116);
	
	var _xwrap =
	/*#__PURE__*/
	__webpack_require__(126);
	
	var bind =
	/*#__PURE__*/
	__webpack_require__(97);
	
	function _arrayReduce(xf, acc, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    acc = xf['@@transducer/step'](acc, list[idx]);
	
	    if (acc && acc['@@transducer/reduced']) {
	      acc = acc['@@transducer/value'];
	      break;
	    }
	
	    idx += 1;
	  }
	
	  return xf['@@transducer/result'](acc);
	}
	
	function _iterableReduce(xf, acc, iter) {
	  var step = iter.next();
	
	  while (!step.done) {
	    acc = xf['@@transducer/step'](acc, step.value);
	
	    if (acc && acc['@@transducer/reduced']) {
	      acc = acc['@@transducer/value'];
	      break;
	    }
	
	    step = iter.next();
	  }
	
	  return xf['@@transducer/result'](acc);
	}
	
	function _methodReduce(xf, acc, obj, methodName) {
	  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
	}
	
	var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
	
	function _reduce(fn, acc, list) {
	  if (typeof fn === 'function') {
	    fn = _xwrap(fn);
	  }
	
	  if (_isArrayLike(list)) {
	    return _arrayReduce(fn, acc, list);
	  }
	
	  if (typeof list['fantasy-land/reduce'] === 'function') {
	    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
	  }
	
	  if (list[symIterator] != null) {
	    return _iterableReduce(fn, acc, list[symIterator]());
	  }
	
	  if (typeof list.next === 'function') {
	    return _iterableReduce(fn, acc, list);
	  }
	
	  if (typeof list.reduce === 'function') {
	    return _methodReduce(fn, acc, list, 'reduce');
	  }
	
	  throw new TypeError('reduce: list must be array or iterable');
	}
	
	module.exports = _reduce;

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = {
	  init: function () {
	    return this.xf['@@transducer/init']();
	  },
	  result: function (result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 =
	/*#__PURE__*/
	__webpack_require__(4);
	
	var _has =
	/*#__PURE__*/
	__webpack_require__(10);
	
	var _isArguments =
	/*#__PURE__*/
	__webpack_require__(115); // cover IE < 9 keys issues
	
	
	var hasEnumBug = !
	/*#__PURE__*/
	{
	  toString: null
	}.propertyIsEnumerable('toString');
	var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug
	
	var hasArgsEnumBug =
	/*#__PURE__*/
	function () {
	  'use strict';
	
	  return arguments.propertyIsEnumerable('length');
	}();
	
	var contains = function contains(list, item) {
	  var idx = 0;
	
	  while (idx < list.length) {
	    if (list[idx] === item) {
	      return true;
	    }
	
	    idx += 1;
	  }
	
	  return false;
	};
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @see R.keysIn, R.values
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	
	
	var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ?
	/*#__PURE__*/
	_curry1(function keys(obj) {
	  return Object(obj) !== obj ? [] : Object.keys(obj);
	}) :
	/*#__PURE__*/
	_curry1(function keys(obj) {
	  if (Object(obj) !== obj) {
	    return [];
	  }
	
	  var prop, nIdx;
	  var ks = [];
	
	  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	
	  for (prop in obj) {
	    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	      ks[ks.length] = prop;
	    }
	  }
	
	  if (hasEnumBug) {
	    nIdx = nonEnumerableProps.length - 1;
	
	    while (nIdx >= 0) {
	      prop = nonEnumerableProps[nIdx];
	
	      if (_has(prop, obj) && !contains(ks, prop)) {
	        ks[ks.length] = prop;
	      }
	
	      nIdx -= 1;
	    }
	  }
	
	  return ks;
	});
	module.exports = keys;

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = interrupt;
	
	function interrupt(interruptors, tokenizers, ctx, params) {
	  var bools = ['pedantic', 'commonmark'];
	  var count = bools.length;
	  var length = interruptors.length;
	  var index = -1;
	  var interruptor;
	  var config;
	  var fn;
	  var offset;
	  var bool;
	  var ignore;
	
	  while (++index < length) {
	    interruptor = interruptors[index];
	    config = interruptor[1] || {};
	    fn = interruptor[0];
	    offset = -1;
	    ignore = false;
	
	    while (++offset < count) {
	      bool = bools[offset];
	
	      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
	        ignore = true;
	        break;
	      }
	    }
	
	    if (ignore) {
	      continue;
	    }
	
	    if (tokenizers[fn].apply(ctx, params)) {
	      return true;
	    }
	  }
	
	  return false;
	}


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var collapseWhiteSpace = __webpack_require__(56);
	
	module.exports = normalize;
	
	/* Normalize an identifier.  Collapses multiple white space
	 * characters into a single space, and removes casing. */
	function normalize(value) {
	  return collapseWhiteSpace(value).toLowerCase();
	}


/***/ },
/* 27 */
/***/ function(module, exports) {

	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}


/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = trimTrailingLines
	
	var line = '\n'
	
	// Remove final newline characters from `value`.
	function trimTrailingLines(value) {
	  var val = String(value)
	  var index = val.length
	
	  while (val.charAt(--index) === line) {
	    // Empty
	  }
	
	  return val.slice(0, index + 1)
	}


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(62));
	__export(__webpack_require__(63));
	__export(__webpack_require__(61));
	__export(__webpack_require__(30));
	__export(__webpack_require__(60));
	__export(__webpack_require__(59));
	__export(__webpack_require__(7));


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tagtypes_1 = __webpack_require__(7);
	/**
	 * Search a node and its children for nodes passing a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param element Element to search. Will be included in the result set if it matches.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 */
	function filter(test, node, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    if (!Array.isArray(node))
	        node = [node];
	    return find(test, node, recurse, limit);
	}
	exports.filter = filter;
	/**
	 * Like `filter`, but only works on an array of nodes.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 */
	function find(test, nodes, recurse, limit) {
	    var result = [];
	    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
	        var elem = nodes_1[_i];
	        if (test(elem)) {
	            result.push(elem);
	            if (--limit <= 0)
	                break;
	        }
	        if (recurse && tagtypes_1.hasChildren(elem) && elem.children.length > 0) {
	            var children = find(test, elem.children, recurse, limit);
	            result.push.apply(result, children);
	            limit -= children.length;
	            if (limit <= 0)
	                break;
	        }
	    }
	    return result;
	}
	exports.find = find;
	/**
	 * Finds the first element inside of an array that matches a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */
	function findOneChild(test, nodes) {
	    return nodes.find(test);
	}
	exports.findOneChild = findOneChild;
	/**
	 * Finds one element in a tree that passes a test.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 */
	function findOne(test, nodes, recurse) {
	    if (recurse === void 0) { recurse = true; }
	    var elem = null;
	    for (var i = 0; i < nodes.length && !elem; i++) {
	        var checked = nodes[i];
	        if (!tagtypes_1.isTag(checked)) {
	            continue;
	        }
	        else if (test(checked)) {
	            elem = checked;
	        }
	        else if (recurse && checked.children.length > 0) {
	            elem = findOne(test, checked.children);
	        }
	    }
	    return elem;
	}
	exports.findOne = findOne;
	/**
	 * Returns whether a tree of nodes contains at least one node passing a test.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */
	function existsOne(test, nodes) {
	    return nodes.some(function (checked) {
	        return tagtypes_1.isTag(checked) &&
	            (test(checked) ||
	                (checked.children.length > 0 &&
	                    existsOne(test, checked.children)));
	    });
	}
	exports.existsOne = existsOne;
	/**
	 * Search and array of nodes and its children for nodes passing a test function.
	 *
	 * Same as `find`, only with less options, leading to reduced complexity.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */
	function findAll(test, nodes) {
	    var _a;
	    var result = [];
	    var stack = nodes.filter(tagtypes_1.isTag);
	    var elem;
	    while ((elem = stack.shift())) {
	        var children = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter(tagtypes_1.isTag);
	        if (children && children.length > 0) {
	            stack.unshift.apply(stack, children);
	        }
	        if (test(elem))
	            result.push(elem);
	    }
	    return result;
	}
	exports.findAll = findAll;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
	var entities_json_1 = __importDefault(__webpack_require__(14));
	var legacy_json_1 = __importDefault(__webpack_require__(42));
	var xml_json_1 = __importDefault(__webpack_require__(15));
	var decode_codepoint_1 = __importDefault(__webpack_require__(32));
	exports.decodeXML = getStrictDecoder(xml_json_1.default);
	exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
	function getStrictDecoder(map) {
	    var keys = Object.keys(map).join("|");
	    var replace = getReplacer(map);
	    keys += "|#[xX][\\da-fA-F]+|#\\d+";
	    var re = new RegExp("&(?:" + keys + ");", "g");
	    return function (str) { return String(str).replace(re, replace); };
	}
	var sorter = function (a, b) { return (a < b ? 1 : -1); };
	exports.decodeHTML = (function () {
	    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
	    var keys = Object.keys(entities_json_1.default).sort(sorter);
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        }
	        else {
	            keys[i] += ";";
	        }
	    }
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
	    var replace = getReplacer(entities_json_1.default);
	    function replacer(str) {
	        if (str.substr(-1) !== ";")
	            str += ";";
	        return replace(str);
	    }
	    //TODO consider creating a merged map
	    return function (str) { return String(str).replace(re, replacer); };
	})();
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            var secondChar = str.charAt(2);
	            if (secondChar === "X" || secondChar === "x") {
	                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
	            }
	            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
	        }
	        return map[str.slice(1, -1)];
	    };
	}


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decode_json_1 = __importDefault(__webpack_require__(87));
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	    if (codePoint in decode_json_1.default) {
	        codePoint = decode_json_1.default[codePoint];
	    }
	    var output = "";
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	    output += String.fromCharCode(codePoint);
	    return output;
	}
	exports.default = decodeCodePoint;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.escape = exports.encodeHTML = exports.encodeXML = void 0;
	var xml_json_1 = __importDefault(__webpack_require__(15));
	var inverseXML = getInverseObj(xml_json_1.default);
	var xmlReplacer = getInverseReplacer(inverseXML);
	exports.encodeXML = getInverse(inverseXML, xmlReplacer);
	var entities_json_1 = __importDefault(__webpack_require__(14));
	var inverseHTML = getInverseObj(entities_json_1.default);
	var htmlReplacer = getInverseReplacer(inverseHTML);
	exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function (inverse, name) {
	        inverse[obj[name]] = "&" + name + ";";
	        return inverse;
	    }, {});
	}
	function getInverseReplacer(inverse) {
	    var single = [];
	    var multiple = [];
	    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
	        var k = _a[_i];
	        if (k.length === 1) {
	            // Add value to single array
	            single.push("\\" + k);
	        }
	        else {
	            // Add value to multiple array
	            multiple.push(k);
	        }
	    }
	    // Add ranges to single characters.
	    single.sort();
	    for (var start = 0; start < single.length - 1; start++) {
	        // Find the end of a run of characters
	        var end = start;
	        while (end < single.length - 1 &&
	            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
	            end += 1;
	        }
	        var count = 1 + end - start;
	        // We want to replace at least three characters
	        if (count < 3)
	            continue;
	        single.splice(start, count, single[start] + "-" + single[end]);
	    }
	    multiple.unshift("[" + single.join("") + "]");
	    return new RegExp(multiple.join("|"), "g");
	}
	var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
	function singleCharReplacer(c) {
	    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	    return "&#x" + c.codePointAt(0).toString(16).toUpperCase() + ";";
	}
	function getInverse(inverse, re) {
	    return function (data) {
	        return data
	            .replace(re, function (name) { return inverse[name]; })
	            .replace(reNonASCII, singleCharReplacer);
	    };
	}
	var reXmlChars = getInverseReplacer(inverseXML);
	function escape(data) {
	    return data
	        .replace(reXmlChars, singleCharReplacer)
	        .replace(reNonASCII, singleCharReplacer);
	}
	exports.escape = escape;


/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	function alwaysValid() {
	  return true;
	}
	
	module.exports = {
	  alwaysValid: alwaysValid,
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(37);
	
	// eslint-disable-next-line max-len
	// https://github.com/facebook/react/blob/15.0-stable/src/renderers/dom/shared/ReactDOMComponent.js#L457
	var voidElementTags = [
	  'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param',
	  'source', 'track', 'wbr', 'menuitem', 'textarea',
	];
	
	function ProcessNodeDefinitions() {
	  function processDefaultNode(node, children, index) {
	    if (node.type === 'text') {
	      return node.data;
	    } else if (node.type === 'comment') {
	      // FIXME: The following doesn't work as the generated HTML results in
	      // "&lt;!--  This is a comment  --&gt;"
	      // return '<!-- ' + node.data + ' -->';
	      return false;
	    }
	
	    if (voidElementTags.indexOf(node.name) > -1) {
	      return utils.createElement(node, index);
	    } else {
	      return utils.createElement(node, index, node.data, children);
	    }
	  }
	
	  return {
	    processDefaultNode: processDefaultNode,
	  };
	}
	
	module.exports = ProcessNodeDefinitions;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ShouldProcessNodeDefinitions = __webpack_require__(74);
	var ProcessNodeDefinitions = __webpack_require__(35);
	
	function ProcessingInstructions() {
	  var processNodeDefinitions = new ProcessNodeDefinitions();
	
	  return {
	    defaultProcessingInstructions: [{
	      shouldProcessNode: ShouldProcessNodeDefinitions.shouldProcessEveryNode,
	      processNode: processNodeDefinitions.processDefaultNode,
	    },],
	  };
	};
	
	module.exports = ProcessingInstructions;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var camelCase = __webpack_require__(89);
	var toPairs = __webpack_require__(130);
	var reduce = __webpack_require__(128);
	var React = __webpack_require__(5);
	var includes = __webpack_require__(102);
	var camelCaseAttrMap = __webpack_require__(72);
	
	function createStyleJsonFromString(styleString) {
	  styleString = styleString || '';
	  var styles = styleString.split(/;(?!base64)/);
	  var singleStyle, key, value, jsonStyles = {};
	  for (var i = 0; i < styles.length; ++i) {
	    singleStyle = styles[i].split(':');
	    if (singleStyle.length > 2) {
	      singleStyle[1] = singleStyle.slice(1).join(':');
	    }
	
	    key = singleStyle[0];
	    value = singleStyle[1];
	    if (typeof value === 'string'){
	      value = value.trim();
	    }
	
	    if (key != null && value != null && key.length > 0 && value.length > 0) {
	      jsonStyles[camelCase(key)] = value;
	    }
	  }
	  return jsonStyles;
	}
	
	// Boolean HTML attributes, copied from https://meiert.com/en/blog/boolean-attributes-of-html/
	var booleanAttrs = [
	  'allowfullscreen',
	  'allowpaymentrequest',
	  'async',
	  'autofocus',
	  'autoplay',
	  'checked',
	  'controls',
	  'default',
	  'disabled',
	  'formnovalidate',
	  'hidden',
	  'ismap',
	  'itemscope',
	  'loop',
	  'multiple',
	  'muted',
	  'nomodule',
	  'novalidate',
	  'open',
	  'playsinline',
	  'readonly',
	  'required',
	  'reversed',
	  'selected',
	  'truespeed',
	];
	
	function createElement(node, index, data, children) {
	  var elementProps = {
	    key: index,
	  };
	  if (node.attribs) {
	    elementProps = reduce(function(result, keyAndValue) {
	      var key = keyAndValue[0];
	      var value = keyAndValue[1];
	      key = camelCaseAttrMap[key.replace(/[-:]/, '')] || key;
	      if (key === 'style') {
	        value = createStyleJsonFromString(value);
	      } else if (key === 'class') {
	        key = 'className';
	      } else if (key === 'for') {
	        key = 'htmlFor';
	      }
	
	      if (includes(key, booleanAttrs) && (value || '') === '') {
	        value = key;
	      }
	
	      result[key] = value;
	      return result;
	    }, elementProps, toPairs(node.attribs));
	  }
	
	  children = children || [];
	  var allChildren = data != null ? [data,].concat(children) : children;
	  return React.createElement.apply(
	    null, [node.name, elementProps,].concat(allChildren)
	  );
	}
	
	module.exports = {
	  createElement: createElement,
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    result["default"] = mod;
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var domhandler_1 = __importDefault(__webpack_require__(13));
	var DomUtils = __importStar(__webpack_require__(29));
	var Parser_1 = __webpack_require__(39);
	//TODO: Consume data as it is coming in
	var FeedHandler = /** @class */ (function (_super) {
	    __extends(FeedHandler, _super);
	    /**
	     *
	     * @param callback
	     * @param options
	     */
	    function FeedHandler(callback, options) {
	        var _this = this;
	        if (typeof callback === "object" && callback !== null) {
	            callback = undefined;
	            options = callback;
	        }
	        _this = _super.call(this, callback, options) || this;
	        return _this;
	    }
	    FeedHandler.prototype.onend = function () {
	        var feed = {};
	        var feedRoot = getOneElement(isValidFeed, this.dom);
	        if (feedRoot) {
	            if (feedRoot.name === "feed") {
	                var childs = feedRoot.children;
	                feed.type = "atom";
	                addConditionally(feed, "id", "id", childs);
	                addConditionally(feed, "title", "title", childs);
	                var href = getAttribute("href", getOneElement("link", childs));
	                if (href) {
	                    feed.link = href;
	                }
	                addConditionally(feed, "description", "subtitle", childs);
	                var updated = fetch("updated", childs);
	                if (updated) {
	                    feed.updated = new Date(updated);
	                }
	                addConditionally(feed, "author", "email", childs, true);
	                feed.items = getElements("entry", childs).map(function (item) {
	                    var entry = {};
	                    var children = item.children;
	                    addConditionally(entry, "id", "id", children);
	                    addConditionally(entry, "title", "title", children);
	                    var href = getAttribute("href", getOneElement("link", children));
	                    if (href) {
	                        entry.link = href;
	                    }
	                    var description = fetch("summary", children) ||
	                        fetch("content", children);
	                    if (description) {
	                        entry.description = description;
	                    }
	                    var pubDate = fetch("updated", children);
	                    if (pubDate) {
	                        entry.pubDate = new Date(pubDate);
	                    }
	                    return entry;
	                });
	            }
	            else {
	                var childs = getOneElement("channel", feedRoot.children)
	                    .children;
	                feed.type = feedRoot.name.substr(0, 3);
	                feed.id = "";
	                addConditionally(feed, "title", "title", childs);
	                addConditionally(feed, "link", "link", childs);
	                addConditionally(feed, "description", "description", childs);
	                var updated = fetch("lastBuildDate", childs);
	                if (updated) {
	                    feed.updated = new Date(updated);
	                }
	                addConditionally(feed, "author", "managingEditor", childs, true);
	                feed.items = getElements("item", feedRoot.children).map(function (item) {
	                    var entry = {};
	                    var children = item.children;
	                    addConditionally(entry, "id", "guid", children);
	                    addConditionally(entry, "title", "title", children);
	                    addConditionally(entry, "link", "link", children);
	                    addConditionally(entry, "description", "description", children);
	                    var pubDate = fetch("pubDate", children);
	                    if (pubDate)
	                        entry.pubDate = new Date(pubDate);
	                    return entry;
	                });
	            }
	        }
	        this.feed = feed;
	        this.handleCallback(feedRoot ? null : Error("couldn't find root of feed"));
	    };
	    return FeedHandler;
	}(domhandler_1.default));
	exports.FeedHandler = FeedHandler;
	function getElements(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse) {
	    if (recurse === void 0) { recurse = false; }
	    return DomUtils.getText(DomUtils.getElementsByTagName(what, where, recurse, 1)).trim();
	}
	function getAttribute(name, elem) {
	    if (!elem) {
	        return null;
	    }
	    var attribs = elem.attribs;
	    return attribs[name];
	}
	function addConditionally(obj, prop, what, where, recurse) {
	    if (recurse === void 0) { recurse = false; }
	    var tmp = fetch(what, where, recurse);
	    // @ts-ignore
	    if (tmp)
	        obj[prop] = tmp;
	}
	function isValidFeed(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	}
	var defaultOptions = { xmlMode: true };
	/**
	 * Parse a feed.
	 *
	 * @param feed The feed that should be parsed, as a string.
	 * @param options Optionally, options for parsing. When using this option, you probably want to set `xmlMode` to `true`.
	 */
	function parseFeed(feed, options) {
	    if (options === void 0) { options = defaultOptions; }
	    var handler = new FeedHandler(options);
	    new Parser_1.Parser(handler, options).end(feed);
	    return handler.feed;
	}
	exports.parseFeed = parseFeed;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Tokenizer_1 = __importDefault(__webpack_require__(40));
	var events_1 = __webpack_require__(65);
	var formTags = new Set([
	    "input",
	    "option",
	    "optgroup",
	    "select",
	    "button",
	    "datalist",
	    "textarea"
	]);
	var pTag = new Set(["p"]);
	var openImpliesClose = {
	    tr: new Set(["tr", "th", "td"]),
	    th: new Set(["th"]),
	    td: new Set(["thead", "th", "td"]),
	    body: new Set(["head", "link", "script"]),
	    li: new Set(["li"]),
	    p: pTag,
	    h1: pTag,
	    h2: pTag,
	    h3: pTag,
	    h4: pTag,
	    h5: pTag,
	    h6: pTag,
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: new Set(["option"]),
	    optgroup: new Set(["optgroup", "option"]),
	    dd: new Set(["dt", "dd"]),
	    dt: new Set(["dt", "dd"]),
	    address: pTag,
	    article: pTag,
	    aside: pTag,
	    blockquote: pTag,
	    details: pTag,
	    div: pTag,
	    dl: pTag,
	    fieldset: pTag,
	    figcaption: pTag,
	    figure: pTag,
	    footer: pTag,
	    form: pTag,
	    header: pTag,
	    hr: pTag,
	    main: pTag,
	    nav: pTag,
	    ol: pTag,
	    pre: pTag,
	    section: pTag,
	    table: pTag,
	    ul: pTag,
	    rt: new Set(["rt", "rp"]),
	    rp: new Set(["rt", "rp"]),
	    tbody: new Set(["thead", "tbody"]),
	    tfoot: new Set(["thead", "tbody"])
	};
	var voidElements = new Set([
	    "area",
	    "base",
	    "basefont",
	    "br",
	    "col",
	    "command",
	    "embed",
	    "frame",
	    "hr",
	    "img",
	    "input",
	    "isindex",
	    "keygen",
	    "link",
	    "meta",
	    "param",
	    "source",
	    "track",
	    "wbr"
	]);
	var foreignContextElements = new Set(["math", "svg"]);
	var htmlIntegrationElements = new Set([
	    "mi",
	    "mo",
	    "mn",
	    "ms",
	    "mtext",
	    "annotation-xml",
	    "foreignObject",
	    "desc",
	    "title"
	]);
	var reNameEnd = /\s|\//;
	var Parser = /** @class */ (function (_super) {
	    __extends(Parser, _super);
	    function Parser(cbs, options) {
	        var _this = _super.call(this) || this;
	        _this._tagname = "";
	        _this._attribname = "";
	        _this._attribvalue = "";
	        _this._attribs = null;
	        _this._stack = [];
	        _this._foreignContext = [];
	        _this.startIndex = 0;
	        _this.endIndex = null;
	        // Aliases for backwards compatibility
	        _this.parseChunk = Parser.prototype.write;
	        _this.done = Parser.prototype.end;
	        _this._options = options || {};
	        _this._cbs = cbs || {};
	        _this._tagname = "";
	        _this._attribname = "";
	        _this._attribvalue = "";
	        _this._attribs = null;
	        _this._stack = [];
	        _this._foreignContext = [];
	        _this.startIndex = 0;
	        _this.endIndex = null;
	        _this._lowerCaseTagNames =
	            "lowerCaseTags" in _this._options
	                ? !!_this._options.lowerCaseTags
	                : !_this._options.xmlMode;
	        _this._lowerCaseAttributeNames =
	            "lowerCaseAttributeNames" in _this._options
	                ? !!_this._options.lowerCaseAttributeNames
	                : !_this._options.xmlMode;
	        _this._tokenizer = new (_this._options.Tokenizer || Tokenizer_1.default)(_this._options, _this);
	        if (_this._cbs.onparserinit)
	            _this._cbs.onparserinit(_this);
	        return _this;
	    }
	    Parser.prototype._updatePosition = function (initialOffset) {
	        if (this.endIndex === null) {
	            if (this._tokenizer._sectionStart <= initialOffset) {
	                this.startIndex = 0;
	            }
	            else {
	                this.startIndex = this._tokenizer._sectionStart - initialOffset;
	            }
	        }
	        else
	            this.startIndex = this.endIndex + 1;
	        this.endIndex = this._tokenizer.getAbsoluteIndex();
	    };
	    //Tokenizer event handlers
	    Parser.prototype.ontext = function (data) {
	        this._updatePosition(1);
	        // @ts-ignore
	        this.endIndex--;
	        if (this._cbs.ontext)
	            this._cbs.ontext(data);
	    };
	    Parser.prototype.onopentagname = function (name) {
	        if (this._lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        this._tagname = name;
	        if (!this._options.xmlMode &&
	            Object.prototype.hasOwnProperty.call(openImpliesClose, name)) {
	            for (var el = void 0; 
	            // @ts-ignore
	            openImpliesClose[name].has((el = this._stack[this._stack.length - 1])); this.onclosetag(el))
	                ;
	        }
	        if (this._options.xmlMode || !voidElements.has(name)) {
	            this._stack.push(name);
	            if (foreignContextElements.has(name)) {
	                this._foreignContext.push(true);
	            }
	            else if (htmlIntegrationElements.has(name)) {
	                this._foreignContext.push(false);
	            }
	        }
	        if (this._cbs.onopentagname)
	            this._cbs.onopentagname(name);
	        if (this._cbs.onopentag)
	            this._attribs = {};
	    };
	    Parser.prototype.onopentagend = function () {
	        this._updatePosition(1);
	        if (this._attribs) {
	            if (this._cbs.onopentag) {
	                this._cbs.onopentag(this._tagname, this._attribs);
	            }
	            this._attribs = null;
	        }
	        if (!this._options.xmlMode &&
	            this._cbs.onclosetag &&
	            voidElements.has(this._tagname)) {
	            this._cbs.onclosetag(this._tagname);
	        }
	        this._tagname = "";
	    };
	    Parser.prototype.onclosetag = function (name) {
	        this._updatePosition(1);
	        if (this._lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        if (foreignContextElements.has(name) ||
	            htmlIntegrationElements.has(name)) {
	            this._foreignContext.pop();
	        }
	        if (this._stack.length &&
	            (this._options.xmlMode || !voidElements.has(name))) {
	            var pos = this._stack.lastIndexOf(name);
	            if (pos !== -1) {
	                if (this._cbs.onclosetag) {
	                    pos = this._stack.length - pos;
	                    // @ts-ignore
	                    while (pos--)
	                        this._cbs.onclosetag(this._stack.pop());
	                }
	                else
	                    this._stack.length = pos;
	            }
	            else if (name === "p" && !this._options.xmlMode) {
	                this.onopentagname(name);
	                this._closeCurrentTag();
	            }
	        }
	        else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    };
	    Parser.prototype.onselfclosingtag = function () {
	        if (this._options.xmlMode ||
	            this._options.recognizeSelfClosing ||
	            this._foreignContext[this._foreignContext.length - 1]) {
	            this._closeCurrentTag();
	        }
	        else {
	            this.onopentagend();
	        }
	    };
	    Parser.prototype._closeCurrentTag = function () {
	        var name = this._tagname;
	        this.onopentagend();
	        //self-closing tags will be on the top of the stack
	        //(cheaper check than in onclosetag)
	        if (this._stack[this._stack.length - 1] === name) {
	            if (this._cbs.onclosetag) {
	                this._cbs.onclosetag(name);
	            }
	            this._stack.pop();
	        }
	    };
	    Parser.prototype.onattribname = function (name) {
	        if (this._lowerCaseAttributeNames) {
	            name = name.toLowerCase();
	        }
	        this._attribname = name;
	    };
	    Parser.prototype.onattribdata = function (value) {
	        this._attribvalue += value;
	    };
	    Parser.prototype.onattribend = function () {
	        if (this._cbs.onattribute)
	            this._cbs.onattribute(this._attribname, this._attribvalue);
	        if (this._attribs &&
	            !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)) {
	            this._attribs[this._attribname] = this._attribvalue;
	        }
	        this._attribname = "";
	        this._attribvalue = "";
	    };
	    Parser.prototype._getInstructionName = function (value) {
	        var idx = value.search(reNameEnd);
	        var name = idx < 0 ? value : value.substr(0, idx);
	        if (this._lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        return name;
	    };
	    Parser.prototype.ondeclaration = function (value) {
	        if (this._cbs.onprocessinginstruction) {
	            var name_1 = this._getInstructionName(value);
	            this._cbs.onprocessinginstruction("!" + name_1, "!" + value);
	        }
	    };
	    Parser.prototype.onprocessinginstruction = function (value) {
	        if (this._cbs.onprocessinginstruction) {
	            var name_2 = this._getInstructionName(value);
	            this._cbs.onprocessinginstruction("?" + name_2, "?" + value);
	        }
	    };
	    Parser.prototype.oncomment = function (value) {
	        this._updatePosition(4);
	        if (this._cbs.oncomment)
	            this._cbs.oncomment(value);
	        if (this._cbs.oncommentend)
	            this._cbs.oncommentend();
	    };
	    Parser.prototype.oncdata = function (value) {
	        this._updatePosition(1);
	        if (this._options.xmlMode || this._options.recognizeCDATA) {
	            if (this._cbs.oncdatastart)
	                this._cbs.oncdatastart();
	            if (this._cbs.ontext)
	                this._cbs.ontext(value);
	            if (this._cbs.oncdataend)
	                this._cbs.oncdataend();
	        }
	        else {
	            this.oncomment("[CDATA[" + value + "]]");
	        }
	    };
	    Parser.prototype.onerror = function (err) {
	        if (this._cbs.onerror)
	            this._cbs.onerror(err);
	    };
	    Parser.prototype.onend = function () {
	        if (this._cbs.onclosetag) {
	            for (var i = this._stack.length; i > 0; this._cbs.onclosetag(this._stack[--i]))
	                ;
	        }
	        if (this._cbs.onend)
	            this._cbs.onend();
	    };
	    //Resets the parser to a blank state, ready to parse a new HTML document
	    Parser.prototype.reset = function () {
	        if (this._cbs.onreset)
	            this._cbs.onreset();
	        this._tokenizer.reset();
	        this._tagname = "";
	        this._attribname = "";
	        this._attribs = null;
	        this._stack = [];
	        if (this._cbs.onparserinit)
	            this._cbs.onparserinit(this);
	    };
	    //Parses a complete HTML document and pushes it to the handler
	    Parser.prototype.parseComplete = function (data) {
	        this.reset();
	        this.end(data);
	    };
	    Parser.prototype.write = function (chunk) {
	        this._tokenizer.write(chunk);
	    };
	    Parser.prototype.end = function (chunk) {
	        this._tokenizer.end(chunk);
	    };
	    Parser.prototype.pause = function () {
	        this._tokenizer.pause();
	    };
	    Parser.prototype.resume = function () {
	        this._tokenizer.resume();
	    };
	    return Parser;
	}(events_1.EventEmitter));
	exports.Parser = Parser;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decode_codepoint_1 = __importDefault(__webpack_require__(32));
	var entities_json_1 = __importDefault(__webpack_require__(14));
	var legacy_json_1 = __importDefault(__webpack_require__(42));
	var xml_json_1 = __importDefault(__webpack_require__(15));
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	    if (upper === lower) {
	        return function (t, c) {
	            if (c === lower) {
	                t._state = SUCCESS;
	            }
	            else {
	                t._state = FAILURE;
	                t._index--;
	            }
	        };
	    }
	    else {
	        return function (t, c) {
	            if (c === lower || c === upper) {
	                t._state = SUCCESS;
	            }
	            else {
	                t._state = FAILURE;
	                t._index--;
	            }
	        };
	    }
	}
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	    return function (t, c) {
	        if (c === lower || c === upper) {
	            t._state = NEXT_STATE;
	        }
	        else {
	            t._state = 3 /* InTagName */;
	            t._index--; //consume the token again
	        }
	    };
	}
	var stateBeforeCdata1 = ifElseState("C", 23 /* BeforeCdata2 */, 16 /* InDeclaration */);
	var stateBeforeCdata2 = ifElseState("D", 24 /* BeforeCdata3 */, 16 /* InDeclaration */);
	var stateBeforeCdata3 = ifElseState("A", 25 /* BeforeCdata4 */, 16 /* InDeclaration */);
	var stateBeforeCdata4 = ifElseState("T", 26 /* BeforeCdata5 */, 16 /* InDeclaration */);
	var stateBeforeCdata5 = ifElseState("A", 27 /* BeforeCdata6 */, 16 /* InDeclaration */);
	var stateBeforeScript1 = consumeSpecialNameChar("R", 34 /* BeforeScript2 */);
	var stateBeforeScript2 = consumeSpecialNameChar("I", 35 /* BeforeScript3 */);
	var stateBeforeScript3 = consumeSpecialNameChar("P", 36 /* BeforeScript4 */);
	var stateBeforeScript4 = consumeSpecialNameChar("T", 37 /* BeforeScript5 */);
	var stateAfterScript1 = ifElseState("R", 39 /* AfterScript2 */, 1 /* Text */);
	var stateAfterScript2 = ifElseState("I", 40 /* AfterScript3 */, 1 /* Text */);
	var stateAfterScript3 = ifElseState("P", 41 /* AfterScript4 */, 1 /* Text */);
	var stateAfterScript4 = ifElseState("T", 42 /* AfterScript5 */, 1 /* Text */);
	var stateBeforeStyle1 = consumeSpecialNameChar("Y", 44 /* BeforeStyle2 */);
	var stateBeforeStyle2 = consumeSpecialNameChar("L", 45 /* BeforeStyle3 */);
	var stateBeforeStyle3 = consumeSpecialNameChar("E", 46 /* BeforeStyle4 */);
	var stateAfterStyle1 = ifElseState("Y", 48 /* AfterStyle2 */, 1 /* Text */);
	var stateAfterStyle2 = ifElseState("L", 49 /* AfterStyle3 */, 1 /* Text */);
	var stateAfterStyle3 = ifElseState("E", 50 /* AfterStyle4 */, 1 /* Text */);
	var stateBeforeEntity = ifElseState("#", 52 /* BeforeNumericEntity */, 53 /* InNamedEntity */);
	var stateBeforeNumericEntity = ifElseState("X", 55 /* InHexEntity */, 54 /* InNumericEntity */);
	var Tokenizer = /** @class */ (function () {
	    function Tokenizer(options, cbs) {
	        /** The current state the tokenizer is in. */
	        this._state = 1 /* Text */;
	        /** The read buffer. */
	        this._buffer = "";
	        /** The beginning of the section that is currently being read. */
	        this._sectionStart = 0;
	        /** The index within the buffer that we are currently looking at. */
	        this._index = 0;
	        /**
	         * Data that has already been processed will be removed from the buffer occasionally.
	         * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
	         */
	        this._bufferOffset = 0;
	        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
	        this._baseState = 1 /* Text */;
	        /** For special parsing behavior inside of script and style tags. */
	        this._special = 1 /* None */;
	        /** Indicates whether the tokenizer has been paused. */
	        this._running = true;
	        /** Indicates whether the tokenizer has finished running / `.end` has been called. */
	        this._ended = false;
	        this._cbs = cbs;
	        this._xmlMode = !!(options && options.xmlMode);
	        this._decodeEntities = !!(options && options.decodeEntities);
	    }
	    Tokenizer.prototype.reset = function () {
	        this._state = 1 /* Text */;
	        this._buffer = "";
	        this._sectionStart = 0;
	        this._index = 0;
	        this._bufferOffset = 0;
	        this._baseState = 1 /* Text */;
	        this._special = 1 /* None */;
	        this._running = true;
	        this._ended = false;
	    };
	    Tokenizer.prototype._stateText = function (c) {
	        if (c === "<") {
	            if (this._index > this._sectionStart) {
	                this._cbs.ontext(this._getSection());
	            }
	            this._state = 2 /* BeforeTagName */;
	            this._sectionStart = this._index;
	        }
	        else if (this._decodeEntities &&
	            this._special === 1 /* None */ &&
	            c === "&") {
	            if (this._index > this._sectionStart) {
	                this._cbs.ontext(this._getSection());
	            }
	            this._baseState = 1 /* Text */;
	            this._state = 51 /* BeforeEntity */;
	            this._sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype._stateBeforeTagName = function (c) {
	        if (c === "/") {
	            this._state = 5 /* BeforeClosingTagName */;
	        }
	        else if (c === "<") {
	            this._cbs.ontext(this._getSection());
	            this._sectionStart = this._index;
	        }
	        else if (c === ">" ||
	            this._special !== 1 /* None */ ||
	            whitespace(c)) {
	            this._state = 1 /* Text */;
	        }
	        else if (c === "!") {
	            this._state = 15 /* BeforeDeclaration */;
	            this._sectionStart = this._index + 1;
	        }
	        else if (c === "?") {
	            this._state = 17 /* InProcessingInstruction */;
	            this._sectionStart = this._index + 1;
	        }
	        else {
	            this._state =
	                !this._xmlMode && (c === "s" || c === "S")
	                    ? 31 /* BeforeSpecial */
	                    : 3 /* InTagName */;
	            this._sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype._stateInTagName = function (c) {
	        if (c === "/" || c === ">" || whitespace(c)) {
	            this._emitToken("onopentagname");
	            this._state = 8 /* BeforeAttributeName */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype._stateBeforeClosingTagName = function (c) {
	        if (whitespace(c)) {
	            // ignore
	        }
	        else if (c === ">") {
	            this._state = 1 /* Text */;
	        }
	        else if (this._special !== 1 /* None */) {
	            if (c === "s" || c === "S") {
	                this._state = 32 /* BeforeSpecialEnd */;
	            }
	            else {
	                this._state = 1 /* Text */;
	                this._index--;
	            }
	        }
	        else {
	            this._state = 6 /* InClosingTagName */;
	            this._sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype._stateInClosingTagName = function (c) {
	        if (c === ">" || whitespace(c)) {
	            this._emitToken("onclosetag");
	            this._state = 7 /* AfterClosingTagName */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype._stateAfterClosingTagName = function (c) {
	        //skip everything until ">"
	        if (c === ">") {
	            this._state = 1 /* Text */;
	            this._sectionStart = this._index + 1;
	        }
	    };
	    Tokenizer.prototype._stateBeforeAttributeName = function (c) {
	        if (c === ">") {
	            this._cbs.onopentagend();
	            this._state = 1 /* Text */;
	            this._sectionStart = this._index + 1;
	        }
	        else if (c === "/") {
	            this._state = 4 /* InSelfClosingTag */;
	        }
	        else if (!whitespace(c)) {
	            this._state = 9 /* InAttributeName */;
	            this._sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype._stateInSelfClosingTag = function (c) {
	        if (c === ">") {
	            this._cbs.onselfclosingtag();
	            this._state = 1 /* Text */;
	            this._sectionStart = this._index + 1;
	        }
	        else if (!whitespace(c)) {
	            this._state = 8 /* BeforeAttributeName */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype._stateInAttributeName = function (c) {
	        if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	            this._cbs.onattribname(this._getSection());
	            this._sectionStart = -1;
	            this._state = 10 /* AfterAttributeName */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype._stateAfterAttributeName = function (c) {
	        if (c === "=") {
	            this._state = 11 /* BeforeAttributeValue */;
	        }
	        else if (c === "/" || c === ">") {
	            this._cbs.onattribend();
	            this._state = 8 /* BeforeAttributeName */;
	            this._index--;
	        }
	        else if (!whitespace(c)) {
	            this._cbs.onattribend();
	            this._state = 9 /* InAttributeName */;
	            this._sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype._stateBeforeAttributeValue = function (c) {
	        if (c === '"') {
	            this._state = 12 /* InAttributeValueDq */;
	            this._sectionStart = this._index + 1;
	        }
	        else if (c === "'") {
	            this._state = 13 /* InAttributeValueSq */;
	            this._sectionStart = this._index + 1;
	        }
	        else if (!whitespace(c)) {
	            this._state = 14 /* InAttributeValueNq */;
	            this._sectionStart = this._index;
	            this._index--; //reconsume token
	        }
	    };
	    Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function (c) {
	        if (c === '"') {
	            this._emitToken("onattribdata");
	            this._cbs.onattribend();
	            this._state = 8 /* BeforeAttributeName */;
	        }
	        else if (this._decodeEntities && c === "&") {
	            this._emitToken("onattribdata");
	            this._baseState = this._state;
	            this._state = 51 /* BeforeEntity */;
	            this._sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype._stateInAttributeValueSingleQuotes = function (c) {
	        if (c === "'") {
	            this._emitToken("onattribdata");
	            this._cbs.onattribend();
	            this._state = 8 /* BeforeAttributeName */;
	        }
	        else if (this._decodeEntities && c === "&") {
	            this._emitToken("onattribdata");
	            this._baseState = this._state;
	            this._state = 51 /* BeforeEntity */;
	            this._sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype._stateInAttributeValueNoQuotes = function (c) {
	        if (whitespace(c) || c === ">") {
	            this._emitToken("onattribdata");
	            this._cbs.onattribend();
	            this._state = 8 /* BeforeAttributeName */;
	            this._index--;
	        }
	        else if (this._decodeEntities && c === "&") {
	            this._emitToken("onattribdata");
	            this._baseState = this._state;
	            this._state = 51 /* BeforeEntity */;
	            this._sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype._stateBeforeDeclaration = function (c) {
	        this._state =
	            c === "["
	                ? 22 /* BeforeCdata1 */
	                : c === "-"
	                    ? 18 /* BeforeComment */
	                    : 16 /* InDeclaration */;
	    };
	    Tokenizer.prototype._stateInDeclaration = function (c) {
	        if (c === ">") {
	            this._cbs.ondeclaration(this._getSection());
	            this._state = 1 /* Text */;
	            this._sectionStart = this._index + 1;
	        }
	    };
	    Tokenizer.prototype._stateInProcessingInstruction = function (c) {
	        if (c === ">") {
	            this._cbs.onprocessinginstruction(this._getSection());
	            this._state = 1 /* Text */;
	            this._sectionStart = this._index + 1;
	        }
	    };
	    Tokenizer.prototype._stateBeforeComment = function (c) {
	        if (c === "-") {
	            this._state = 19 /* InComment */;
	            this._sectionStart = this._index + 1;
	        }
	        else {
	            this._state = 16 /* InDeclaration */;
	        }
	    };
	    Tokenizer.prototype._stateInComment = function (c) {
	        if (c === "-")
	            this._state = 20 /* AfterComment1 */;
	    };
	    Tokenizer.prototype._stateAfterComment1 = function (c) {
	        if (c === "-") {
	            this._state = 21 /* AfterComment2 */;
	        }
	        else {
	            this._state = 19 /* InComment */;
	        }
	    };
	    Tokenizer.prototype._stateAfterComment2 = function (c) {
	        if (c === ">") {
	            //remove 2 trailing chars
	            this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
	            this._state = 1 /* Text */;
	            this._sectionStart = this._index + 1;
	        }
	        else if (c !== "-") {
	            this._state = 19 /* InComment */;
	        }
	        // else: stay in AFTER_COMMENT_2 (`--->`)
	    };
	    Tokenizer.prototype._stateBeforeCdata6 = function (c) {
	        if (c === "[") {
	            this._state = 28 /* InCdata */;
	            this._sectionStart = this._index + 1;
	        }
	        else {
	            this._state = 16 /* InDeclaration */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype._stateInCdata = function (c) {
	        if (c === "]")
	            this._state = 29 /* AfterCdata1 */;
	    };
	    Tokenizer.prototype._stateAfterCdata1 = function (c) {
	        if (c === "]")
	            this._state = 30 /* AfterCdata2 */;
	        else
	            this._state = 28 /* InCdata */;
	    };
	    Tokenizer.prototype._stateAfterCdata2 = function (c) {
	        if (c === ">") {
	            //remove 2 trailing chars
	            this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
	            this._state = 1 /* Text */;
	            this._sectionStart = this._index + 1;
	        }
	        else if (c !== "]") {
	            this._state = 28 /* InCdata */;
	        }
	        //else: stay in AFTER_CDATA_2 (`]]]>`)
	    };
	    Tokenizer.prototype._stateBeforeSpecial = function (c) {
	        if (c === "c" || c === "C") {
	            this._state = 33 /* BeforeScript1 */;
	        }
	        else if (c === "t" || c === "T") {
	            this._state = 43 /* BeforeStyle1 */;
	        }
	        else {
	            this._state = 3 /* InTagName */;
	            this._index--; //consume the token again
	        }
	    };
	    Tokenizer.prototype._stateBeforeSpecialEnd = function (c) {
	        if (this._special === 2 /* Script */ && (c === "c" || c === "C")) {
	            this._state = 38 /* AfterScript1 */;
	        }
	        else if (this._special === 3 /* Style */ &&
	            (c === "t" || c === "T")) {
	            this._state = 47 /* AfterStyle1 */;
	        }
	        else
	            this._state = 1 /* Text */;
	    };
	    Tokenizer.prototype._stateBeforeScript5 = function (c) {
	        if (c === "/" || c === ">" || whitespace(c)) {
	            this._special = 2 /* Script */;
	        }
	        this._state = 3 /* InTagName */;
	        this._index--; //consume the token again
	    };
	    Tokenizer.prototype._stateAfterScript5 = function (c) {
	        if (c === ">" || whitespace(c)) {
	            this._special = 1 /* None */;
	            this._state = 6 /* InClosingTagName */;
	            this._sectionStart = this._index - 6;
	            this._index--; //reconsume the token
	        }
	        else
	            this._state = 1 /* Text */;
	    };
	    Tokenizer.prototype._stateBeforeStyle4 = function (c) {
	        if (c === "/" || c === ">" || whitespace(c)) {
	            this._special = 3 /* Style */;
	        }
	        this._state = 3 /* InTagName */;
	        this._index--; //consume the token again
	    };
	    Tokenizer.prototype._stateAfterStyle4 = function (c) {
	        if (c === ">" || whitespace(c)) {
	            this._special = 1 /* None */;
	            this._state = 6 /* InClosingTagName */;
	            this._sectionStart = this._index - 5;
	            this._index--; //reconsume the token
	        }
	        else
	            this._state = 1 /* Text */;
	    };
	    //for entities terminated with a semicolon
	    Tokenizer.prototype._parseNamedEntityStrict = function () {
	        //offset = 1
	        if (this._sectionStart + 1 < this._index) {
	            var entity = this._buffer.substring(this._sectionStart + 1, this._index), map = this._xmlMode ? xml_json_1.default : entities_json_1.default;
	            if (Object.prototype.hasOwnProperty.call(map, entity)) {
	                // @ts-ignore
	                this._emitPartial(map[entity]);
	                this._sectionStart = this._index + 1;
	            }
	        }
	    };
	    //parses legacy entities (without trailing semicolon)
	    Tokenizer.prototype._parseLegacyEntity = function () {
	        var start = this._sectionStart + 1;
	        var limit = this._index - start;
	        if (limit > 6)
	            limit = 6; // The max length of legacy entities is 6
	        while (limit >= 2) {
	            // The min length of legacy entities is 2
	            var entity = this._buffer.substr(start, limit);
	            if (Object.prototype.hasOwnProperty.call(legacy_json_1.default, entity)) {
	                // @ts-ignore
	                this._emitPartial(legacy_json_1.default[entity]);
	                this._sectionStart += limit + 1;
	                return;
	            }
	            else {
	                limit--;
	            }
	        }
	    };
	    Tokenizer.prototype._stateInNamedEntity = function (c) {
	        if (c === ";") {
	            this._parseNamedEntityStrict();
	            if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	                this._parseLegacyEntity();
	            }
	            this._state = this._baseState;
	        }
	        else if ((c < "a" || c > "z") &&
	            (c < "A" || c > "Z") &&
	            (c < "0" || c > "9")) {
	            if (this._xmlMode || this._sectionStart + 1 === this._index) {
	                // ignore
	            }
	            else if (this._baseState !== 1 /* Text */) {
	                if (c !== "=") {
	                    this._parseNamedEntityStrict();
	                }
	            }
	            else {
	                this._parseLegacyEntity();
	            }
	            this._state = this._baseState;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype._decodeNumericEntity = function (offset, base) {
	        var sectionStart = this._sectionStart + offset;
	        if (sectionStart !== this._index) {
	            //parse entity
	            var entity = this._buffer.substring(sectionStart, this._index);
	            var parsed = parseInt(entity, base);
	            this._emitPartial(decode_codepoint_1.default(parsed));
	            this._sectionStart = this._index;
	        }
	        else {
	            this._sectionStart--;
	        }
	        this._state = this._baseState;
	    };
	    Tokenizer.prototype._stateInNumericEntity = function (c) {
	        if (c === ";") {
	            this._decodeNumericEntity(2, 10);
	            this._sectionStart++;
	        }
	        else if (c < "0" || c > "9") {
	            if (!this._xmlMode) {
	                this._decodeNumericEntity(2, 10);
	            }
	            else {
	                this._state = this._baseState;
	            }
	            this._index--;
	        }
	    };
	    Tokenizer.prototype._stateInHexEntity = function (c) {
	        if (c === ";") {
	            this._decodeNumericEntity(3, 16);
	            this._sectionStart++;
	        }
	        else if ((c < "a" || c > "f") &&
	            (c < "A" || c > "F") &&
	            (c < "0" || c > "9")) {
	            if (!this._xmlMode) {
	                this._decodeNumericEntity(3, 16);
	            }
	            else {
	                this._state = this._baseState;
	            }
	            this._index--;
	        }
	    };
	    Tokenizer.prototype._cleanup = function () {
	        if (this._sectionStart < 0) {
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        }
	        else if (this._running) {
	            if (this._state === 1 /* Text */) {
	                if (this._sectionStart !== this._index) {
	                    this._cbs.ontext(this._buffer.substr(this._sectionStart));
	                }
	                this._buffer = "";
	                this._bufferOffset += this._index;
	                this._index = 0;
	            }
	            else if (this._sectionStart === this._index) {
	                //the section just started
	                this._buffer = "";
	                this._bufferOffset += this._index;
	                this._index = 0;
	            }
	            else {
	                //remove everything unnecessary
	                this._buffer = this._buffer.substr(this._sectionStart);
	                this._index -= this._sectionStart;
	                this._bufferOffset += this._sectionStart;
	            }
	            this._sectionStart = 0;
	        }
	    };
	    //TODO make events conditional
	    Tokenizer.prototype.write = function (chunk) {
	        if (this._ended)
	            this._cbs.onerror(Error(".write() after done!"));
	        this._buffer += chunk;
	        this._parse();
	    };
	    // Iterates through the buffer, calling the function corresponding to the current state.
	    // States that are more likely to be hit are higher up, as a performance improvement.
	    Tokenizer.prototype._parse = function () {
	        while (this._index < this._buffer.length && this._running) {
	            var c = this._buffer.charAt(this._index);
	            if (this._state === 1 /* Text */) {
	                this._stateText(c);
	            }
	            else if (this._state === 12 /* InAttributeValueDq */) {
	                this._stateInAttributeValueDoubleQuotes(c);
	            }
	            else if (this._state === 9 /* InAttributeName */) {
	                this._stateInAttributeName(c);
	            }
	            else if (this._state === 19 /* InComment */) {
	                this._stateInComment(c);
	            }
	            else if (this._state === 8 /* BeforeAttributeName */) {
	                this._stateBeforeAttributeName(c);
	            }
	            else if (this._state === 3 /* InTagName */) {
	                this._stateInTagName(c);
	            }
	            else if (this._state === 6 /* InClosingTagName */) {
	                this._stateInClosingTagName(c);
	            }
	            else if (this._state === 2 /* BeforeTagName */) {
	                this._stateBeforeTagName(c);
	            }
	            else if (this._state === 10 /* AfterAttributeName */) {
	                this._stateAfterAttributeName(c);
	            }
	            else if (this._state === 13 /* InAttributeValueSq */) {
	                this._stateInAttributeValueSingleQuotes(c);
	            }
	            else if (this._state === 11 /* BeforeAttributeValue */) {
	                this._stateBeforeAttributeValue(c);
	            }
	            else if (this._state === 5 /* BeforeClosingTagName */) {
	                this._stateBeforeClosingTagName(c);
	            }
	            else if (this._state === 7 /* AfterClosingTagName */) {
	                this._stateAfterClosingTagName(c);
	            }
	            else if (this._state === 31 /* BeforeSpecial */) {
	                this._stateBeforeSpecial(c);
	            }
	            else if (this._state === 20 /* AfterComment1 */) {
	                this._stateAfterComment1(c);
	            }
	            else if (this._state === 14 /* InAttributeValueNq */) {
	                this._stateInAttributeValueNoQuotes(c);
	            }
	            else if (this._state === 4 /* InSelfClosingTag */) {
	                this._stateInSelfClosingTag(c);
	            }
	            else if (this._state === 16 /* InDeclaration */) {
	                this._stateInDeclaration(c);
	            }
	            else if (this._state === 15 /* BeforeDeclaration */) {
	                this._stateBeforeDeclaration(c);
	            }
	            else if (this._state === 21 /* AfterComment2 */) {
	                this._stateAfterComment2(c);
	            }
	            else if (this._state === 18 /* BeforeComment */) {
	                this._stateBeforeComment(c);
	            }
	            else if (this._state === 32 /* BeforeSpecialEnd */) {
	                this._stateBeforeSpecialEnd(c);
	            }
	            else if (this._state === 38 /* AfterScript1 */) {
	                stateAfterScript1(this, c);
	            }
	            else if (this._state === 39 /* AfterScript2 */) {
	                stateAfterScript2(this, c);
	            }
	            else if (this._state === 40 /* AfterScript3 */) {
	                stateAfterScript3(this, c);
	            }
	            else if (this._state === 33 /* BeforeScript1 */) {
	                stateBeforeScript1(this, c);
	            }
	            else if (this._state === 34 /* BeforeScript2 */) {
	                stateBeforeScript2(this, c);
	            }
	            else if (this._state === 35 /* BeforeScript3 */) {
	                stateBeforeScript3(this, c);
	            }
	            else if (this._state === 36 /* BeforeScript4 */) {
	                stateBeforeScript4(this, c);
	            }
	            else if (this._state === 37 /* BeforeScript5 */) {
	                this._stateBeforeScript5(c);
	            }
	            else if (this._state === 41 /* AfterScript4 */) {
	                stateAfterScript4(this, c);
	            }
	            else if (this._state === 42 /* AfterScript5 */) {
	                this._stateAfterScript5(c);
	            }
	            else if (this._state === 43 /* BeforeStyle1 */) {
	                stateBeforeStyle1(this, c);
	            }
	            else if (this._state === 28 /* InCdata */) {
	                this._stateInCdata(c);
	            }
	            else if (this._state === 44 /* BeforeStyle2 */) {
	                stateBeforeStyle2(this, c);
	            }
	            else if (this._state === 45 /* BeforeStyle3 */) {
	                stateBeforeStyle3(this, c);
	            }
	            else if (this._state === 46 /* BeforeStyle4 */) {
	                this._stateBeforeStyle4(c);
	            }
	            else if (this._state === 47 /* AfterStyle1 */) {
	                stateAfterStyle1(this, c);
	            }
	            else if (this._state === 48 /* AfterStyle2 */) {
	                stateAfterStyle2(this, c);
	            }
	            else if (this._state === 49 /* AfterStyle3 */) {
	                stateAfterStyle3(this, c);
	            }
	            else if (this._state === 50 /* AfterStyle4 */) {
	                this._stateAfterStyle4(c);
	            }
	            else if (this._state === 17 /* InProcessingInstruction */) {
	                this._stateInProcessingInstruction(c);
	            }
	            else if (this._state === 53 /* InNamedEntity */) {
	                this._stateInNamedEntity(c);
	            }
	            else if (this._state === 22 /* BeforeCdata1 */) {
	                stateBeforeCdata1(this, c);
	            }
	            else if (this._state === 51 /* BeforeEntity */) {
	                stateBeforeEntity(this, c);
	            }
	            else if (this._state === 23 /* BeforeCdata2 */) {
	                stateBeforeCdata2(this, c);
	            }
	            else if (this._state === 24 /* BeforeCdata3 */) {
	                stateBeforeCdata3(this, c);
	            }
	            else if (this._state === 29 /* AfterCdata1 */) {
	                this._stateAfterCdata1(c);
	            }
	            else if (this._state === 30 /* AfterCdata2 */) {
	                this._stateAfterCdata2(c);
	            }
	            else if (this._state === 25 /* BeforeCdata4 */) {
	                stateBeforeCdata4(this, c);
	            }
	            else if (this._state === 26 /* BeforeCdata5 */) {
	                stateBeforeCdata5(this, c);
	            }
	            else if (this._state === 27 /* BeforeCdata6 */) {
	                this._stateBeforeCdata6(c);
	            }
	            else if (this._state === 55 /* InHexEntity */) {
	                this._stateInHexEntity(c);
	            }
	            else if (this._state === 54 /* InNumericEntity */) {
	                this._stateInNumericEntity(c);
	            }
	            else if (this._state === 52 /* BeforeNumericEntity */) {
	                stateBeforeNumericEntity(this, c);
	            }
	            else {
	                this._cbs.onerror(Error("unknown _state"), this._state);
	            }
	            this._index++;
	        }
	        this._cleanup();
	    };
	    Tokenizer.prototype.pause = function () {
	        this._running = false;
	    };
	    Tokenizer.prototype.resume = function () {
	        this._running = true;
	        if (this._index < this._buffer.length) {
	            this._parse();
	        }
	        if (this._ended) {
	            this._finish();
	        }
	    };
	    Tokenizer.prototype.end = function (chunk) {
	        if (this._ended)
	            this._cbs.onerror(Error(".end() after done!"));
	        if (chunk)
	            this.write(chunk);
	        this._ended = true;
	        if (this._running)
	            this._finish();
	    };
	    Tokenizer.prototype._finish = function () {
	        //if there is remaining data, emit it in a reasonable way
	        if (this._sectionStart < this._index) {
	            this._handleTrailingData();
	        }
	        this._cbs.onend();
	    };
	    Tokenizer.prototype._handleTrailingData = function () {
	        var data = this._buffer.substr(this._sectionStart);
	        if (this._state === 28 /* InCdata */ ||
	            this._state === 29 /* AfterCdata1 */ ||
	            this._state === 30 /* AfterCdata2 */) {
	            this._cbs.oncdata(data);
	        }
	        else if (this._state === 19 /* InComment */ ||
	            this._state === 20 /* AfterComment1 */ ||
	            this._state === 21 /* AfterComment2 */) {
	            this._cbs.oncomment(data);
	        }
	        else if (this._state === 53 /* InNamedEntity */ && !this._xmlMode) {
	            this._parseLegacyEntity();
	            if (this._sectionStart < this._index) {
	                this._state = this._baseState;
	                this._handleTrailingData();
	            }
	        }
	        else if (this._state === 54 /* InNumericEntity */ && !this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	            if (this._sectionStart < this._index) {
	                this._state = this._baseState;
	                this._handleTrailingData();
	            }
	        }
	        else if (this._state === 55 /* InHexEntity */ && !this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	            if (this._sectionStart < this._index) {
	                this._state = this._baseState;
	                this._handleTrailingData();
	            }
	        }
	        else if (this._state !== 3 /* InTagName */ &&
	            this._state !== 8 /* BeforeAttributeName */ &&
	            this._state !== 11 /* BeforeAttributeValue */ &&
	            this._state !== 10 /* AfterAttributeName */ &&
	            this._state !== 9 /* InAttributeName */ &&
	            this._state !== 13 /* InAttributeValueSq */ &&
	            this._state !== 12 /* InAttributeValueDq */ &&
	            this._state !== 14 /* InAttributeValueNq */ &&
	            this._state !== 6 /* InClosingTagName */) {
	            this._cbs.ontext(data);
	        }
	        //else, ignore remaining data
	        //TODO add a way to remove current tag
	    };
	    Tokenizer.prototype.getAbsoluteIndex = function () {
	        return this._bufferOffset + this._index;
	    };
	    Tokenizer.prototype._getSection = function () {
	        return this._buffer.substring(this._sectionStart, this._index);
	    };
	    Tokenizer.prototype._emitToken = function (name) {
	        this._cbs[name](this._getSection());
	        this._sectionStart = -1;
	    };
	    Tokenizer.prototype._emitPartial = function (value) {
	        if (this._baseState !== 1 /* Text */) {
	            this._cbs.onattribdata(value); //TODO implement the new event
	        }
	        else {
	            this._cbs.ontext(value);
	        }
	    };
	    return Tokenizer;
	}());
	exports.default = Tokenizer;


/***/ },
/* 41 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = alphabetical
	
	// Check if the given character code, or the character code at the first
	// character, is alphabetical.
	function alphabetical(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 && code <= 122) /* a-z */ ||
	    (code >= 65 && code <= 90) /* A-Z */
	  )
	}


/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var _arity =
	/*#__PURE__*/
	__webpack_require__(19);
	
	var _curry1 =
	/*#__PURE__*/
	__webpack_require__(4);
	
	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _curryN =
	/*#__PURE__*/
	__webpack_require__(108);
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      const sumArgs = (...args) => R.sum(args);
	 *
	 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      const f = curriedAddFourNumbers(1, 2);
	 *      const g = f(3);
	 *      g(4); //=> 10
	 */
	
	
	var curryN =
	/*#__PURE__*/
	_curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	
	  return _arity(length, _curryN(length, [], fn));
	});
	
	module.exports = curryN;

/***/ },
/* 45 */
/***/ function(module, exports) {

	"use strict";
	
	var HtmlParser = '__RMD_HTML_PARSER__';
	exports.HtmlParser = typeof Symbol === 'undefined' ? HtmlParser : Symbol(HtmlParser);

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(52);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  position: true,
	  gfm: true,
	  commonmark: false,
	  footnotes: false,
	  pedantic: false,
	  blocks: __webpack_require__(88)
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var link = value.indexOf('[', fromIndex);
	  var image = value.indexOf('![', fromIndex);
	
	  if (image === -1) {
	    return link;
	  }
	
	  /* Link can never be `-1` if an image is found, so we don’t need
	   * to check for that :) */
	  return link < image ? link : image;
	}


/***/ },
/* 49 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('<', fromIndex);
	}


/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = indentation;
	
	/* Map of characters, and their column length,
	 * which can be used as indentation. */
	var characters = {' ': 1, '\t': 4};
	
	/* Gets indentation information for a line. */
	function indentation(value) {
	  var index = 0;
	  var indent = 0;
	  var character = value.charAt(index);
	  var stops = {};
	  var size;
	
	  while (character in characters) {
	    size = characters[character];
	
	    indent += size;
	
	    if (size > 1) {
	      indent = Math.floor(indent / size) * size;
	    }
	
	    stops[indent] = index;
	
	    character = value.charAt(++index);
	  }
	
	  return {indent: indent, stops: stops};
	}


/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
	var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
	var singleQuoted = '\'[^\']*\'';
	var doubleQuoted = '"[^"]*"';
	var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
	var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
	var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
	var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
	var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
	var processing = '<[?].*?[?]>';
	var declaration = '<![A-Za-z]+\\s+[^>]*>';
	var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
	
	exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');
	
	exports.tag = new RegExp('^(?:' +
	  openTag + '|' +
	  closeTag + '|' +
	  comment + '|' +
	  processing + '|' +
	  declaration + '|' +
	  cdata +
	')');


/***/ },
/* 52 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(70);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	__webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Markdown = __webpack_require__(146);
	
	var textStyle = {
	  fontSize: "25px",
	  fontFamily: "Roboto"
	
	};
	var intial = '# Welcome to my React Markdown Previewer!\n\n## This is a sub-heading...\n### And here\'s some other cool stuff:\n  \nHeres some code, `<div></div>`, between 2 backticks.\n\n```\n// this is multi-line code:\n\nfunction anotherExample(firstLine, lastLine) {\n  if (firstLine == \'```\' && lastLine == \'```\') {\n    return multiLineCode;\n  }\n}\n```\n  \nYou can also make text **bold**... whoa!\nOr _italic_.\nOr... wait for it... **_both!_**\nAnd feel free to go crazy ~~crossing stuff out~~.\n\nThere\'s also [links](https://www.freecodecamp.com), and\n> Block Quotes!\n\nAnd if you want to get really crazy, even tables:\n\nWild Header | Crazy Header | Another Header?\n------------ | ------------- | ------------- \nYour content can | be here, and it | can be here....\nAnd here. | Okay. | I think we get it.\n\n- And of course there are lists.\n  - Some are bulleted.\n     - With different indentation levels.\n        - That look like this.\n\n\n1. And there are numbered lists too.\n1. Use just 1s if you want! \n1. But the list goes on...\n- Even if you use dashes or asterisks.\n* And last but not least, let\'s not forget embedded images:\n\n![Cool pic](https://picsum.photos/200/300)\n';
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.state = {
	      input: intial
	    };
	    _this.ontextEnter = _this.ontextEnter.bind(_this);
	    _this.keyPressed = _this.keyPressed.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'ontextEnter',
	    value: function ontextEnter(event) {
	      console.log(this.state.input);
	      this.setState({ input: event.target.value });
	    }
	  }, {
	    key: 'keyPressed',
	    value: function keyPressed(event) {
	      if (event.key === "Enter") {}
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 text-center' },
	            _react2.default.createElement(
	              'h1',
	              { style: { fontFamily: "ubuntu" } },
	              'Markdown Previewer'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6 text-center  ', style: { borderRight: "10px solid green", borderLeft: "1px solid", borderTop: "1px solid", borderBottom: "1px solid", height: "500px" } },
	            _react2.default.createElement(
	              'h2',
	              { style: { fontFamily: "ubuntu" } },
	              'Editor'
	            ),
	            _react2.default.createElement(
	              'textarea',
	              { className: 'form-control', onKeyPress: this.keyPressed, id: 'editor', onChange: this.ontextEnter, rows: '17', placeholder: 'Enter the text in markdown manner........', textarea: textStyle },
	              intial
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6', style: { borderRight: "1px solid", borderLeft: "10px solid red", borderTop: "1px solid", borderBottom: "1px solid" } },
	            _react2.default.createElement(
	              'h2',
	              { style: { fontFamily: "ubuntu", textAlign: "center" } },
	              'Preview '
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: 'preview', style: { overflow: "scroll", height: "450px" } },
	              _react2.default.createElement(Markdown, { id: 'preview', source: this.state.input.split('\n').join(' \n\n'), escapeHtml: false })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(133);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(53);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(69);
	
	__webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = bail
	
	function bail(err) {
	  if (err) {
	    throw err
	  }
	}


/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = collapse
	
	// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
	function collapse(value) {
	  return String(value).replace(/\s+/g, ' ')
	}


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(12);
	var entities = __webpack_require__(64);
	
	/* mixed-case SVG and MathML tags & attributes
	   recognized by the HTML parser, see
	   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	*/
	var foreignNames = __webpack_require__(86);
	foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
	foreignNames.attributeNames.__proto__ = null;
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '';
	  var value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (opts.xmlMode === 'foreign') {
	      /* fix up mixed-case attribute names */
	      key = foreignNames.attributeNames[key] || key;
	    }
	    output += key;
	    if ((value !== null && value !== '') || opts.xmlMode) {
	      output +=
	        '="' +
	        (opts.decodeEntities
	          ? entities.encodeXML(value)
	          : value.replace(/\"/g, '&quot;')) +
	        '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	};
	
	var render = (module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for (var i = 0; i < dom.length; i++) {
	    var elem = dom[i];
	
	    if (elem.type === 'root') output += render(elem.children, opts);
	    else if (ElementType.isTag(elem)) output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment) output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA) output += renderCdata(elem);
	    else output += renderText(elem, opts);
	  }
	
	  return output;
	});
	
	var foreignModeIntegrationPoints = [
	  'mi',
	  'mo',
	  'mn',
	  'ms',
	  'mtext',
	  'annotation-xml',
	  'foreignObject',
	  'desc',
	  'title'
	];
	
	function renderTag(elem, opts) {
	  // Handle SVG / MathML in HTML
	  if (opts.xmlMode === 'foreign') {
	    /* fix up mixed-case element names */
	    elem.name = foreignNames.elementNames[elem.name] || elem.name;
	    /* exit foreign mode at integration points */
	    if (
	      elem.parent &&
	      foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0
	    )
	      opts = Object.assign({}, opts, { xmlMode: false });
	  }
	  if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
	    opts = Object.assign({}, opts, { xmlMode: 'foreign' });
	  }
	
	  var tag = '<' + elem.name;
	  var attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (
	    opts.decodeEntities &&
	    !(elem.parent && elem.parent.name in unencodedElements)
	  ) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ },
/* 58 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var nodeTypes = new Map([
	    ["tag" /* Tag */, 1],
	    ["script" /* Script */, 1],
	    ["style" /* Style */, 1],
	    ["directive" /* Directive */, 1],
	    ["text" /* Text */, 3],
	    ["cdata" /* CDATA */, 4],
	    ["comment" /* Comment */, 8]
	]);
	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var Node = /** @class */ (function () {
	    /**
	     *
	     * @param type The type of the node.
	     */
	    function Node(type) {
	        this.type = type;
	        /** Parent of the node */
	        this.parent = null;
	        /** Previous sibling */
	        this.prev = null;
	        /** Next sibling */
	        this.next = null;
	        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
	        this.startIndex = null;
	        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
	        this.endIndex = null;
	    }
	    Object.defineProperty(Node.prototype, "nodeType", {
	        // Read-only aliases
	        get: function () {
	            return nodeTypes.get(this.type) || 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "parentNode", {
	        // Read-write aliases for properties
	        get: function () {
	            return this.parent || null;
	        },
	        set: function (parent) {
	            this.parent = parent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "previousSibling", {
	        get: function () {
	            return this.prev || null;
	        },
	        set: function (prev) {
	            this.prev = prev;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "nextSibling", {
	        get: function () {
	            return this.next || null;
	        },
	        set: function (next) {
	            this.next = next;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Node;
	}());
	exports.Node = Node;
	var DataNode = /** @class */ (function (_super) {
	    __extends(DataNode, _super);
	    /**
	     *
	     * @param type The type of the node
	     * @param data The content of the data node
	     */
	    function DataNode(type, data) {
	        var _this = _super.call(this, type) || this;
	        _this.data = data;
	        return _this;
	    }
	    Object.defineProperty(DataNode.prototype, "nodeValue", {
	        get: function () {
	            return this.data;
	        },
	        set: function (data) {
	            this.data = data;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DataNode;
	}(Node));
	exports.DataNode = DataNode;
	var ProcessingInstruction = /** @class */ (function (_super) {
	    __extends(ProcessingInstruction, _super);
	    function ProcessingInstruction(name, data) {
	        var _this = _super.call(this, "directive" /* Directive */, data) || this;
	        _this.name = name;
	        return _this;
	    }
	    return ProcessingInstruction;
	}(DataNode));
	exports.ProcessingInstruction = ProcessingInstruction;
	var NodeWithChildren = /** @class */ (function (_super) {
	    __extends(NodeWithChildren, _super);
	    /**
	     *
	     * @param type Type of the node.
	     * @param children Children of the node. Only certain node types can have children.
	     */
	    function NodeWithChildren(type, children) {
	        var _this = _super.call(this, type) || this;
	        _this.children = children;
	        return _this;
	    }
	    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
	        // Aliases
	        get: function () {
	            return this.children[0] || null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
	        get: function () {
	            return this.children[this.children.length - 1] || null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
	        get: function () {
	            return this.children;
	        },
	        set: function (children) {
	            this.children = children;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return NodeWithChildren;
	}(Node));
	exports.NodeWithChildren = NodeWithChildren;
	var Element = /** @class */ (function (_super) {
	    __extends(Element, _super);
	    /**
	     *
	     * @param name Name of the tag, eg. `div`, `span`
	     * @param attribs Object mapping attribute names to attribute values
	     */
	    function Element(name, attribs) {
	        var _this = _super.call(this, name === "script"
	            ? "script" /* Script */
	            : name === "style"
	                ? "style" /* Style */
	                : "tag" /* Tag */, []) || this;
	        _this.name = name;
	        _this.attribs = attribs;
	        _this.attribs = attribs;
	        return _this;
	    }
	    Object.defineProperty(Element.prototype, "tagName", {
	        // DOM Level 1 aliases
	        get: function () {
	            return this.name;
	        },
	        set: function (name) {
	            this.name = name;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Element;
	}(NodeWithChildren));
	exports.Element = Element;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tagtypes_1 = __webpack_require__(7);
	/**
	 * Given an array of nodes, remove any member that is contained by another.
	 *
	 * @param nodes Nodes to filter.
	 */
	function removeSubsets(nodes) {
	    var idx = nodes.length;
	    // Check if each node (or one of its ancestors) is already contained in the
	    // array.
	    while (--idx >= 0) {
	        var node = nodes[idx];
	        // Remove the node if it is not unique.
	        // We are going through the array from the end, so we only
	        // have to check nodes that preceed the node under consideration in the array.
	        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
	            nodes.splice(idx, 1);
	            continue;
	        }
	        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
	            if (nodes.indexOf(ancestor) > -1) {
	                nodes.splice(idx, 1);
	                break;
	            }
	        }
	    }
	    return nodes;
	}
	exports.removeSubsets = removeSubsets;
	/***
	 * Compare the position of one node against another node in any other document.
	 * The return value is a bitmask with the following values:
	 *
	 * document order:
	 * > There is an ordering, document order, defined on all the nodes in the
	 * > document corresponding to the order in which the first character of the
	 * > XML representation of each node occurs in the XML representation of the
	 * > document after expansion of general entities. Thus, the document element
	 * > node will be the first node. Element nodes occur before their children.
	 * > Thus, document order orders element nodes in order of the occurrence of
	 * > their start-tag in the XML (after expansion of entities). The attribute
	 * > nodes of an element occur after the element and before its children. The
	 * > relative order of attribute nodes is implementation-dependent./
	 *
	 * Source:
	 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	 * @param nodaA The first node to use in the comparison
	 * @param nodeB The second node to use in the comparison
	 *
	 * @return A bitmask describing the input nodes' relative position.
	 *
	 *        See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	 *        a description of these values.
	 */
	function compareDocumentPosition(nodeA, nodeB) {
	    var aParents = [];
	    var bParents = [];
	    if (nodeA === nodeB) {
	        return 0;
	    }
	    var current = tagtypes_1.hasChildren(nodeA) ? nodeA : nodeA.parent;
	    while (current) {
	        aParents.unshift(current);
	        current = current.parent;
	    }
	    current = tagtypes_1.hasChildren(nodeB) ? nodeB : nodeB.parent;
	    while (current) {
	        bParents.unshift(current);
	        current = current.parent;
	    }
	    var idx = 0;
	    while (aParents[idx] === bParents[idx]) {
	        idx++;
	    }
	    if (idx === 0) {
	        return 1 /* DISCONNECTED */;
	    }
	    var sharedParent = aParents[idx - 1];
	    var siblings = sharedParent.children;
	    var aSibling = aParents[idx];
	    var bSibling = bParents[idx];
	    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
	        if (sharedParent === nodeB) {
	            return 4 /* FOLLOWING */ | 16 /* CONTAINED_BY */;
	        }
	        return 4 /* FOLLOWING */;
	    }
	    else {
	        if (sharedParent === nodeA) {
	            return 2 /* PRECEDING */ | 8 /* CONTAINS */;
	        }
	        return 2 /* PRECEDING */;
	    }
	}
	exports.compareDocumentPosition = compareDocumentPosition;
	/***
	 * Sort an array of nodes based on their relative position in the document and
	 * remove any duplicate nodes. If the array contains nodes that do not belong
	 * to the same document, sort order is unspecified.
	 *
	 * @param nodes Array of DOM nodes
	 * @returns collection of unique nodes, sorted in document order
	 */
	function uniqueSort(nodes) {
	    nodes = nodes.filter(function (node, i, arr) { return !arr.includes(node, i + 1); });
	    nodes.sort(function (a, b) {
	        var relative = compareDocumentPosition(a, b);
	        if (relative & 2 /* PRECEDING */) {
	            return -1;
	        }
	        else if (relative & 4 /* FOLLOWING */) {
	            return 1;
	        }
	        return 0;
	    });
	    return nodes;
	}
	exports.uniqueSort = uniqueSort;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var querying_1 = __webpack_require__(30);
	var tagtypes_1 = __webpack_require__(7);
	function isTextNode(node) {
	    return node.type === "text" /* Text */;
	}
	/* eslint-disable @typescript-eslint/camelcase */
	var Checks = {
	    tag_name: function (name) {
	        if (typeof name === "function") {
	            return function (elem) { return tagtypes_1.isTag(elem) && name(elem.name); };
	        }
	        else if (name === "*") {
	            return tagtypes_1.isTag;
	        }
	        else {
	            return function (elem) { return tagtypes_1.isTag(elem) && elem.name === name; };
	        }
	    },
	    tag_type: function (type) {
	        if (typeof type === "function") {
	            return function (elem) { return type(elem.type); };
	        }
	        else {
	            return function (elem) { return elem.type === type; };
	        }
	    },
	    tag_contains: function (data) {
	        if (typeof data === "function") {
	            return function (elem) { return isTextNode(elem) && data(elem.data); };
	        }
	        else {
	            return function (elem) { return isTextNode(elem) && elem.data === data; };
	        }
	    },
	};
	/* eslint-enable @typescript-eslint/camelcase */
	function getAttribCheck(attrib, value) {
	    if (typeof value === "function") {
	        return function (elem) { return tagtypes_1.isTag(elem) && value(elem.attribs[attrib]); };
	    }
	    else {
	        return function (elem) { return tagtypes_1.isTag(elem) && elem.attribs[attrib] === value; };
	    }
	}
	function combineFuncs(a, b) {
	    return function (elem) { return a(elem) || b(elem); };
	}
	function compileTest(options) {
	    var funcs = Object.keys(options).map(function (key) {
	        var value = options[key];
	        return key in Checks
	            ? Checks[key](value)
	            : getAttribCheck(key, value);
	    });
	    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
	}
	function testElement(options, element) {
	    var test = compileTest(options);
	    return test ? test(element) : true;
	}
	exports.testElement = testElement;
	function getElements(options, element, recurse, limit) {
	    if (limit === void 0) { limit = Infinity; }
	    var test = compileTest(options);
	    return test ? querying_1.filter(test, element, recurse, limit) : [];
	}
	exports.getElements = getElements;
	function getElementById(id, element, recurse) {
	    if (recurse === void 0) { recurse = true; }
	    if (!Array.isArray(element))
	        element = [element];
	    return querying_1.findOne(getAttribCheck("id", id), element, recurse);
	}
	exports.getElementById = getElementById;
	function getElementsByTagName(name, element, recurse, limit) {
	    if (limit === void 0) { limit = Infinity; }
	    return querying_1.filter(Checks.tag_name(name), element, recurse, limit);
	}
	exports.getElementsByTagName = getElementsByTagName;
	function getElementsByTagType(type, element, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    return querying_1.filter(Checks.tag_type(type), element, recurse, limit);
	}
	exports.getElementsByTagType = getElementsByTagType;


/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/***
	 * Remove an element from the dom
	 *
	 * @param elem The element to be removed
	 */
	function removeElement(elem) {
	    if (elem.prev)
	        elem.prev.next = elem.next;
	    if (elem.next)
	        elem.next.prev = elem.prev;
	    if (elem.parent) {
	        var childs = elem.parent.children;
	        childs.splice(childs.lastIndexOf(elem), 1);
	    }
	}
	exports.removeElement = removeElement;
	/***
	 * Replace an element in the dom
	 *
	 * @param elem The element to be replaced
	 * @param replacement The element to be added
	 */
	function replaceElement(elem, replacement) {
	    var prev = (replacement.prev = elem.prev);
	    if (prev) {
	        prev.next = replacement;
	    }
	    var next = (replacement.next = elem.next);
	    if (next) {
	        next.prev = replacement;
	    }
	    var parent = (replacement.parent = elem.parent);
	    if (parent) {
	        var childs = parent.children;
	        childs[childs.lastIndexOf(elem)] = replacement;
	    }
	}
	exports.replaceElement = replaceElement;
	/***
	 * Append a child to an element
	 *
	 * @param elem The element to append to
	 * @param child The element to be added as a child
	 */
	function appendChild(elem, child) {
	    child.parent = elem;
	    if (elem.children.push(child) !== 1) {
	        var sibling = elem.children[elem.children.length - 2];
	        sibling.next = child;
	        child.prev = sibling;
	        child.next = null;
	    }
	}
	exports.appendChild = appendChild;
	/***
	 * Append an element after another
	 *
	 * @param elem The element to append to
	 * @param next The element be added
	 */
	function append(elem, next) {
	    var parent = elem.parent;
	    var currNext = elem.next;
	    next.next = currNext;
	    next.prev = elem;
	    elem.next = next;
	    next.parent = parent;
	    if (currNext) {
	        currNext.prev = next;
	        if (parent) {
	            var childs = parent.children;
	            childs.splice(childs.lastIndexOf(currNext), 0, next);
	        }
	    }
	    else if (parent) {
	        parent.children.push(next);
	    }
	}
	exports.append = append;
	/***
	 * Prepend an element before another
	 *
	 * @param elem The element to append to
	 * @param prev The element be added
	 */
	function prepend(elem, prev) {
	    var parent = elem.parent;
	    if (parent) {
	        var childs = parent.children;
	        childs.splice(childs.lastIndexOf(elem), 0, prev);
	    }
	    if (elem.prev) {
	        elem.prev.next = prev;
	    }
	    prev.parent = parent;
	    prev.prev = elem.prev;
	    prev.next = elem;
	    elem.prev = prev;
	}
	exports.prepend = prepend;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var tagtypes_1 = __webpack_require__(7);
	var dom_serializer_1 = __importDefault(__webpack_require__(57));
	function getOuterHTML(node, options) {
	    return dom_serializer_1.default(node, options);
	}
	exports.getOuterHTML = getOuterHTML;
	function getInnerHTML(node, options) {
	    return tagtypes_1.hasChildren(node)
	        ? node.children.map(function (node) { return getOuterHTML(node, options); }).join("")
	        : "";
	}
	exports.getInnerHTML = getInnerHTML;
	function getText(node) {
	    if (Array.isArray(node))
	        return node.map(getText).join("");
	    if (tagtypes_1.isTag(node))
	        return node.name === "br" ? "\n" : getText(node.children);
	    if (tagtypes_1.isCDATA(node))
	        return getText(node.children);
	    if (tagtypes_1.isText(node))
	        return node.data;
	    return "";
	}
	exports.getText = getText;


/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function getChildren(elem) {
	    return elem.children || null;
	}
	exports.getChildren = getChildren;
	function getParent(elem) {
	    return elem.parent || null;
	}
	exports.getParent = getParent;
	function getSiblings(elem) {
	    var parent = getParent(elem);
	    return parent ? getChildren(parent) : [elem];
	}
	exports.getSiblings = getSiblings;
	function getAttributeValue(elem, name) {
	    var _a;
	    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
	}
	exports.getAttributeValue = getAttributeValue;
	function hasAttrib(elem, name) {
	    return (!!elem.attribs &&
	        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
	        elem.attribs[name] != null);
	}
	exports.hasAttrib = hasAttrib;
	/***
	 * Returns the name property of an element
	 *
	 * @param elem The element to get the name for
	 */
	function getName(elem) {
	    return elem.name;
	}
	exports.getName = getName;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.encode = exports.decodeStrict = exports.decode = void 0;
	var decode_1 = __webpack_require__(31);
	var encode_1 = __webpack_require__(33);
	/**
	 * Decodes a string with entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 */
	function decode(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
	}
	exports.decode = decode;
	/**
	 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 */
	function decodeStrict(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
	}
	exports.decodeStrict = decodeStrict;
	/**
	 * Encodes a string with entities.
	 *
	 * @param data String to encode.
	 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
	 */
	function encode(data, level) {
	    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
	}
	exports.encode = encode;
	var encode_2 = __webpack_require__(33);
	Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return encode_2.encodeXML; } });
	Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return encode_2.escape; } });
	// Legacy aliases
	Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	var decode_2 = __webpack_require__(31);
	Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_2.decodeXML; } });
	Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	// Legacy aliases
	Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_2.decodeXML; } });


/***/ },
/* 65 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ },
/* 67 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 68 */
67,
/* 69 */
67,
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.5d5d9eef.svg";

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parser = __webpack_require__(73);
	var processingInstructions = __webpack_require__(36);
	var isValidNodeDefinitions = __webpack_require__(34);
	var processNodeDefinitions = __webpack_require__(35);
	
	module.exports = {
	  Parser: parser,
	  ProcessingInstructions: processingInstructions,
	  IsValidNodeDefinitions: isValidNodeDefinitions,
	  ProcessNodeDefinitions: processNodeDefinitions,
	};


/***/ },
/* 72 */
/***/ function(module, exports) {

	// These are all sourced from https://facebook.github.io/react/docs/tags-and-attributes.html -
	// all attributes regardless of whether they have a different case to their HTML equivalents are
	// listed to reduce the chance of human error and make it easier to just copy-paste the new list if
	// it changes.
	'use strict';
	var HTML_ATTRIBUTES = [
	  'accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency',
	  'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding',
	  'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className',
	  'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'coords',
	  'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download',
	  'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate',
	  'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang',
	  'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType',
	  'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth',
	  'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted',
	  'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster',
	  'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role',
	  'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected',
	  'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start',
	  'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width',
	  'wmode', 'wrap', 'onClick',
	];
	
	var NON_STANDARD_ATTRIBUTES = [
	  'autoCapitalize', 'autoCorrect', 'color', 'itemProp', 'itemScope', 'itemType', 'itemRef',
	  'itemID', 'security', 'unselectable', 'results', 'autoSave',
	];
	
	var SVG_ATTRIBUTES = [
	  'accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic',
	  'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth',
	  'baseFrequency', 'baseProfile', 'baselineShift', 'bbox', 'begin', 'bias', 'by', 'calcMode',
	  'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation',
	  'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType',
	  'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant',
	  'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode',
	  'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill',
	  'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity',
	  'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle',
	  'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName',
	  'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef',
	  'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'ideographic',
	  'imageRendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kernelMatrix',
	  'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust',
	  'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight',
	  'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits',
	  'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order',
	  'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness',
	  'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform',
	  'patternUnits', 'pointerEvents', 'points', 'pointsAtX', 'pointsAtY', 'pointsAtZ',
	  'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY',
	  'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures',
	  'restart', 'result', 'rotate', 'rx', 'ry', 'scale', 'seed', 'shapeRendering', 'slope',
	  'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset',
	  'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity',
	  'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray',
	  'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity',
	  'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY',
	  'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1',
	  'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange',
	  'unitsPerEm', 'vAlphabetic', 'vHanging', 'vIdeographic', 'vMathematical', 'values',
	  'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'viewBox',
	  'viewTarget', 'visibility', 'widths', 'wordSpacing', 'writingMode', 'x', 'x1', 'x2',
	  'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole',
	  'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlns', 'xmlnsXlink', 'xmlBase', 'xmlLang',
	  'xmlSpace', 'y', 'y1', 'y2', 'yChannelSelector', 'z', 'zoomAndPan',
	];
	
	var camelCaseMap = HTML_ATTRIBUTES
	  .concat(NON_STANDARD_ATTRIBUTES)
	  .concat(SVG_ATTRIBUTES)
	  .reduce(function (soFar, attr) {
	    var lower = attr.toLowerCase();
	    if (lower !== attr) {
	      soFar[lower] = attr;
	    }
	    return soFar;
	  }, {});
	
	module.exports = camelCaseMap;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var forEach = __webpack_require__(101);
	var find = __webpack_require__(100);
	var reject = __webpack_require__(129);
	var addIndex = __webpack_require__(96);
	var map = __webpack_require__(127);
	var HtmlParser = __webpack_require__(77).Parser;
	var DomHandler = __webpack_require__(13).DomHandler;
	var ProcessingInstructions = __webpack_require__(36);
	var IsValidNodeDefinitions = __webpack_require__(34);
	var utils = __webpack_require__(37);
	
	function Html2ReactParser(options) {
	  function parseHtmlToTree(html) {
	    options = options || {};
	    options.decodeEntities = true;
	    var handler = new DomHandler();
	    var parser = new HtmlParser(handler, options);
	    parser.parseComplete(html);
	    return handler.dom.filter(function (element) {
	      return element.type !== 'directive';
	    });
	  };
	
	  function traverseDom(node, isValidNode, processingInstructions, preprocessingInstructions,
	    index) {
	    if (isValidNode(node)) {
	      forEach(function (preprocessingInstruction) {
	        if (preprocessingInstruction.shouldPreprocessNode(node)) {
	          preprocessingInstruction.preprocessNode(node, index);
	        }
	      }, preprocessingInstructions || []);
	
	      var processingInstruction = find(function (processingInstruction) {
	        return processingInstruction.shouldProcessNode(node);
	      }, processingInstructions || []);
	      if (processingInstruction != null) {
	        var children = reject(function (x) {return x == null || x === false;},
	          addIndex(map)(function (child, i) {
	            return traverseDom(child, isValidNode, processingInstructions,
	              preprocessingInstructions, i);
	          }, node.children || []));
	
	        if (processingInstruction.replaceChildren) {
	          return utils.createElement(node, index, node.data, [
	            processingInstruction.processNode(node, children, index),
	          ]);
	        } else {
	          return processingInstruction.processNode(node, children, index);
	        }
	      } else {
	        return false;
	      }
	    } else {
	      return false;
	    }
	  };
	
	  function parseWithInstructions(html, isValidNode, processingInstructions,
	      preprocessingInstructions) {
	    var domTree = parseHtmlToTree(html);
	    var list = domTree.map(function (domTreeItem, index) {
	      return traverseDom(domTreeItem, isValidNode, processingInstructions,
	        preprocessingInstructions, index);
	    });
	    return list.length <= 1 ? list[0] : list;
	  };
	
	  function parse(html) {
	    var processingInstructions = new ProcessingInstructions();
	    return parseWithInstructions(html,
	      IsValidNodeDefinitions.alwaysValid,
	      processingInstructions.defaultProcessingInstructions);
	  };
	
	  return {
	    parse: parse,
	    parseWithInstructions: parseWithInstructions,
	  };
	};
	
	module.exports = Html2ReactParser;


/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	function shouldProcessEveryNode(node) {
	  return true;
	}
	
	module.exports = {
	  shouldProcessEveryNode: shouldProcessEveryNode,
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var MultiplexHandler_1 = __importDefault(__webpack_require__(76));
	var CollectingHandler = /** @class */ (function (_super) {
	    __extends(CollectingHandler, _super);
	    function CollectingHandler(cbs) {
	        if (cbs === void 0) { cbs = {}; }
	        var _this = _super.call(this, function (name) {
	            var _a;
	            var args = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	            }
	            _this.events.push([name].concat(args));
	            // @ts-ignore
	            if (_this._cbs[name])
	                (_a = _this._cbs)[name].apply(_a, args);
	        }) || this;
	        _this._cbs = cbs;
	        _this.events = [];
	        return _this;
	    }
	    CollectingHandler.prototype.onreset = function () {
	        this.events = [];
	        if (this._cbs.onreset)
	            this._cbs.onreset();
	    };
	    CollectingHandler.prototype.restart = function () {
	        var _a;
	        if (this._cbs.onreset)
	            this._cbs.onreset();
	        for (var i = 0; i < this.events.length; i++) {
	            var _b = this.events[i], name_1 = _b[0], args = _b.slice(1);
	            if (!this._cbs[name_1]) {
	                continue;
	            }
	            // @ts-ignore
	            (_a = this._cbs)[name_1].apply(_a, args);
	        }
	    };
	    return CollectingHandler;
	}(MultiplexHandler_1.default));
	exports.CollectingHandler = CollectingHandler;


/***/ },
/* 76 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Calls a specific handler function for all events that are encountered.
	 *
	 * @param func — The function to multiplex all events to.
	 */
	var MultiplexHandler = /** @class */ (function () {
	    function MultiplexHandler(func) {
	        this._func = func;
	    }
	    /* Format: eventname: number of arguments */
	    MultiplexHandler.prototype.onattribute = function (name, value) {
	        this._func("onattribute", name, value);
	    };
	    MultiplexHandler.prototype.oncdatastart = function () {
	        this._func("oncdatastart");
	    };
	    MultiplexHandler.prototype.oncdataend = function () {
	        this._func("oncdataend");
	    };
	    MultiplexHandler.prototype.ontext = function (text) {
	        this._func("ontext", text);
	    };
	    MultiplexHandler.prototype.onprocessinginstruction = function (name, value) {
	        this._func("onprocessinginstruction", name, value);
	    };
	    MultiplexHandler.prototype.oncomment = function (comment) {
	        this._func("oncomment", comment);
	    };
	    MultiplexHandler.prototype.oncommentend = function () {
	        this._func("oncommentend");
	    };
	    MultiplexHandler.prototype.onclosetag = function (name) {
	        this._func("onclosetag", name);
	    };
	    MultiplexHandler.prototype.onopentag = function (name, attribs) {
	        this._func("onopentag", name, attribs);
	    };
	    MultiplexHandler.prototype.onopentagname = function (name) {
	        this._func("onopentagname", name);
	    };
	    MultiplexHandler.prototype.onerror = function (error) {
	        this._func("onerror", error);
	    };
	    MultiplexHandler.prototype.onend = function () {
	        this._func("onend");
	    };
	    MultiplexHandler.prototype.onparserinit = function (parser) {
	        this._func("onparserinit", parser);
	    };
	    MultiplexHandler.prototype.onreset = function () {
	        this._func("onreset");
	    };
	    return MultiplexHandler;
	}());
	exports.default = MultiplexHandler;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    result["default"] = mod;
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Parser_1 = __webpack_require__(39);
	exports.Parser = Parser_1.Parser;
	var domhandler_1 = __webpack_require__(13);
	exports.DomHandler = domhandler_1.DomHandler;
	exports.DefaultHandler = domhandler_1.DomHandler;
	// Helper methods
	/**
	 * Parses data, returns the resulting DOM.
	 *
	 * @param data The data that should be parsed.
	 * @param options Optional options for the parser and DOM builder.
	 */
	function parseDOM(data, options) {
	    var handler = new domhandler_1.DomHandler(void 0, options);
	    new Parser_1.Parser(handler, options).end(data);
	    return handler.dom;
	}
	exports.parseDOM = parseDOM;
	/**
	 * Creates a parser instance, with an attached DOM handler.
	 *
	 * @param cb A callback that will be called once parsing has been completed.
	 * @param options Optional options for the parser and DOM builder.
	 * @param elementCb An optional callback that will be called every time a tag has been completed inside of the DOM.
	 */
	function createDomStream(cb, options, elementCb) {
	    var handler = new domhandler_1.DomHandler(cb, options, elementCb);
	    return new Parser_1.Parser(handler, options);
	}
	exports.createDomStream = createDomStream;
	var Tokenizer_1 = __webpack_require__(40);
	exports.Tokenizer = Tokenizer_1.default;
	var ElementType = __importStar(__webpack_require__(12));
	exports.ElementType = ElementType;
	/**
	 * List of all events that the parser emits.
	 *
	 * Format: eventname: number of arguments.
	 */
	exports.EVENTS = {
	    attribute: 2,
	    cdatastart: 0,
	    cdataend: 0,
	    text: 1,
	    processinginstruction: 2,
	    comment: 1,
	    commentend: 0,
	    closetag: 1,
	    opentag: 2,
	    opentagname: 1,
	    error: 1,
	    end: 0
	};
	/*
	    All of the following exports exist for backwards-compatibility.
	    They should probably be removed eventually.
	*/
	__export(__webpack_require__(38));
	__export(__webpack_require__(210));
	__export(__webpack_require__(75));
	var DomUtils = __importStar(__webpack_require__(29));
	exports.DomUtils = DomUtils;
	var FeedHandler_1 = __webpack_require__(38);
	exports.RssHandler = FeedHandler_1.FeedHandler;


/***/ },
/* 78 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var alphabetical = __webpack_require__(41)
	var decimal = __webpack_require__(9)
	
	module.exports = alphanumerical
	
	// Check if the given character code, or the character code at the first
	// character, is alphanumerical.
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character)
	}


/***/ },
/* 80 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 81 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = hexadecimal
	
	// Check if the given character code, or the character code at the first
	// character, is hexadecimal.
	function hexadecimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 /* a */ && code <= 102) /* z */ ||
	    (code >= 65 /* A */ && code <= 70) /* Z */ ||
	    (code >= 48 /* A */ && code <= 57) /* Z */
	  )
	}


/***/ },
/* 82 */
/***/ function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ },
/* 83 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = wordCharacter
	
	var fromCode = String.fromCharCode
	var re = /\w/
	
	// Check if the given character code, or the character code at the first
	// character, is a word character.
	function wordCharacter(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = {
		"AElig": "Æ",
		"AMP": "&",
		"Aacute": "Á",
		"Acirc": "Â",
		"Agrave": "À",
		"Aring": "Å",
		"Atilde": "Ã",
		"Auml": "Ä",
		"COPY": "©",
		"Ccedil": "Ç",
		"ETH": "Ð",
		"Eacute": "É",
		"Ecirc": "Ê",
		"Egrave": "È",
		"Euml": "Ë",
		"GT": ">",
		"Iacute": "Í",
		"Icirc": "Î",
		"Igrave": "Ì",
		"Iuml": "Ï",
		"LT": "<",
		"Ntilde": "Ñ",
		"Oacute": "Ó",
		"Ocirc": "Ô",
		"Ograve": "Ò",
		"Oslash": "Ø",
		"Otilde": "Õ",
		"Ouml": "Ö",
		"QUOT": "\"",
		"REG": "®",
		"THORN": "Þ",
		"Uacute": "Ú",
		"Ucirc": "Û",
		"Ugrave": "Ù",
		"Uuml": "Ü",
		"Yacute": "Ý",
		"aacute": "á",
		"acirc": "â",
		"acute": "´",
		"aelig": "æ",
		"agrave": "à",
		"amp": "&",
		"aring": "å",
		"atilde": "ã",
		"auml": "ä",
		"brvbar": "¦",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"eacute": "é",
		"ecirc": "ê",
		"egrave": "è",
		"eth": "ð",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"iacute": "í",
		"icirc": "î",
		"iexcl": "¡",
		"igrave": "ì",
		"iquest": "¿",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"ntilde": "ñ",
		"oacute": "ó",
		"ocirc": "ô",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"oslash": "ø",
		"otilde": "õ",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"raquo": "»",
		"reg": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"thorn": "þ",
		"times": "×",
		"uacute": "ú",
		"ucirc": "û",
		"ugrave": "ù",
		"uml": "¨",
		"uuml": "ü",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = {
		"0": "�",
		"128": "€",
		"130": "‚",
		"131": "ƒ",
		"132": "„",
		"133": "…",
		"134": "†",
		"135": "‡",
		"136": "ˆ",
		"137": "‰",
		"138": "Š",
		"139": "‹",
		"140": "Œ",
		"142": "Ž",
		"145": "‘",
		"146": "’",
		"147": "“",
		"148": "”",
		"149": "•",
		"150": "–",
		"151": "—",
		"152": "˜",
		"153": "™",
		"154": "š",
		"155": "›",
		"156": "œ",
		"158": "ž",
		"159": "Ÿ"
	};

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports = {
		"elementNames": {
			"altglyph": "altGlyph",
			"altglyphdef": "altGlyphDef",
			"altglyphitem": "altGlyphItem",
			"animatecolor": "animateColor",
			"animatemotion": "animateMotion",
			"animatetransform": "animateTransform",
			"clippath": "clipPath",
			"feblend": "feBlend",
			"fecolormatrix": "feColorMatrix",
			"fecomponenttransfer": "feComponentTransfer",
			"fecomposite": "feComposite",
			"feconvolvematrix": "feConvolveMatrix",
			"fediffuselighting": "feDiffuseLighting",
			"fedisplacementmap": "feDisplacementMap",
			"fedistantlight": "feDistantLight",
			"fedropshadow": "feDropShadow",
			"feflood": "feFlood",
			"fefunca": "feFuncA",
			"fefuncb": "feFuncB",
			"fefuncg": "feFuncG",
			"fefuncr": "feFuncR",
			"fegaussianblur": "feGaussianBlur",
			"feimage": "feImage",
			"femerge": "feMerge",
			"femergenode": "feMergeNode",
			"femorphology": "feMorphology",
			"feoffset": "feOffset",
			"fepointlight": "fePointLight",
			"fespecularlighting": "feSpecularLighting",
			"fespotlight": "feSpotLight",
			"fetile": "feTile",
			"feturbulence": "feTurbulence",
			"foreignobject": "foreignObject",
			"glyphref": "glyphRef",
			"lineargradient": "linearGradient",
			"radialgradient": "radialGradient",
			"textpath": "textPath"
		},
		"attributeNames": {
			"definitionurl": "definitionURL",
			"attributename": "attributeName",
			"attributetype": "attributeType",
			"basefrequency": "baseFrequency",
			"baseprofile": "baseProfile",
			"calcmode": "calcMode",
			"clippathunits": "clipPathUnits",
			"diffuseconstant": "diffuseConstant",
			"edgemode": "edgeMode",
			"filterunits": "filterUnits",
			"glyphref": "glyphRef",
			"gradienttransform": "gradientTransform",
			"gradientunits": "gradientUnits",
			"kernelmatrix": "kernelMatrix",
			"kernelunitlength": "kernelUnitLength",
			"keypoints": "keyPoints",
			"keysplines": "keySplines",
			"keytimes": "keyTimes",
			"lengthadjust": "lengthAdjust",
			"limitingconeangle": "limitingConeAngle",
			"markerheight": "markerHeight",
			"markerunits": "markerUnits",
			"markerwidth": "markerWidth",
			"maskcontentunits": "maskContentUnits",
			"maskunits": "maskUnits",
			"numoctaves": "numOctaves",
			"pathlength": "pathLength",
			"patterncontentunits": "patternContentUnits",
			"patterntransform": "patternTransform",
			"patternunits": "patternUnits",
			"pointsatx": "pointsAtX",
			"pointsaty": "pointsAtY",
			"pointsatz": "pointsAtZ",
			"preservealpha": "preserveAlpha",
			"preserveaspectratio": "preserveAspectRatio",
			"primitiveunits": "primitiveUnits",
			"refx": "refX",
			"refy": "refY",
			"repeatcount": "repeatCount",
			"repeatdur": "repeatDur",
			"requiredextensions": "requiredExtensions",
			"requiredfeatures": "requiredFeatures",
			"specularconstant": "specularConstant",
			"specularexponent": "specularExponent",
			"spreadmethod": "spreadMethod",
			"startoffset": "startOffset",
			"stddeviation": "stdDeviation",
			"stitchtiles": "stitchTiles",
			"surfacescale": "surfaceScale",
			"systemlanguage": "systemLanguage",
			"tablevalues": "tableValues",
			"targetx": "targetX",
			"targety": "targetY",
			"textlength": "textLength",
			"viewbox": "viewBox",
			"viewtarget": "viewTarget",
			"xchannelselector": "xChannelSelector",
			"ychannelselector": "yChannelSelector",
			"zoomandpan": "zoomAndPan"
		}
	};

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports = [
		"address",
		"article",
		"aside",
		"base",
		"basefont",
		"blockquote",
		"body",
		"caption",
		"center",
		"col",
		"colgroup",
		"dd",
		"details",
		"dialog",
		"dir",
		"div",
		"dl",
		"dt",
		"fieldset",
		"figcaption",
		"figure",
		"footer",
		"form",
		"frame",
		"frameset",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"head",
		"header",
		"hgroup",
		"hr",
		"html",
		"iframe",
		"legend",
		"li",
		"link",
		"main",
		"menu",
		"menuitem",
		"meta",
		"nav",
		"noframes",
		"ol",
		"optgroup",
		"option",
		"p",
		"param",
		"pre",
		"section",
		"source",
		"title",
		"summary",
		"table",
		"tbody",
		"td",
		"tfoot",
		"th",
		"thead",
		"title",
		"tr",
		"track",
		"ul"
	];

/***/ },
/* 89 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsAstral = '[' + rsAstralRange + ']',
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	  rsUpper + '+' + rsOptUpperContr,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 'ss'
	};
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar--');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__FOO_BAR__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = camelCase;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = escapes
	
	var defaults = [
	  '\\',
	  '`',
	  '*',
	  '{',
	  '}',
	  '[',
	  ']',
	  '(',
	  ')',
	  '#',
	  '+',
	  '-',
	  '.',
	  '!',
	  '_',
	  '>'
	]
	
	var gfm = defaults.concat(['~', '|'])
	
	var commonmark = gfm.concat([
	  '\n',
	  '"',
	  '$',
	  '%',
	  '&',
	  "'",
	  ',',
	  '/',
	  ':',
	  ';',
	  '<',
	  '=',
	  '?',
	  '@',
	  '^'
	])
	
	escapes.default = defaults
	escapes.gfm = gfm
	escapes.commonmark = commonmark
	
	// Get markdown escapes.
	function escapes(options) {
	  var settings = options || {}
	
	  if (settings.commonmark) {
	    return commonmark
	  }
	
	  return settings.gfm ? gfm : defaults
	}


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var visitWithParents = __webpack_require__(203);
	
	function addListMetadata() {
	  return function (ast) {
	    visitWithParents(ast, 'list', function (listNode, parents) {
	      var depth = 0, i, n;
	      for (i = 0, n = parents.length; i < n; i++) {
	        if (parents[i].type === 'list') depth += 1;
	      }
	      for (i = 0, n = listNode.children.length; i < n; i++) {
	        var child = listNode.children[i];
	        child.index = i;
	        child.ordered = listNode.ordered;
	      }
	      listNode.depth = depth;
	    });
	    return ast;
	  };
	}
	
	module.exports = addListMetadata;


/***/ },
/* 92 */
/***/ function(module, exports) {

	'use strict'
	
	/* eslint-env browser */
	
	var el
	
	var semicolon = 59 //  ';'
	
	module.exports = decodeEntity
	
	function decodeEntity(characters) {
	  var entity = '&' + characters + ';'
	  var char
	
	  el = el || document.createElement('i')
	  el.innerHTML = entity
	  char = el.textContent
	
	  // Some entities do not require the closing semicolon (`&not` - for instance),
	  // which leads to situations where parsing the assumed entity of &notit; will
	  // result in the string `¬it;`.  When we encounter a trailing semicolon after
	  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
	  // assume that the matching was incomplete
	  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
	    return false
	  }
	
	  // If the decoded string is equal to the input, the entity was not valid
	  return char === entity ? false : char
	}


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(95);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(93)();
	}


/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var _concat =
	/*#__PURE__*/
	__webpack_require__(106);
	
	var _curry1 =
	/*#__PURE__*/
	__webpack_require__(4);
	
	var curryN =
	/*#__PURE__*/
	__webpack_require__(44);
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, [`R.map`](#map) function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      const mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	
	
	var addIndex =
	/*#__PURE__*/
	_curry1(function addIndex(fn) {
	  return curryN(fn.length, function () {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	
	    args[0] = function () {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	
	    return fn.apply(this, args);
	  });
	});
	
	module.exports = addIndex;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var _arity =
	/*#__PURE__*/
	__webpack_require__(19);
	
	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      const log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	
	
	var bind =
	/*#__PURE__*/
	_curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function () {
	    return fn.apply(thisObj, arguments);
	  });
	});
	
	module.exports = bind;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _equals =
	/*#__PURE__*/
	__webpack_require__(109);
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      const a = {}; a.v = a;
	 *      const b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	
	
	var equals =
	/*#__PURE__*/
	_curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});
	
	module.exports = equals;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _dispatchable =
	/*#__PURE__*/
	__webpack_require__(20);
	
	var _filter =
	/*#__PURE__*/
	__webpack_require__(110);
	
	var _isObject =
	/*#__PURE__*/
	__webpack_require__(117);
	
	var _reduce =
	/*#__PURE__*/
	__webpack_require__(22);
	
	var _xfilter =
	/*#__PURE__*/
	__webpack_require__(123);
	
	var keys =
	/*#__PURE__*/
	__webpack_require__(24);
	/**
	 * Takes a predicate and a `Filterable`, and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array} Filterable
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      const isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	
	
	var filter =
	/*#__PURE__*/
	_curry2(
	/*#__PURE__*/
	_dispatchable(['filter'], _xfilter, function (pred, filterable) {
	  return _isObject(filterable) ? _reduce(function (acc, key) {
	    if (pred(filterable[key])) {
	      acc[key] = filterable[key];
	    }
	
	    return acc;
	  }, {}, keys(filterable)) : // else
	  _filter(pred, filterable);
	}));
	
	module.exports = filter;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _dispatchable =
	/*#__PURE__*/
	__webpack_require__(20);
	
	var _xfind =
	/*#__PURE__*/
	__webpack_require__(124);
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	
	
	var find =
	/*#__PURE__*/
	_curry2(
	/*#__PURE__*/
	_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	
	    idx += 1;
	  }
	}));
	
	module.exports = find;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod =
	/*#__PURE__*/
	__webpack_require__(104);
	
	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      const printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	
	
	var forEach =
	/*#__PURE__*/
	_curry2(
	/*#__PURE__*/
	_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	
	  return list;
	}));
	
	module.exports = forEach;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var _includes =
	/*#__PURE__*/
	__webpack_require__(112);
	
	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	/**
	 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
	 * terms, to at least one element of the given list; `false` otherwise.
	 * Works also with strings.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.26.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.includes(3, [1, 2, 3]); //=> true
	 *      R.includes(4, [1, 2, 3]); //=> false
	 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.includes([42], [[42]]); //=> true
	 *      R.includes('ba', 'banana'); //=>true
	 */
	
	
	var includes =
	/*#__PURE__*/
	_curry2(_includes);
	
	module.exports = includes;

/***/ },
/* 103 */
/***/ function(module, exports) {

	function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	
	  return list;
	}
	
	module.exports = _arrayFromIterator;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray =
	/*#__PURE__*/
	__webpack_require__(21);
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	
	
	function _checkForMethod(methodname, fn) {
	  return function () {
	    var length = arguments.length;
	
	    if (length === 0) {
	      return fn();
	    }
	
	    var obj = arguments[length - 1];
	    return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	}
	
	module.exports = _checkForMethod;

/***/ },
/* 105 */
/***/ function(module, exports) {

	function _complement(f) {
	  return function () {
	    return !f.apply(this, arguments);
	  };
	}
	
	module.exports = _complement;

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	  idx = 0;
	
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	
	  idx = 0;
	
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	
	  return result;
	}
	
	module.exports = _concat;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 =
	/*#__PURE__*/
	__webpack_require__(4);
	
	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _isPlaceholder =
	/*#__PURE__*/
	__webpack_require__(11);
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	
	      case 1:
	        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        });
	
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
	          return fn(_a, b, _c);
	        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        }) : _curry1(function (_c) {
	          return fn(a, b, _c);
	        });
	
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
	          return fn(_a, _b, c);
	        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
	          return fn(_a, b, _c);
	        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        }) : _isPlaceholder(a) ? _curry1(function (_a) {
	          return fn(_a, b, c);
	        }) : _isPlaceholder(b) ? _curry1(function (_b) {
	          return fn(a, _b, c);
	        }) : _isPlaceholder(c) ? _curry1(function (_c) {
	          return fn(a, b, _c);
	        }) : fn(a, b, c);
	    }
	  };
	}
	
	module.exports = _curry3;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var _arity =
	/*#__PURE__*/
	__webpack_require__(19);
	
	var _isPlaceholder =
	/*#__PURE__*/
	__webpack_require__(11);
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curryN(length, received, fn) {
	  return function () {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	
	      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	
	      combined[combinedIdx] = result;
	
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	
	      combinedIdx += 1;
	    }
	
	    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
	  };
	}
	
	module.exports = _curryN;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var _arrayFromIterator =
	/*#__PURE__*/
	__webpack_require__(103);
	
	var _includesWith =
	/*#__PURE__*/
	__webpack_require__(113);
	
	var _functionName =
	/*#__PURE__*/
	__webpack_require__(111);
	
	var _has =
	/*#__PURE__*/
	__webpack_require__(10);
	
	var _objectIs =
	/*#__PURE__*/
	__webpack_require__(121);
	
	var keys =
	/*#__PURE__*/
	__webpack_require__(24);
	
	var type =
	/*#__PURE__*/
	__webpack_require__(131);
	/**
	 * private _uniqContentEquals function.
	 * That function is checking equality of 2 iterator contents with 2 assumptions
	 * - iterators lengths are the same
	 * - iterators values are unique
	 *
	 * false-positive result will be returned for comparision of, e.g.
	 * - [1,2,3] and [1,2,3,4]
	 * - [1,1,1] and [1,2,3]
	 * */
	
	
	function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
	  var a = _arrayFromIterator(aIterator);
	
	  var b = _arrayFromIterator(bIterator);
	
	  function eq(_a, _b) {
	    return _equals(_a, _b, stackA.slice(), stackB.slice());
	  } // if *a* array contains any element that is not included in *b*
	
	
	  return !_includesWith(function (b, aItem) {
	    return !_includesWith(eq, aItem, b);
	  }, b, a);
	}
	
	function _equals(a, b, stackA, stackB) {
	  if (_objectIs(a, b)) {
	    return true;
	  }
	
	  var typeA = type(a);
	
	  if (typeA !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
	    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (typeA) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	
	      break;
	
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && _objectIs(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	
	      break;
	
	    case 'Date':
	      if (!_objectIs(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	
	      break;
	
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	
	    case 'RegExp':
	      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
	        return false;
	      }
	
	      break;
	  }
	
	  var idx = stackA.length - 1;
	
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	
	    idx -= 1;
	  }
	
	  switch (typeA) {
	    case 'Map':
	      if (a.size !== b.size) {
	        return false;
	      }
	
	      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
	
	    case 'Set':
	      if (a.size !== b.size) {
	        return false;
	      }
	
	      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
	
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	    case 'Date':
	    case 'Error':
	    case 'RegExp':
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	    case 'ArrayBuffer':
	      break;
	
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var extendedStackA = stackA.concat([a]);
	  var extendedStackB = stackB.concat([b]);
	  idx = keysA.length - 1;
	
	  while (idx >= 0) {
	    var key = keysA[idx];
	
	    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
	      return false;
	    }
	
	    idx -= 1;
	  }
	
	  return true;
	}
	
	module.exports = _equals;

/***/ },
/* 110 */
/***/ function(module, exports) {

	function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	
	    idx += 1;
	  }
	
	  return result;
	}
	
	module.exports = _filter;

/***/ },
/* 111 */
/***/ function(module, exports) {

	function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	}
	
	module.exports = _functionName;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var _indexOf =
	/*#__PURE__*/
	__webpack_require__(114);
	
	function _includes(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	}
	
	module.exports = _includes;

/***/ },
/* 113 */
/***/ function(module, exports) {

	function _includesWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	
	    idx += 1;
	  }
	
	  return false;
	}
	
	module.exports = _includesWith;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var equals =
	/*#__PURE__*/
	__webpack_require__(98);
	
	function _indexOf(list, a, idx) {
	  var inf, item; // Array.prototype.indexOf doesn't exist below IE9
	
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	
	          while (idx < list.length) {
	            item = list[idx];
	
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	
	            idx += 1;
	          }
	
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	
	            idx += 1;
	          }
	
	          return -1;
	        } // non-zero numbers can utilise Set
	
	
	        return list.indexOf(a, idx);
	      // all these types can utilise Set
	
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	
	    }
	  } // anything else not covered above, defer to R.equals
	
	
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	
	    idx += 1;
	  }
	
	  return -1;
	}
	
	module.exports = _indexOf;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var _has =
	/*#__PURE__*/
	__webpack_require__(10);
	
	var toString = Object.prototype.toString;
	
	var _isArguments =
	/*#__PURE__*/
	function () {
	  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
	    return toString.call(x) === '[object Arguments]';
	  } : function _isArguments(x) {
	    return _has('callee', x);
	  };
	}();
	
	module.exports = _isArguments;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 =
	/*#__PURE__*/
	__webpack_require__(4);
	
	var _isArray =
	/*#__PURE__*/
	__webpack_require__(21);
	
	var _isString =
	/*#__PURE__*/
	__webpack_require__(118);
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @private
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @example
	 *
	 *      _isArrayLike([]); //=> true
	 *      _isArrayLike(true); //=> false
	 *      _isArrayLike({}); //=> false
	 *      _isArrayLike({length: 10}); //=> false
	 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	
	
	var _isArrayLike =
	/*#__PURE__*/
	_curry1(function isArrayLike(x) {
	  if (_isArray(x)) {
	    return true;
	  }
	
	  if (!x) {
	    return false;
	  }
	
	  if (typeof x !== 'object') {
	    return false;
	  }
	
	  if (_isString(x)) {
	    return false;
	  }
	
	  if (x.nodeType === 1) {
	    return !!x.length;
	  }
	
	  if (x.length === 0) {
	    return true;
	  }
	
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	
	  return false;
	});
	
	module.exports = _isArrayLike;

/***/ },
/* 117 */
/***/ function(module, exports) {

	function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	}
	
	module.exports = _isObject;

/***/ },
/* 118 */
/***/ function(module, exports) {

	function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	}
	
	module.exports = _isString;

/***/ },
/* 119 */
/***/ function(module, exports) {

	function _isTransformer(obj) {
	  return obj != null && typeof obj['@@transducer/step'] === 'function';
	}
	
	module.exports = _isTransformer;

/***/ },
/* 120 */
/***/ function(module, exports) {

	function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	
	  return result;
	}
	
	module.exports = _map;

/***/ },
/* 121 */
/***/ function(module, exports) {

	// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function _objectIs(a, b) {
	  // SameValue algorithm
	  if (a === b) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	}
	
	module.exports = typeof Object.is === 'function' ? Object.is : _objectIs;

/***/ },
/* 122 */
/***/ function(module, exports) {

	function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x : {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	}
	
	module.exports = _reduced;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _xfBase =
	/*#__PURE__*/
	__webpack_require__(23);
	
	var XFilter =
	/*#__PURE__*/
	function () {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	
	  XFilter.prototype['@@transducer/step'] = function (result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return XFilter;
	}();
	
	var _xfilter =
	/*#__PURE__*/
	_curry2(function _xfilter(f, xf) {
	  return new XFilter(f, xf);
	});
	
	module.exports = _xfilter;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _reduced =
	/*#__PURE__*/
	__webpack_require__(122);
	
	var _xfBase =
	/*#__PURE__*/
	__webpack_require__(23);
	
	var XFind =
	/*#__PURE__*/
	function () {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	
	  XFind.prototype['@@transducer/result'] = function (result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	
	    return this.xf['@@transducer/result'](result);
	  };
	
	  XFind.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	
	    return result;
	  };
	
	  return XFind;
	}();
	
	var _xfind =
	/*#__PURE__*/
	_curry2(function _xfind(f, xf) {
	  return new XFind(f, xf);
	});
	
	module.exports = _xfind;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _xfBase =
	/*#__PURE__*/
	__webpack_require__(23);
	
	var XMap =
	/*#__PURE__*/
	function () {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	
	  XMap.prototype['@@transducer/step'] = function (result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return XMap;
	}();
	
	var _xmap =
	/*#__PURE__*/
	_curry2(function _xmap(f, xf) {
	  return new XMap(f, xf);
	});
	
	module.exports = _xmap;

/***/ },
/* 126 */
/***/ function(module, exports) {

	var XWrap =
	/*#__PURE__*/
	function () {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	
	  XWrap.prototype['@@transducer/init'] = function () {
	    throw new Error('init not implemented on XWrap');
	  };
	
	  XWrap.prototype['@@transducer/result'] = function (acc) {
	    return acc;
	  };
	
	  XWrap.prototype['@@transducer/step'] = function (acc, x) {
	    return this.f(acc, x);
	  };
	
	  return XWrap;
	}();
	
	function _xwrap(fn) {
	  return new XWrap(fn);
	}
	
	module.exports = _xwrap;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var _dispatchable =
	/*#__PURE__*/
	__webpack_require__(20);
	
	var _map =
	/*#__PURE__*/
	__webpack_require__(120);
	
	var _reduce =
	/*#__PURE__*/
	__webpack_require__(22);
	
	var _xmap =
	/*#__PURE__*/
	__webpack_require__(125);
	
	var curryN =
	/*#__PURE__*/
	__webpack_require__(44);
	
	var keys =
	/*#__PURE__*/
	__webpack_require__(24);
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      const double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	
	
	var map =
	/*#__PURE__*/
	_curry2(
	/*#__PURE__*/
	_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function () {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	
	    case '[object Object]':
	      return _reduce(function (acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	
	    default:
	      return _map(fn, functor);
	  }
	}));
	
	module.exports = map;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 =
	/*#__PURE__*/
	__webpack_require__(107);
	
	var _reduce =
	/*#__PURE__*/
	__webpack_require__(22);
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * [`R.reduced`](#reduced) to shortcut the iteration.
	 *
	 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
	 * is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present. When
	 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
	 * shortcuting, as this is not implemented by `reduce`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *      //          -               -10
	 *      //         / \              / \
	 *      //        -   4           -6   4
	 *      //       / \              / \
	 *      //      -   3   ==>     -3   3
	 *      //     / \              / \
	 *      //    -   2           -1   2
	 *      //   / \              / \
	 *      //  0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	
	
	var reduce =
	/*#__PURE__*/
	_curry3(_reduce);
	
	module.exports = reduce;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var _complement =
	/*#__PURE__*/
	__webpack_require__(105);
	
	var _curry2 =
	/*#__PURE__*/
	__webpack_require__(1);
	
	var filter =
	/*#__PURE__*/
	__webpack_require__(99);
	/**
	 * The complement of [`filter`](#filter).
	 *
	 * Acts as a transducer if a transformer is given in list position. Filterable
	 * objects include plain objects or any object that has a filter method such
	 * as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      const isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	
	
	var reject =
	/*#__PURE__*/
	_curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});
	
	module.exports = reject;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 =
	/*#__PURE__*/
	__webpack_require__(4);
	
	var _has =
	/*#__PURE__*/
	__webpack_require__(10);
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	
	
	var toPairs =
	/*#__PURE__*/
	_curry1(function toPairs(obj) {
	  var pairs = [];
	
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	
	  return pairs;
	});
	
	module.exports = toPairs;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 =
	/*#__PURE__*/
	__webpack_require__(4);
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 *      R.type(() => {}); //=> "Function"
	 *      R.type(undefined); //=> "Undefined"
	 */
	
	
	var type =
	/*#__PURE__*/
	_curry1(function type(val) {
	  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
	});
	
	module.exports = type;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(5),n=__webpack_require__(16),r=__webpack_require__(194);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(132);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 134 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(134);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(5);
	
	var xtend = __webpack_require__(3);
	
	var ReactIs = __webpack_require__(135);
	
	var defaultNodePosition = {
	  start: {
	    line: 1,
	    column: 1,
	    offset: 0
	  },
	  end: {
	    line: 1,
	    column: 1,
	    offset: 0
	  }
	};
	
	function astToReact(node, options) {
	  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	  var renderer = options.renderers[node.type]; // nodes generated by plugins may not have position data
	  // much of the code after this point will attempt to access properties of the node.position
	  // this will set the node position to the parent node's position to prevent errors
	
	  if (node.position === undefined) {
	    node.position = parent.node && parent.node.position || defaultNodePosition;
	  }
	
	  var pos = node.position.start;
	  var key = [node.type, pos.line, pos.column, index].join('-');
	
	  if (!ReactIs.isValidElementType(renderer)) {
	    throw new Error("Renderer for type `".concat(node.type, "` not defined or is not renderable"));
	  }
	
	  var nodeProps = getNodeProps(node, key, options, renderer, parent, index);
	  return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);
	
	  function resolveChildren() {
	    return node.children && node.children.map(function (childNode, i) {
	      return astToReact(childNode, options, {
	        node: node,
	        props: nodeProps
	      }, i);
	    });
	  }
	} // eslint-disable-next-line max-params, complexity
	
	
	function getNodeProps(node, key, opts, renderer, parent, index) {
	  var props = {
	    key: key
	  };
	  var isTagRenderer = typeof renderer === 'string'; // `sourcePos` is true if the user wants source information (line/column info from markdown source)
	
	  if (opts.sourcePos && node.position) {
	    props['data-sourcepos'] = flattenPosition(node.position);
	  }
	
	  if (opts.rawSourcePos && !isTagRenderer) {
	    props.sourcePosition = node.position;
	  } // If `includeNodeIndex` is true, pass node index info to all non-tag renderers
	
	
	  if (opts.includeNodeIndex && parent.node && parent.node.children && !isTagRenderer) {
	    props.index = parent.node.children.indexOf(node);
	    props.parentChildCount = parent.node.children.length;
	  }
	
	  var ref = node.identifier !== null && node.identifier !== undefined ? opts.definitions[node.identifier] || {} : null;
	
	  switch (node.type) {
	    case 'root':
	      assignDefined(props, {
	        className: opts.className
	      });
	      break;
	
	    case 'text':
	      props.nodeKey = key;
	      props.children = node.value;
	      break;
	
	    case 'heading':
	      props.level = node.depth;
	      break;
	
	    case 'list':
	      props.start = node.start;
	      props.ordered = node.ordered;
	      props.tight = !node.loose;
	      props.depth = node.depth;
	      break;
	
	    case 'listItem':
	      props.checked = node.checked;
	      props.tight = !node.loose;
	      props.ordered = node.ordered;
	      props.index = node.index;
	      props.children = getListItemChildren(node, parent).map(function (childNode, i) {
	        return astToReact(childNode, opts, {
	          node: node,
	          props: props
	        }, i);
	      });
	      break;
	
	    case 'definition':
	      assignDefined(props, {
	        identifier: node.identifier,
	        title: node.title,
	        url: node.url
	      });
	      break;
	
	    case 'code':
	      assignDefined(props, {
	        language: node.lang && node.lang.split(/\s/, 1)[0]
	      });
	      break;
	
	    case 'inlineCode':
	      props.children = node.value;
	      props.inline = true;
	      break;
	
	    case 'link':
	      assignDefined(props, {
	        title: node.title || undefined,
	        target: typeof opts.linkTarget === 'function' ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
	        href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
	      });
	      break;
	
	    case 'image':
	      assignDefined(props, {
	        alt: node.alt || undefined,
	        title: node.title || undefined,
	        src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
	      });
	      break;
	
	    case 'linkReference':
	      assignDefined(props, xtend(ref, {
	        href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
	      }));
	      break;
	
	    case 'imageReference':
	      assignDefined(props, {
	        src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
	        title: ref.title || undefined,
	        alt: node.alt || undefined
	      });
	      break;
	
	    case 'table':
	    case 'tableHead':
	    case 'tableBody':
	      props.columnAlignment = node.align;
	      break;
	
	    case 'tableRow':
	      props.isHeader = parent.node.type === 'tableHead';
	      props.columnAlignment = parent.props.columnAlignment;
	      break;
	
	    case 'tableCell':
	      assignDefined(props, {
	        isHeader: parent.props.isHeader,
	        align: parent.props.columnAlignment[index]
	      });
	      break;
	
	    case 'virtualHtml':
	      props.tag = node.tag;
	      break;
	
	    case 'html':
	      // @todo find a better way than this
	      props.isBlock = node.position.start.line !== node.position.end.line;
	      props.escapeHtml = opts.escapeHtml;
	      props.skipHtml = opts.skipHtml;
	      break;
	
	    case 'parsedHtml':
	      {
	        var parsedChildren;
	
	        if (node.children) {
	          parsedChildren = node.children.map(function (child, i) {
	            return astToReact(child, opts, {
	              node: node,
	              props: props
	            }, i);
	          });
	        }
	
	        props.escapeHtml = opts.escapeHtml;
	        props.skipHtml = opts.skipHtml;
	        props.element = mergeNodeChildren(node, parsedChildren);
	        break;
	      }
	
	    default:
	      assignDefined(props, xtend(node, {
	        type: undefined,
	        position: undefined,
	        children: undefined
	      }));
	  }
	
	  if (!isTagRenderer && node.value) {
	    props.value = node.value;
	  }
	
	  return props;
	}
	
	function assignDefined(target, attrs) {
	  for (var key in attrs) {
	    if (typeof attrs[key] !== 'undefined') {
	      target[key] = attrs[key];
	    }
	  }
	}
	
	function mergeNodeChildren(node, parsedChildren) {
	  var el = node.element;
	
	  if (Array.isArray(el)) {
	    var Fragment = React.Fragment || 'div';
	    return React.createElement(Fragment, null, el);
	  }
	
	  if (el.props.children || parsedChildren) {
	    var children = React.Children.toArray(el.props.children).concat(parsedChildren);
	    return React.cloneElement(el, null, children);
	  }
	
	  return React.cloneElement(el, null);
	}
	
	function flattenPosition(pos) {
	  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(String).join('');
	}
	
	function getListItemChildren(node, parent) {
	  if (node.loose) {
	    return node.children;
	  }
	
	  if (parent.node && node.index > 0 && parent.node.children[node.index - 1].loose) {
	    return node.children;
	  }
	
	  return unwrapParagraphs(node);
	}
	
	function unwrapParagraphs(node) {
	  return node.children.reduce(function (array, child) {
	    return array.concat(child.type === 'paragraph' ? child.children || [] : [child]);
	  }, []);
	}
	
	module.exports = astToReact;

/***/ },
/* 137 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function getDefinitions(node) {
	  var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (node.children || []).reduce(function (definitions, child) {
	    if (child.type === 'definition') {
	      definitions[child.identifier] = {
	        href: child.url,
	        title: child.title
	      };
	    }
	
	    return getDefinitions(child, definitions);
	  }, defs);
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var visit = __webpack_require__(8);
	
	exports.ofType = function (types, mode) {
	  return function (node) {
	    types.forEach(function (type) {
	      return visit(node, type, disallow, true);
	    });
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	exports.ifNotMatch = function (allowNode, mode) {
	  return function (node) {
	    visit(node, disallow, true);
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent && !allowNode(node, index, parent)) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	function untangle(node, index, parent, mode) {
	  if (mode === 'remove') {
	    parent.children.splice(index, 1);
	  } else if (mode === 'unwrap') {
	    var args = [index, 1];
	
	    if (node.children) {
	      args = args.concat(node.children);
	    }
	
	    Array.prototype.splice.apply(parent.children, args);
	  }
	}

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Full blown HTML parsing based on htmlparser2.
	 * Pulls in a heavy set of dependencies and thus WILL bloat your bundle size.
	 * You have been warned.
	 **/
	var React = __webpack_require__(5);
	
	var xtend = __webpack_require__(3);
	
	var visit = __webpack_require__(8);
	
	var HtmlToReact = __webpack_require__(71);
	
	var symbols = __webpack_require__(45);
	
	var type = 'parsedHtml';
	var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
	var startTagRe = /^<([a-z]+)\b/i;
	var closingTagRe = /^<\/([a-z]+)\s*>$/;
	var parser = new HtmlToReact.Parser();
	var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
	var defaultConfig = {
	  isValidNode: function isValidNode(node) {
	    return node.type !== 'script';
	  },
	  processingInstructions: [{
	    shouldProcessNode: function shouldProcessNode() {
	      return true;
	    },
	    processNode: processNodeDefinitions.processDefaultNode
	  }]
	};
	
	function parseHtml(config, tree, props) {
	  var open;
	  var currentParent;
	  visit(tree, 'html', function (node, index, parent) {
	    if (props.escapeHtml) {
	      parent.children.splice(index, 1, {
	        type: 'text',
	        position: node.position,
	        value: node.value
	      });
	      return true;
	    }
	
	    if (props.skipHtml) {
	      parent.children.splice(index, 1);
	      return true;
	    }
	
	    if (currentParent !== parent) {
	      open = [];
	      currentParent = parent;
	    }
	
	    var selfClosing = getSelfClosingTagName(node);
	
	    if (selfClosing) {
	      parent.children.splice(index, 1, {
	        type: 'virtualHtml',
	        tag: selfClosing,
	        position: node.position
	      });
	      return true;
	    }
	
	    var current = parseNode(node, config);
	
	    if (!current || current.type === type) {
	      return true;
	    }
	
	    var matching = findAndPull(open, current.tag);
	
	    if (matching) {
	      parent.children.splice(index, 0, parsedHtml(current, matching, parent));
	    } else if (!current.opening) {
	      open.push(current);
	    }
	
	    return true;
	  }, true // Iterate in reverse
	  ); // Find any leftover HTML elements and blindly replace them with a parsed version
	
	  visit(tree, 'html', function (node, index, parent) {
	    var element = parser.parseWithInstructions(node.value, config.isValidNode, config.processingInstructions);
	
	    if (!element) {
	      parent.children.splice(index, 1);
	      return true;
	    }
	
	    parent.children.splice(index, 1, {
	      type: type,
	      element: element,
	      value: node.value,
	      position: node.position
	    });
	    return true;
	  });
	  return tree;
	}
	
	function findAndPull(open, matchingTag) {
	  var i = open.length;
	
	  while (i--) {
	    if (open[i].tag === matchingTag) {
	      return open.splice(i, 1)[0];
	    }
	  }
	
	  return false;
	}
	
	function parseNode(node, config) {
	  var match = node.value.trim().match(closingTagRe);
	
	  if (match) {
	    return {
	      tag: match[1],
	      opening: false,
	      node: node
	    };
	  }
	
	  var el = parser.parseWithInstructions(node.value, config.isValidNode, config.processingInstructions);
	
	  if (!el) {
	    return false;
	  }
	
	  var isMultiple = React.Children.count(el) > 1;
	  var isSelfClosing = !isMultiple && selfClosingRe.test("<".concat(el.type, ">"));
	
	  if (isMultiple || isSelfClosing) {
	    return {
	      type: type,
	      position: node.position,
	      node: el
	    };
	  }
	
	  var startTagMatch = node.value.trim().match(startTagRe);
	  var tag = startTagMatch ? startTagMatch[1] : el.type;
	  return {
	    tag: tag,
	    opening: true,
	    node: node,
	    element: el
	  };
	}
	
	function getSelfClosingTagName(node) {
	  var match = node.value.match(selfClosingRe);
	  return match ? match[1] : false;
	}
	
	function parsedHtml(fromNode, toNode, parent) {
	  var fromIndex = parent.children.indexOf(fromNode.node);
	  var toIndex = parent.children.indexOf(toNode.node);
	  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
	  var children = extracted.slice(1, -1);
	  return {
	    type: type,
	    children: children,
	    tag: fromNode.tag,
	    element: fromNode.element,
	    value: fromNode.node.value,
	    position: {
	      start: fromNode.node.position.start,
	      end: toNode.node.position.end,
	      indent: []
	    }
	  };
	}
	
	module.exports = function getHtmlParserPlugin(config, props) {
	  if (props && (typeof config.source !== 'undefined' || typeof config.children !== 'undefined')) {
	    throw new Error('react-markdown: `html-parser` must be called before use - see https://github.com/rexxars/react-markdown#parsing-html');
	  }
	
	  var htmlConfig = xtend(defaultConfig, config || {});
	  var plugin = parseHtml.bind(null, htmlConfig);
	  plugin.identity = symbols.HtmlParser;
	  return plugin;
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Naive, simple plugin to match inline nodes without attributes
	 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
	 * For proper HTML support, you'll want a different plugin
	 **/
	var visit = __webpack_require__(8);
	
	var type = 'virtualHtml';
	var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
	var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
	
	module.exports = function (tree) {
	  var open;
	  var currentParent;
	  visit(tree, 'html', function (node, index, parent) {
	    if (currentParent !== parent) {
	      open = [];
	      currentParent = parent;
	    }
	
	    var selfClosing = getSelfClosing(node);
	
	    if (selfClosing) {
	      parent.children.splice(index, 1, {
	        type: type,
	        tag: selfClosing,
	        position: node.position
	      });
	      return true;
	    }
	
	    var current = getSimpleTag(node, parent);
	
	    if (!current) {
	      return true;
	    }
	
	    var matching = findAndPull(open, current.tag);
	
	    if (matching) {
	      parent.children.splice(index, 0, virtual(current, matching, parent));
	    } else if (!current.opening) {
	      open.push(current);
	    }
	
	    return true;
	  }, true // Iterate in reverse
	  );
	  return tree;
	};
	
	function findAndPull(open, matchingTag) {
	  var i = open.length;
	
	  while (i--) {
	    if (open[i].tag === matchingTag) {
	      return open.splice(i, 1)[0];
	    }
	  }
	
	  return false;
	}
	
	function getSimpleTag(node, parent) {
	  var match = node.value.match(simpleTagRe);
	  return match ? {
	    tag: match[2],
	    opening: !match[1],
	    node: node
	  } : false;
	}
	
	function getSelfClosing(node) {
	  var match = node.value.match(selfClosingRe);
	  return match ? match[1] : false;
	}
	
	function virtual(fromNode, toNode, parent) {
	  var fromIndex = parent.children.indexOf(fromNode.node);
	  var toIndex = parent.children.indexOf(toNode.node);
	  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
	  var children = extracted.slice(1, -1);
	  return {
	    type: type,
	    children: children,
	    tag: fromNode.tag,
	    position: {
	      start: fromNode.node.position.start,
	      end: toNode.node.position.end,
	      indent: []
	    }
	  };
	}

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var xtend = __webpack_require__(3);
	
	var unified = __webpack_require__(199);
	
	var parse = __webpack_require__(152);
	
	var PropTypes = __webpack_require__(94);
	
	var addListMetadata = __webpack_require__(91);
	
	var naiveHtml = __webpack_require__(140);
	
	var disallowNode = __webpack_require__(138);
	
	var astToReact = __webpack_require__(136);
	
	var wrapTableRows = __webpack_require__(145);
	
	var getDefinitions = __webpack_require__(137);
	
	var uriTransformer = __webpack_require__(143);
	
	var defaultRenderers = __webpack_require__(142);
	
	var symbols = __webpack_require__(45);
	
	var allTypes = Object.keys(defaultRenderers);
	
	var ReactMarkdown = function ReactMarkdown(props) {
	  var src = props.source || props.children || '';
	  var parserOptions = props.parserOptions;
	
	  if (props.allowedTypes && props.disallowedTypes) {
	    throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
	  }
	
	  var renderers = xtend(defaultRenderers, props.renderers);
	  var plugins = [[parse, parserOptions]].concat(props.plugins || []);
	  var parser = plugins.reduce(applyParserPlugin, unified());
	  var rawAst = parser.parse(src);
	  var renderProps = xtend(props, {
	    renderers: renderers,
	    definitions: getDefinitions(rawAst)
	  });
	  var astPlugins = determineAstPlugins(props); // eslint-disable-next-line no-sync
	
	  var transformedAst = parser.runSync(rawAst);
	  var ast = astPlugins.reduce(function (node, plugin) {
	    return plugin(node, renderProps);
	  }, transformedAst);
	  return astToReact(ast, renderProps);
	};
	
	function applyParserPlugin(parser, plugin) {
	  return Array.isArray(plugin) ? parser.use.apply(parser, _toConsumableArray(plugin)) : parser.use(plugin);
	}
	
	function determineAstPlugins(props) {
	  var plugins = [wrapTableRows, addListMetadata()];
	  var disallowedTypes = props.disallowedTypes;
	
	  if (props.allowedTypes) {
	    disallowedTypes = allTypes.filter(function (type) {
	      return type !== 'root' && props.allowedTypes.indexOf(type) === -1;
	    });
	  }
	
	  var removalMethod = props.unwrapDisallowed ? 'unwrap' : 'remove';
	
	  if (disallowedTypes && disallowedTypes.length > 0) {
	    plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
	  }
	
	  if (props.allowNode) {
	    plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
	  }
	
	  var renderHtml = !props.escapeHtml && !props.skipHtml;
	  var hasHtmlParser = (props.astPlugins || []).some(function (item) {
	    var plugin = Array.isArray(item) ? item[0] : item;
	    return plugin.identity === symbols.HtmlParser;
	  });
	
	  if (renderHtml && !hasHtmlParser) {
	    plugins.push(naiveHtml);
	  }
	
	  return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
	}
	
	ReactMarkdown.defaultProps = {
	  renderers: {},
	  escapeHtml: true,
	  skipHtml: false,
	  sourcePos: false,
	  rawSourcePos: false,
	  transformLinkUri: uriTransformer,
	  astPlugins: [],
	  plugins: [],
	  parserOptions: {}
	};
	ReactMarkdown.propTypes = {
	  className: PropTypes.string,
	  source: PropTypes.string,
	  children: PropTypes.string,
	  sourcePos: PropTypes.bool,
	  rawSourcePos: PropTypes.bool,
	  escapeHtml: PropTypes.bool,
	  skipHtml: PropTypes.bool,
	  allowNode: PropTypes.func,
	  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
	  transformImageUri: PropTypes.func,
	  astPlugins: PropTypes.arrayOf(PropTypes.func),
	  unwrapDisallowed: PropTypes.bool,
	  renderers: PropTypes.object,
	  plugins: PropTypes.array,
	  parserOptions: PropTypes.object
	};
	ReactMarkdown.types = allTypes;
	ReactMarkdown.renderers = defaultRenderers;
	ReactMarkdown.uriTransformer = uriTransformer;
	module.exports = ReactMarkdown;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types, react/no-multi-comp */
	'use strict';
	
	var xtend = __webpack_require__(3);
	
	var React = __webpack_require__(5);
	
	var supportsStringRender = parseInt((React.version || '16').slice(0, 2), 10) >= 16;
	var createElement = React.createElement;
	module.exports = {
	  break: 'br',
	  paragraph: 'p',
	  emphasis: 'em',
	  strong: 'strong',
	  thematicBreak: 'hr',
	  blockquote: 'blockquote',
	  delete: 'del',
	  link: 'a',
	  image: 'img',
	  linkReference: 'a',
	  imageReference: 'img',
	  table: SimpleRenderer.bind(null, 'table'),
	  tableHead: SimpleRenderer.bind(null, 'thead'),
	  tableBody: SimpleRenderer.bind(null, 'tbody'),
	  tableRow: SimpleRenderer.bind(null, 'tr'),
	  tableCell: TableCell,
	  root: Root,
	  text: TextRenderer,
	  list: List,
	  listItem: ListItem,
	  definition: NullRenderer,
	  heading: Heading,
	  inlineCode: InlineCode,
	  code: CodeBlock,
	  html: Html,
	  virtualHtml: VirtualHtml,
	  parsedHtml: ParsedHtml
	};
	
	function TextRenderer(props) {
	  return supportsStringRender ? props.children : createElement('span', null, props.children);
	}
	
	function Root(props) {
	  var useFragment = !props.className;
	  var root = useFragment ? React.Fragment || 'div' : 'div';
	  return createElement(root, useFragment ? null : props, props.children);
	}
	
	function SimpleRenderer(tag, props) {
	  return createElement(tag, getCoreProps(props), props.children);
	}
	
	function TableCell(props) {
	  var style = props.align ? {
	    textAlign: props.align
	  } : undefined;
	  var coreProps = getCoreProps(props);
	  return createElement(props.isHeader ? 'th' : 'td', style ? xtend({
	    style: style
	  }, coreProps) : coreProps, props.children);
	}
	
	function Heading(props) {
	  return createElement("h".concat(props.level), getCoreProps(props), props.children);
	}
	
	function List(props) {
	  var attrs = getCoreProps(props);
	
	  if (props.start !== null && props.start !== 1 && props.start !== undefined) {
	    attrs.start = props.start.toString();
	  }
	
	  return createElement(props.ordered ? 'ol' : 'ul', attrs, props.children);
	}
	
	function ListItem(props) {
	  var checkbox = null;
	
	  if (props.checked !== null && props.checked !== undefined) {
	    var checked = props.checked;
	    checkbox = createElement('input', {
	      type: 'checkbox',
	      checked: checked,
	      readOnly: true
	    });
	  }
	
	  return createElement('li', getCoreProps(props), checkbox, props.children);
	}
	
	function CodeBlock(props) {
	  var className = props.language && "language-".concat(props.language);
	  var code = createElement('code', className ? {
	    className: className
	  } : null, props.value);
	  return createElement('pre', getCoreProps(props), code);
	}
	
	function InlineCode(props) {
	  return createElement('code', getCoreProps(props), props.children);
	}
	
	function Html(props) {
	  if (props.skipHtml) {
	    return null;
	  }
	
	  var tag = props.isBlock ? 'div' : 'span';
	
	  if (props.escapeHtml) {
	    var comp = React.Fragment || tag;
	    return createElement(comp, null, props.value);
	  }
	
	  var nodeProps = {
	    dangerouslySetInnerHTML: {
	      __html: props.value
	    }
	  };
	  return createElement(tag, nodeProps);
	}
	
	function ParsedHtml(props) {
	  return props['data-sourcepos'] ? React.cloneElement(props.element, {
	    'data-sourcepos': props['data-sourcepos']
	  }) : props.element;
	}
	
	function VirtualHtml(props) {
	  return createElement(props.tag, getCoreProps(props), props.children);
	}
	
	function NullRenderer() {
	  return null;
	}
	
	function getCoreProps(props) {
	  return props['data-sourcepos'] ? {
	    'data-sourcepos': props['data-sourcepos']
	  } : {};
	}

/***/ },
/* 143 */
/***/ function(module, exports) {

	"use strict";
	
	var protocols = ['http', 'https', 'mailto', 'tel'];
	
	module.exports = function uriTransformer(uri) {
	  var url = (uri || '').trim();
	  var first = url.charAt(0);
	
	  if (first === '#' || first === '/') {
	    return url;
	  }
	
	  var colon = url.indexOf(':');
	
	  if (colon === -1) {
	    return url;
	  }
	
	  var length = protocols.length;
	  var index = -1;
	
	  while (++index < length) {
	    var protocol = protocols[index];
	
	    if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) {
	      return url;
	    }
	  }
	
	  index = url.indexOf('?');
	
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  index = url.indexOf('#');
	
	  if (index !== -1 && colon > index) {
	    return url;
	  } // eslint-disable-next-line no-script-url
	
	
	  return 'javascript:void(0)';
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(3);
	
	var ReactMarkdown = __webpack_require__(141);
	
	var htmlParser = __webpack_require__(139);
	
	var parseHtml = htmlParser();
	
	function ReactMarkdownWithHtml(props) {
	  var astPlugins = [parseHtml].concat(props.astPlugins || []);
	  return ReactMarkdown(xtend(props, {
	    astPlugins: astPlugins
	  }));
	}
	
	ReactMarkdownWithHtml.defaultProps = ReactMarkdown.defaultProps;
	ReactMarkdownWithHtml.propTypes = ReactMarkdown.propTypes;
	ReactMarkdownWithHtml.types = ReactMarkdown.types;
	ReactMarkdownWithHtml.renderers = ReactMarkdown.renderers;
	ReactMarkdownWithHtml.uriTransformer = ReactMarkdown.uriTransformer;
	module.exports = ReactMarkdownWithHtml;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(8);
	
	module.exports = function (node) {
	  visit(node, 'table', wrap);
	  return node;
	};
	
	function wrap(table) {
	  var children = table.children;
	  table.children = [{
	    type: 'tableHead',
	    align: table.align,
	    children: [children[0]],
	    position: children[0].position
	  }];
	
	  if (children.length > 1) {
	    table.children.push({
	      type: 'tableBody',
	      align: table.align,
	      children: children.slice(1),
	      position: {
	        start: children[1].position.start,
	        end: children[children.length - 1].position.end
	      }
	    });
	  }
	}

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(144)


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(149).enable();
	  window.Promise = __webpack_require__(148);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(150);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(16);


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(46);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(46);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 150 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(16),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(198);
	var xtend = __webpack_require__(3);
	var Parser = __webpack_require__(162);
	
	module.exports = parse;
	parse.Parser = Parser;
	
	function parse(options) {
	  var Local = unherit(Parser);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Parser = Local;
	}


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(3);
	var entities = __webpack_require__(17);
	
	module.exports = factory;
	
	/* Factory to create an entity decoder. */
	function factory(ctx) {
	  decoder.raw = decodeRaw;
	
	  return decoder;
	
	  /* Normalize `position` to add an `indent`. */
	  function normalize(position) {
	    var offsets = ctx.offset;
	    var line = position.line;
	    var result = [];
	
	    while (++line) {
	      if (!(line in offsets)) {
	        break;
	      }
	
	      result.push((offsets[line] || 0) + 1);
	    }
	
	    return {
	      start: position,
	      indent: result
	    };
	  }
	
	  /* Handle a warning.
	   * See https://github.com/wooorm/parse-entities
	   * for the warnings. */
	  function handleWarning(reason, position, code) {
	    if (code === 3) {
	      return;
	    }
	
	    ctx.file.message(reason, position);
	  }
	
	  /* Decode `value` (at `position`) into text-nodes. */
	  function decoder(value, position, handler) {
	    entities(value, {
	      position: normalize(position),
	      warning: handleWarning,
	      text: handler,
	      reference: handler,
	      textContext: ctx,
	      referenceContext: ctx
	    });
	  }
	
	  /* Decode `value` (at `position`) into a string. */
	  function decodeRaw(value, position, options) {
	    return entities(value, xtend(options, {
	      position: normalize(position),
	      warning: handleWarning
	    }));
	  }
	}


/***/ },
/* 154 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var index = value.indexOf('\n', fromIndex);
	
	  while (index > fromIndex) {
	    if (value.charAt(index - 1) !== ' ') {
	      break;
	    }
	
	    index--;
	  }
	
	  return index;
	}


/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('`', fromIndex);
	}


/***/ },
/* 156 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('~~', fromIndex);
	}


/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('*', fromIndex);
	  var underscore = value.indexOf('_', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('\\', fromIndex);
	}


/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('**', fromIndex);
	  var underscore = value.indexOf('__', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	var PROTOCOLS = ['https://', 'http://', 'mailto:'];
	
	function locate(value, fromIndex) {
	  var length = PROTOCOLS.length;
	  var index = -1;
	  var min = -1;
	  var position;
	
	  if (!this.options.gfm) {
	    return -1;
	  }
	
	  while (++index < length) {
	    position = value.indexOf(PROTOCOLS[index], fromIndex);
	
	    if (position !== -1 && (position < min || min === -1)) {
	      min = position;
	    }
	  }
	
	  return min;
	}


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(3);
	var removePosition = __webpack_require__(201);
	
	module.exports = parse;
	
	var C_NEWLINE = '\n';
	var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
	
	/* Parse the bound file. */
	function parse() {
	  var self = this;
	  var value = String(self.file);
	  var start = {line: 1, column: 1, offset: 0};
	  var content = xtend(start);
	  var node;
	
	  /* Clean non-unix newlines: `\r\n` and `\r` are all
	   * changed to `\n`.  This should not affect positional
	   * information. */
	  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
	
	  if (value.charCodeAt(0) === 0xFEFF) {
	    value = value.slice(1);
	
	    content.column++;
	    content.offset++;
	  }
	
	  node = {
	    type: 'root',
	    children: self.tokenizeBlock(value, content),
	    position: {
	      start: start,
	      end: self.eof || xtend(start)
	    }
	  };
	
	  if (!self.options.position) {
	    removePosition(node, true);
	  }
	
	  return node;
	}


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(3);
	var toggle = __webpack_require__(195);
	var vfileLocation = __webpack_require__(205);
	var unescape = __webpack_require__(190);
	var decode = __webpack_require__(153);
	var tokenizer = __webpack_require__(189);
	
	module.exports = Parser;
	
	function Parser(doc, file) {
	  this.file = file;
	  this.offset = {};
	  this.options = xtend(this.options);
	  this.setOptions({});
	
	  this.inList = false;
	  this.inBlock = false;
	  this.inLink = false;
	  this.atStart = true;
	
	  this.toOffset = vfileLocation(file).toOffset;
	  this.unescape = unescape(this, 'escape');
	  this.decode = decode(this);
	}
	
	var proto = Parser.prototype;
	
	/* Expose core. */
	proto.setOptions = __webpack_require__(163);
	proto.parse = __webpack_require__(161);
	
	/* Expose `defaults`. */
	proto.options = __webpack_require__(47);
	
	/* Enter and exit helpers. */
	proto.exitStart = toggle('atStart', true);
	proto.enterList = toggle('inList', false);
	proto.enterLink = toggle('inLink', false);
	proto.enterBlock = toggle('inBlock', false);
	
	/* Nodes that can interupt a paragraph:
	 *
	 * ```markdown
	 * A paragraph, followed by a thematic break.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the paragraph. */
	proto.interruptParagraph = [
	  ['thematicBreak'],
	  ['atxHeading'],
	  ['fencedCode'],
	  ['blockquote'],
	  ['html'],
	  ['setextHeading', {commonmark: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a list:
	 *
	 * ```markdown
	 * - One
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the list. */
	proto.interruptList = [
	  ['atxHeading', {pedantic: false}],
	  ['fencedCode', {pedantic: false}],
	  ['thematicBreak', {pedantic: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a blockquote:
	 *
	 * ```markdown
	 * > A paragraph.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the blockquote. */
	proto.interruptBlockquote = [
	  ['indentedCode', {commonmark: true}],
	  ['fencedCode', {commonmark: true}],
	  ['atxHeading', {commonmark: true}],
	  ['setextHeading', {commonmark: true}],
	  ['thematicBreak', {commonmark: true}],
	  ['html', {commonmark: true}],
	  ['list', {commonmark: true}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Handlers. */
	proto.blockTokenizers = {
	  newline: __webpack_require__(181),
	  indentedCode: __webpack_require__(168),
	  fencedCode: __webpack_require__(167),
	  blockquote: __webpack_require__(165),
	  atxHeading: __webpack_require__(175),
	  thematicBreak: __webpack_require__(187),
	  list: __webpack_require__(180),
	  setextHeading: __webpack_require__(176),
	  html: __webpack_require__(177),
	  footnote: __webpack_require__(174),
	  definition: __webpack_require__(170),
	  table: __webpack_require__(185),
	  paragraph: __webpack_require__(182)
	};
	
	proto.inlineTokenizers = {
	  escape: __webpack_require__(173),
	  autoLink: __webpack_require__(164),
	  url: __webpack_require__(188),
	  html: __webpack_require__(178),
	  link: __webpack_require__(179),
	  reference: __webpack_require__(183),
	  strong: __webpack_require__(184),
	  emphasis: __webpack_require__(172),
	  deletion: __webpack_require__(171),
	  code: __webpack_require__(169),
	  break: __webpack_require__(166),
	  text: __webpack_require__(186)
	};
	
	/* Expose precedence. */
	proto.blockMethods = keys(proto.blockTokenizers);
	proto.inlineMethods = keys(proto.inlineTokenizers);
	
	/* Tokenizers. */
	proto.tokenizeBlock = tokenizer('block');
	proto.tokenizeInline = tokenizer('inline');
	proto.tokenizeFactory = tokenizer;
	
	/* Get all keys in `value`. */
	function keys(value) {
	  var result = [];
	  var key;
	
	  for (key in value) {
	    result.push(key);
	  }
	
	  return result;
	}


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(3);
	var escapes = __webpack_require__(90);
	var defaults = __webpack_require__(47);
	
	module.exports = setOptions;
	
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var key;
	  var value;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error(
	      'Invalid value `' + options + '` ' +
	      'for setting `options`'
	    );
	  }
	
	  for (key in defaults) {
	    value = options[key];
	
	    if (value == null) {
	      value = current[key];
	    }
	
	    if (
	      (key !== 'blocks' && typeof value !== 'boolean') ||
	      (key === 'blocks' && typeof value !== 'object')
	    ) {
	      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
	    }
	
	    options[key] = value;
	  }
	
	  self.options = options;
	  self.escape = escapes(options);
	
	  return self;
	}


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	var decode = __webpack_require__(17);
	var locate = __webpack_require__(49);
	
	module.exports = autoLink;
	autoLink.locator = locate;
	autoLink.notInLink = true;
	
	var C_LT = '<';
	var C_GT = '>';
	var C_AT_SIGN = '@';
	var C_SLASH = '/';
	var MAILTO = 'mailto:';
	var MAILTO_LENGTH = MAILTO.length;
	
	/* Tokenise a link. */
	function autoLink(eat, value, silent) {
	  var self;
	  var subvalue;
	  var length;
	  var index;
	  var queue;
	  var character;
	  var hasAtCharacter;
	  var link;
	  var now;
	  var content;
	  var tokenizers;
	  var exit;
	
	  if (value.charAt(0) !== C_LT) {
	    return;
	  }
	
	  self = this;
	  subvalue = '';
	  length = value.length;
	  index = 0;
	  queue = '';
	  hasAtCharacter = false;
	  link = '';
	
	  index++;
	  subvalue = C_LT;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      whitespace(character) ||
	      character === C_GT ||
	      character === C_AT_SIGN ||
	      (character === ':' && value.charAt(index + 1) === C_SLASH)
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  link += queue;
	  queue = '';
	
	  character = value.charAt(index);
	  link += character;
	  index++;
	
	  if (character === C_AT_SIGN) {
	    hasAtCharacter = true;
	  } else {
	    if (
	      character !== ':' ||
	      value.charAt(index + 1) !== C_SLASH
	    ) {
	      return;
	    }
	
	    link += C_SLASH;
	    index++;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_GT) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!queue || character !== C_GT) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  link += queue;
	  content = link;
	  subvalue += link + character;
	  now = eat.now();
	  now.column++;
	  now.offset++;
	
	  if (hasAtCharacter) {
	    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
	      content = content.substr(MAILTO_LENGTH);
	      now.column += MAILTO_LENGTH;
	      now.offset += MAILTO_LENGTH;
	    } else {
	      link = MAILTO + link;
	    }
	  }
	
	  /* Temporarily remove all tokenizers except text in autolinks. */
	  tokenizers = self.inlineTokenizers;
	  self.inlineTokenizers = {text: tokenizers.text};
	
	  exit = self.enterLink();
	
	  content = self.tokenizeInline(content, now);
	
	  self.inlineTokenizers = tokenizers;
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(link, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(6);
	var interrupt = __webpack_require__(25);
	
	module.exports = blockquote;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_GT = '>';
	
	/* Tokenise a blockquote. */
	function blockquote(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptBlockquote;
	  var now = eat.now();
	  var currentLine = now.line;
	  var length = value.length;
	  var values = [];
	  var contents = [];
	  var indents = [];
	  var add;
	  var index = 0;
	  var character;
	  var rest;
	  var nextIndex;
	  var content;
	  var line;
	  var startIndex;
	  var prefixed;
	  var exit;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_GT) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      index++;
	    }
	
	    if (value.charAt(index) === C_GT) {
	      index++;
	      prefixed = true;
	
	      if (value.charAt(index) === C_SPACE) {
	        index++;
	      }
	    } else {
	      index = startIndex;
	    }
	
	    content = value.slice(index, nextIndex);
	
	    if (!prefixed && !trim(content)) {
	      index = startIndex;
	      break;
	    }
	
	    if (!prefixed) {
	      rest = value.slice(index);
	
	      /* Check if the following code contains a possible
	       * block. */
	      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
	        break;
	      }
	    }
	
	    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
	
	    indents.push(index - startIndex);
	    values.push(line);
	    contents.push(content);
	
	    index = nextIndex + 1;
	  }
	
	  index = -1;
	  length = indents.length;
	  add = eat(values.join(C_NEWLINE));
	
	  while (++index < length) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
	    currentLine++;
	  }
	
	  exit = self.enterBlock();
	  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
	  exit();
	
	  return add({
	    type: 'blockquote',
	    children: contents
	  });
	}


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(154);
	
	module.exports = hardBreak;
	hardBreak.locator = locate;
	
	var MIN_BREAK_LENGTH = 2;
	
	function hardBreak(eat, value, silent) {
	  var length = value.length;
	  var index = -1;
	  var queue = '';
	  var character;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === '\n') {
	      if (index < MIN_BREAK_LENGTH) {
	        return;
	      }
	
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      queue += character;
	
	      return eat(queue)({type: 'break'});
	    }
	
	    if (character !== ' ') {
	      return;
	    }
	
	    queue += character;
	  }
	}


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(28);
	
	module.exports = fencedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_TILDE = '~';
	var C_TICK = '`';
	
	var MIN_FENCE_COUNT = 3;
	var CODE_INDENT_COUNT = 4;
	
	function fencedCode(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = 0;
	  var subvalue = '';
	  var fenceCount;
	  var marker;
	  var character;
	  var flag;
	  var queue;
	  var content;
	  var exdentedContent;
	  var closing;
	  var exdentedClosing;
	  var indent;
	  var now;
	
	  if (!settings.gfm) {
	    return;
	  }
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  indent = index;
	
	  /* Eat the fence. */
	  character = value.charAt(index);
	
	  if (character !== C_TILDE && character !== C_TICK) {
	    return;
	  }
	
	  index++;
	  marker = character;
	  fenceCount = 1;
	  subvalue += character;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      break;
	    }
	
	    subvalue += character;
	    fenceCount++;
	    index++;
	  }
	
	  if (fenceCount < MIN_FENCE_COUNT) {
	    return;
	  }
	
	  /* Eat spacing before flag. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat flag. */
	  flag = '';
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_NEWLINE ||
	      character === C_TILDE ||
	      character === C_TICK
	    ) {
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      flag += queue + character;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character && character !== C_NEWLINE) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	
	  subvalue += flag;
	  flag = self.decode.raw(self.unescape(flag), now);
	
	  if (queue) {
	    subvalue += queue;
	  }
	
	  queue = '';
	  closing = '';
	  exdentedClosing = '';
	  content = '';
	  exdentedContent = '';
	
	  /* Eat content. */
	  while (index < length) {
	    character = value.charAt(index);
	    content += closing;
	    exdentedContent += exdentedClosing;
	    closing = '';
	    exdentedClosing = '';
	
	    if (character !== C_NEWLINE) {
	      content += character;
	      exdentedClosing += character;
	      index++;
	      continue;
	    }
	
	    /* Add the newline to `subvalue` if its the first
	     * character.  Otherwise, add it to the `closing`
	     * queue. */
	    if (content) {
	      closing += character;
	      exdentedClosing += character;
	    } else {
	      subvalue += character;
	    }
	
	    queue = '';
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue.slice(indent);
	
	    if (queue.length >= CODE_INDENT_COUNT) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue;
	
	    if (queue.length < fenceCount) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      closing += character;
	      exdentedClosing += character;
	      index++;
	    }
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	  }
	
	  subvalue += content + closing;
	
	  return eat(subvalue)({
	    type: 'code',
	    lang: flag || null,
	    value: trim(exdentedContent)
	  });
	}


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(27);
	var trim = __webpack_require__(28);
	
	module.exports = indentedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var CODE_INDENT_COUNT = 4;
	var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
	
	/* Tokenise indented code. */
	function indentedCode(eat, value, silent) {
	  var index = -1;
	  var length = value.length;
	  var subvalue = '';
	  var content = '';
	  var subvalueQueue = '';
	  var contentQueue = '';
	  var character;
	  var blankQueue;
	  var indent;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (indent) {
	      indent = false;
	
	      subvalue += subvalueQueue;
	      content += contentQueue;
	      subvalueQueue = '';
	      contentQueue = '';
	
	      if (character === C_NEWLINE) {
	        subvalueQueue = character;
	        contentQueue = character;
	      } else {
	        subvalue += character;
	        content += character;
	
	        while (++index < length) {
	          character = value.charAt(index);
	
	          if (!character || character === C_NEWLINE) {
	            contentQueue = character;
	            subvalueQueue = character;
	            break;
	          }
	
	          subvalue += character;
	          content += character;
	        }
	      }
	    } else if (
	      character === C_SPACE &&
	      value.charAt(index + 1) === character &&
	      value.charAt(index + 2) === character &&
	      value.charAt(index + 3) === character
	    ) {
	      subvalueQueue += CODE_INDENT;
	      index += 3;
	      indent = true;
	    } else if (character === C_TAB) {
	      subvalueQueue += character;
	      indent = true;
	    } else {
	      blankQueue = '';
	
	      while (character === C_TAB || character === C_SPACE) {
	        blankQueue += character;
	        character = value.charAt(++index);
	      }
	
	      if (character !== C_NEWLINE) {
	        break;
	      }
	
	      subvalueQueue += blankQueue + character;
	      contentQueue += character;
	    }
	  }
	
	  if (content) {
	    if (silent) {
	      return true;
	    }
	
	    return eat(subvalue)({
	      type: 'code',
	      lang: null,
	      value: trim(content)
	    });
	  }
	}


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	var locate = __webpack_require__(155);
	
	module.exports = inlineCode;
	inlineCode.locator = locate;
	
	var C_TICK = '`';
	
	/* Tokenise inline code. */
	function inlineCode(eat, value, silent) {
	  var length = value.length;
	  var index = 0;
	  var queue = '';
	  var tickQueue = '';
	  var contentQueue;
	  var subqueue;
	  var count;
	  var openingCount;
	  var subvalue;
	  var character;
	  var found;
	  var next;
	
	  while (index < length) {
	    if (value.charAt(index) !== C_TICK) {
	      break;
	    }
	
	    queue += C_TICK;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue = queue;
	  openingCount = index;
	  queue = '';
	  next = value.charAt(index);
	  count = 0;
	
	  while (index < length) {
	    character = next;
	    next = value.charAt(index + 1);
	
	    if (character === C_TICK) {
	      count++;
	      tickQueue += character;
	    } else {
	      count = 0;
	      queue += character;
	    }
	
	    if (count && next !== C_TICK) {
	      if (count === openingCount) {
	        subvalue += queue + tickQueue;
	        found = true;
	        break;
	      }
	
	      queue += tickQueue;
	      tickQueue = '';
	    }
	
	    index++;
	  }
	
	  if (!found) {
	    if (openingCount % 2 !== 0) {
	      return;
	    }
	
	    queue = '';
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  contentQueue = '';
	  subqueue = '';
	  length = queue.length;
	  index = -1;
	
	  while (++index < length) {
	    character = queue.charAt(index);
	
	    if (whitespace(character)) {
	      subqueue += character;
	      continue;
	    }
	
	    if (subqueue) {
	      if (contentQueue) {
	        contentQueue += subqueue;
	      }
	
	      subqueue = '';
	    }
	
	    contentQueue += character;
	  }
	
	  return eat(subvalue)({
	    type: 'inlineCode',
	    value: contentQueue
	  });
	}


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	var normalize = __webpack_require__(26);
	
	module.exports = definition;
	definition.notInList = true;
	definition.notInBlock = true;
	
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_COLON = ':';
	var C_LT = '<';
	var C_GT = '>';
	
	function definition(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var beforeURL;
	  var beforeTitle;
	  var queue;
	  var character;
	  var test;
	  var identifier;
	  var url;
	  var title;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  identifier = queue;
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isEnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === isEnclosedURLCharacter.delimiter) {
	      subvalue += C_LT + queue + character;
	      index++;
	    } else {
	      if (commonmark) {
	        return;
	      }
	
	      index -= queue.length + 1;
	      queue = '';
	    }
	  }
	
	  if (!queue) {
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isUnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    subvalue += queue;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  url = queue;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  test = null;
	
	  if (character === C_DOUBLE_QUOTE) {
	    test = C_DOUBLE_QUOTE;
	  } else if (character === C_SINGLE_QUOTE) {
	    test = C_SINGLE_QUOTE;
	  } else if (character === C_PAREN_OPEN) {
	    test = C_PAREN_CLOSE;
	  }
	
	  if (!test) {
	    queue = '';
	    index = subvalue.length;
	  } else if (queue) {
	    subvalue += queue + character;
	    index = subvalue.length;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === test) {
	        break;
	      }
	
	      if (character === C_NEWLINE) {
	        index++;
	        character = value.charAt(index);
	
	        if (character === C_NEWLINE || character === test) {
	          return;
	        }
	
	        queue += C_NEWLINE;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character !== test) {
	      return;
	    }
	
	    beforeTitle = subvalue;
	    subvalue += queue + character;
	    index++;
	    title = queue;
	    queue = '';
	  } else {
	    return;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!character || character === C_NEWLINE) {
	    if (silent) {
	      return true;
	    }
	
	    beforeURL = eat(beforeURL).test().end;
	    url = self.decode.raw(self.unescape(url), beforeURL, {nonTerminated: false});
	
	    if (title) {
	      beforeTitle = eat(beforeTitle).test().end;
	      title = self.decode.raw(self.unescape(title), beforeTitle);
	    }
	
	    return eat(subvalue)({
	      type: 'definition',
	      identifier: normalize(identifier),
	      title: title || null,
	      url: url
	    });
	  }
	}
	
	/* Check if `character` can be inside an enclosed URI. */
	function isEnclosedURLCharacter(character) {
	  return character !== C_GT &&
	    character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE;
	}
	
	isEnclosedURLCharacter.delimiter = C_GT;
	
	/* Check if `character` can be inside an unclosed URI. */
	function isUnclosedURLCharacter(character) {
	  return character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE &&
	    !whitespace(character);
	}


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	var locate = __webpack_require__(156);
	
	module.exports = strikethrough;
	strikethrough.locator = locate;
	
	var C_TILDE = '~';
	var DOUBLE = '~~';
	
	function strikethrough(eat, value, silent) {
	  var self = this;
	  var character = '';
	  var previous = '';
	  var preceding = '';
	  var subvalue = '';
	  var index;
	  var length;
	  var now;
	
	  if (
	    !self.options.gfm ||
	    value.charAt(0) !== C_TILDE ||
	    value.charAt(1) !== C_TILDE ||
	    whitespace(value.charAt(2))
	  ) {
	    return;
	  }
	
	  index = 1;
	  length = value.length;
	  now = eat.now();
	  now.column += 2;
	  now.offset += 2;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_TILDE &&
	      previous === C_TILDE &&
	      (!preceding || !whitespace(preceding))
	    ) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      return eat(DOUBLE + subvalue + DOUBLE)({
	        type: 'delete',
	        children: self.tokenizeInline(subvalue, now)
	      });
	    }
	
	    subvalue += previous;
	    preceding = previous;
	    previous = character;
	  }
	}


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(6);
	var word = __webpack_require__(83);
	var whitespace = __webpack_require__(2);
	var locate = __webpack_require__(157);
	
	module.exports = emphasis;
	emphasis.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function emphasis(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  subvalue = character;
	  marker = character;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (character === marker && (!pedantic || !whitespace(prev))) {
	      character = value.charAt(++index);
	
	      if (character !== marker) {
	        if (!trim(queue) || prev === marker) {
	          return;
	        }
	
	        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
	          queue += marker;
	          continue;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column++;
	        now.offset++;
	
	        return eat(subvalue + queue + marker)({
	          type: 'emphasis',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	
	      queue += marker;
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(158);
	
	module.exports = escape;
	escape.locator = locate;
	
	function escape(eat, value, silent) {
	  var self = this;
	  var character;
	  var node;
	
	  if (value.charAt(0) === '\\') {
	    character = value.charAt(1);
	
	    if (self.escape.indexOf(character) !== -1) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      if (character === '\n') {
	        node = {type: 'break'};
	      } else {
	        node = {
	          type: 'text',
	          value: character
	        };
	      }
	
	      return eat('\\' + character)(node);
	    }
	  }
	}


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	var normalize = __webpack_require__(26);
	
	module.exports = footnoteDefinition;
	footnoteDefinition.notInList = true;
	footnoteDefinition.notInBlock = true;
	
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_CARET = '^';
	var C_COLON = ':';
	
	var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
	
	function footnoteDefinition(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var index;
	  var length;
	  var subvalue;
	  var now;
	  var currentLine;
	  var content;
	  var queue;
	  var subqueue;
	  var character;
	  var identifier;
	  var add;
	  var exit;
	
	  if (!self.options.footnotes) {
	    return;
	  }
	
	  index = 0;
	  length = value.length;
	  subvalue = '';
	  now = eat.now();
	  currentLine = now.line;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  if (
	    value.charAt(index) !== C_BRACKET_OPEN ||
	    value.charAt(index + 1) !== C_CARET
	  ) {
	    return;
	  }
	
	  subvalue += C_BRACKET_OPEN + C_CARET;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  identifier = normalize(queue);
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  queue = '';
	  content = '';
	  subqueue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      subqueue = character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_NEWLINE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      queue += subqueue;
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_SPACE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      if (subqueue.length === 0) {
	        break;
	      }
	
	      queue += subqueue;
	    }
	
	    if (queue) {
	      content += queue;
	      queue = '';
	    }
	
	    content += character;
	    index++;
	  }
	
	  subvalue += content;
	
	  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
	    currentLine++;
	
	    return '';
	  });
	
	  add = eat(subvalue);
	
	  exit = self.enterBlock();
	  content = self.tokenizeBlock(content, now);
	  exit();
	
	  return add({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: content
	  });
	}


/***/ },
/* 175 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = atxHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_HASH = '#';
	
	var MAX_ATX_COUNT = 6;
	
	function atxHeading(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = -1;
	  var now = eat.now();
	  var subvalue = '';
	  var content = '';
	  var character;
	  var queue;
	  var depth;
	
	  /* Eat initial spacing. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat hashes. */
	  depth = 0;
	
	  while (++index <= length) {
	    character = value.charAt(index);
	
	    if (character !== C_HASH) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	    depth++;
	  }
	
	  if (depth > MAX_ATX_COUNT) {
	    return;
	  }
	
	  if (
	    !depth ||
	    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
	  ) {
	    return;
	  }
	
	  length = value.length + 1;
	
	  /* Eat intermediate white-space. */
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  /* Exit when not in pedantic mode without spacing. */
	  if (
	    !settings.pedantic &&
	    queue.length === 0 &&
	    character &&
	    character !== C_NEWLINE
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  /* Eat content. */
	  subvalue += queue;
	  queue = '';
	  content = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	
	    if (
	      character !== C_SPACE &&
	      character !== C_TAB &&
	      character !== C_HASH
	    ) {
	      content += queue + character;
	      queue = '';
	      continue;
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_HASH) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    index--;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  return eat(subvalue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ },
/* 176 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = setextHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_EQUALS = '=';
	var C_DASH = '-';
	
	var MAX_HEADING_INDENT = 3;
	
	/* Map of characters which can be used to mark setext
	 * headers, mapping to their corresponding depth. */
	var SETEXT_MARKERS = {};
	
	SETEXT_MARKERS[C_EQUALS] = 1;
	SETEXT_MARKERS[C_DASH] = 2;
	
	function setextHeading(eat, value, silent) {
	  var self = this;
	  var now = eat.now();
	  var length = value.length;
	  var index = -1;
	  var subvalue = '';
	  var content;
	  var queue;
	  var character;
	  var marker;
	  var depth;
	
	  /* Eat initial indentation. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat content. */
	  content = '';
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      index--;
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      content += queue + character;
	      queue = '';
	    }
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  /* Ensure the content is followed by a newline and a
	   * valid marker. */
	  character = value.charAt(++index);
	  marker = value.charAt(++index);
	
	  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
	    return;
	  }
	
	  subvalue += character;
	
	  /* Eat Setext-line. */
	  queue = marker;
	  depth = SETEXT_MARKERS[marker];
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      if (character !== C_NEWLINE) {
	        return;
	      }
	
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  return eat(subvalue + queue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var openCloseTag = __webpack_require__(51).openCloseTag;
	
	module.exports = blockHTML;
	
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_LT = '<';
	
	function blockHTML(eat, value, silent) {
	  var self = this;
	  var blocks = self.options.blocks;
	  var length = value.length;
	  var index = 0;
	  var next;
	  var line;
	  var offset;
	  var character;
	  var count;
	  var sequence;
	  var subvalue;
	
	  var sequences = [
	    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
	    [/^<!--/, /-->/, true],
	    [/^<\?/, /\?>/, true],
	    [/^<![A-Za-z]/, />/, true],
	    [/^<!\[CDATA\[/, /\]\]>/, true],
	    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
	    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
	  ];
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_LT) {
	    return;
	  }
	
	  next = value.indexOf(C_NEWLINE, index + 1);
	  next = next === -1 ? length : next;
	  line = value.slice(index, next);
	  offset = -1;
	  count = sequences.length;
	
	  while (++offset < count) {
	    if (sequences[offset][0].test(line)) {
	      sequence = sequences[offset];
	      break;
	    }
	  }
	
	  if (!sequence) {
	    return;
	  }
	
	  if (silent) {
	    return sequence[2];
	  }
	
	  index = next;
	
	  if (!sequence[1].test(line)) {
	    while (index < length) {
	      next = value.indexOf(C_NEWLINE, index + 1);
	      next = next === -1 ? length : next;
	      line = value.slice(index + 1, next);
	
	      if (sequence[1].test(line)) {
	        if (line) {
	          index = next;
	        }
	
	        break;
	      }
	
	      index = next;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabetical = __webpack_require__(41);
	var locate = __webpack_require__(49);
	var tag = __webpack_require__(51).tag;
	
	module.exports = inlineHTML;
	inlineHTML.locator = locate;
	
	var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
	var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
	
	function inlineHTML(eat, value, silent) {
	  var self = this;
	  var length = value.length;
	  var character;
	  var subvalue;
	
	  if (value.charAt(0) !== '<' || length < 3) {
	    return;
	  }
	
	  character = value.charAt(1);
	
	  if (
	    !alphabetical(character) &&
	    character !== '?' &&
	    character !== '!' &&
	    character !== '/'
	  ) {
	    return;
	  }
	
	  subvalue = value.match(tag);
	
	  if (!subvalue) {
	    return;
	  }
	
	  /* istanbul ignore if - not used yet. */
	  if (silent) {
	    return true;
	  }
	
	  subvalue = subvalue[0];
	
	  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
	    self.inLink = true;
	  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
	    self.inLink = false;
	  }
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	var locate = __webpack_require__(48);
	
	module.exports = link;
	link.locator = locate;
	
	var own = {}.hasOwnProperty;
	
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_GT = '>';
	var C_TICK = '`';
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	
	/* Map of characters, which can be used to mark link
	 * and image titles. */
	var LINK_MARKERS = {};
	
	LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	
	/* Map of characters, which can be used to mark link
	 * and image titles in commonmark-mode. */
	var COMMONMARK_LINK_MARKERS = {};
	
	COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
	
	function link(eat, value, silent) {
	  var self = this;
	  var subvalue = '';
	  var index = 0;
	  var character = value.charAt(0);
	  var pedantic = self.options.pedantic;
	  var commonmark = self.options.commonmark;
	  var gfm = self.options.gfm;
	  var closed;
	  var count;
	  var opening;
	  var beforeURL;
	  var beforeTitle;
	  var subqueue;
	  var hasMarker;
	  var markers;
	  var isImage;
	  var content;
	  var marker;
	  var length;
	  var title;
	  var depth;
	  var queue;
	  var url;
	  var now;
	  var exit;
	  var node;
	
	  /* Detect whether this is an image. */
	  if (character === '!') {
	    isImage = true;
	    subvalue = character;
	    character = value.charAt(++index);
	  }
	
	  /* Eat the opening. */
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  /* Exit when this is a link and we’re already inside
	   * a link. */
	  if (!isImage && self.inLink) {
	    return;
	  }
	
	  subvalue += character;
	  queue = '';
	  index++;
	
	  /* Eat the content. */
	  length = value.length;
	  now = eat.now();
	  depth = 0;
	
	  now.column += index;
	  now.offset += index;
	
	  while (index < length) {
	    character = value.charAt(index);
	    subqueue = character;
	
	    if (character === C_TICK) {
	      /* Inline-code in link content. */
	      count = 1;
	
	      while (value.charAt(index + 1) === C_TICK) {
	        subqueue += character;
	        index++;
	        count++;
	      }
	
	      if (!opening) {
	        opening = count;
	      } else if (count >= opening) {
	        opening = 0;
	      }
	    } else if (character === C_BACKSLASH) {
	      /* Allow brackets to be escaped. */
	      index++;
	      subqueue += value.charAt(index);
	    /* In GFM mode, brackets in code still count.
	     * In all other modes, they don’t.  This empty
	     * block prevents the next statements are
	     * entered. */
	    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
	      depth++;
	    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
	      if (depth) {
	        depth--;
	      } else {
	        /* Allow white-space between content and
	         * url in GFM mode. */
	        if (!pedantic) {
	          while (index < length) {
	            character = value.charAt(index + 1);
	
	            if (!whitespace(character)) {
	              break;
	            }
	
	            subqueue += character;
	            index++;
	          }
	        }
	
	        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
	          return;
	        }
	
	        subqueue += C_PAREN_OPEN;
	        closed = true;
	        index++;
	
	        break;
	      }
	    }
	
	    queue += subqueue;
	    subqueue = '';
	    index++;
	  }
	
	  /* Eat the content closing. */
	  if (!closed) {
	    return;
	  }
	
	  content = queue;
	  subvalue += queue + subqueue;
	  index++;
	
	  /* Eat white-space. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat the URL. */
	  character = value.charAt(index);
	  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	    beforeURL += C_LT;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_GT) {
	        break;
	      }
	
	      if (commonmark && character === '\n') {
	        return;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    if (value.charAt(index) !== C_GT) {
	      return;
	    }
	
	    subvalue += C_LT + queue + C_GT;
	    url = queue;
	    index++;
	  } else {
	    character = null;
	    subqueue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (subqueue && own.call(markers, character)) {
	        break;
	      }
	
	      if (whitespace(character)) {
	        if (!pedantic) {
	          break;
	        }
	
	        subqueue += character;
	      } else {
	        if (character === C_PAREN_OPEN) {
	          depth++;
	        } else if (character === C_PAREN_CLOSE) {
	          if (depth === 0) {
	            break;
	          }
	
	          depth--;
	        }
	
	        queue += subqueue;
	        subqueue = '';
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        queue += character;
	      }
	
	      index++;
	    }
	
	    subvalue += queue;
	    url = queue;
	    index = subvalue.length;
	  }
	
	  /* Eat white-space. */
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  subvalue += queue;
	
	  /* Eat the title. */
	  if (queue && own.call(markers, character)) {
	    index++;
	    subvalue += character;
	    queue = '';
	    marker = markers[character];
	    beforeTitle = subvalue;
	
	    /* In commonmark-mode, things are pretty easy: the
	     * marker cannot occur inside the title.
	     *
	     * Non-commonmark does, however, support nested
	     * delimiters. */
	    if (commonmark) {
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          break;
	        }
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        index++;
	        queue += character;
	      }
	
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        return;
	      }
	
	      title = queue;
	      subvalue += queue + character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (!whitespace(character)) {
	          break;
	        }
	
	        subvalue += character;
	        index++;
	      }
	    } else {
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          if (hasMarker) {
	            queue += marker + subqueue;
	            subqueue = '';
	          }
	
	          hasMarker = true;
	        } else if (!hasMarker) {
	          queue += character;
	        } else if (character === C_PAREN_CLOSE) {
	          subvalue += queue + marker + subqueue;
	          title = queue;
	          break;
	        } else if (whitespace(character)) {
	          subqueue += character;
	        } else {
	          queue += marker + subqueue + character;
	          subqueue = '';
	          hasMarker = false;
	        }
	
	        index++;
	      }
	    }
	  }
	
	  if (value.charAt(index) !== C_PAREN_CLOSE) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  subvalue += C_PAREN_CLOSE;
	
	  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {nonTerminated: false});
	
	  if (title) {
	    beforeTitle = eat(beforeTitle).test().end;
	    title = self.decode.raw(self.unescape(title), beforeTitle);
	  }
	
	  node = {
	    type: isImage ? 'image' : 'link',
	    title: title || null,
	    url: url
	  };
	
	  if (isImage) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  } else {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  }
	
	  return eat(subvalue)(node);
	}


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable max-params */
	
	var trim = __webpack_require__(6);
	var repeat = __webpack_require__(27);
	var decimal = __webpack_require__(9);
	var getIndent = __webpack_require__(50);
	var removeIndent = __webpack_require__(191);
	var interrupt = __webpack_require__(25);
	
	module.exports = list;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_PLUS = '+';
	var C_DASH = '-';
	var C_DOT = '.';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_PAREN_CLOSE = ')';
	var C_X_LOWER = 'x';
	
	var TAB_SIZE = 4;
	var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
	var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
	var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
	var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
	var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
	
	/* Map of characters which can be used to mark
	 * list-items. */
	var LIST_UNORDERED_MARKERS = {};
	
	LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
	LIST_UNORDERED_MARKERS[C_PLUS] = true;
	LIST_UNORDERED_MARKERS[C_DASH] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_MARKERS = {};
	
	LIST_ORDERED_MARKERS[C_DOT] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_COMMONMARK_MARKERS = {};
	
	LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
	LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
	
	function list(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var pedantic = self.options.pedantic;
	  var tokenizers = self.blockTokenizers;
	  var interuptors = self.interruptList;
	  var markers;
	  var index = 0;
	  var length = value.length;
	  var start = null;
	  var size = 0;
	  var queue;
	  var ordered;
	  var character;
	  var marker;
	  var nextIndex;
	  var startIndex;
	  var prefixed;
	  var currentMarker;
	  var content;
	  var line;
	  var prevEmpty;
	  var empty;
	  var items;
	  var allLines;
	  var emptyLines;
	  var item;
	  var enterTop;
	  var exitBlockquote;
	  var isLoose;
	  var node;
	  var now;
	  var end;
	  var indented;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_TAB) {
	      size += TAB_SIZE - (size % TAB_SIZE);
	    } else if (character === C_SPACE) {
	      size++;
	    } else {
	      break;
	    }
	
	    index++;
	  }
	
	  if (size >= TAB_SIZE) {
	    return;
	  }
	
	  character = value.charAt(index);
	
	  markers = commonmark ?
	    LIST_ORDERED_COMMONMARK_MARKERS :
	    LIST_ORDERED_MARKERS;
	
	  if (LIST_UNORDERED_MARKERS[character] === true) {
	    marker = character;
	    ordered = false;
	  } else {
	    ordered = true;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!decimal(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (!queue || markers[character] !== true) {
	      return;
	    }
	
	    start = parseInt(queue, 10);
	    marker = character;
	  }
	
	  character = value.charAt(++index);
	
	  if (character !== C_SPACE && character !== C_TAB) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	  items = [];
	  allLines = [];
	  emptyLines = [];
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	    indented = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    end = index + TAB_SIZE;
	    size = 0;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_TAB) {
	        size += TAB_SIZE - (size % TAB_SIZE);
	      } else if (character === C_SPACE) {
	        size++;
	      } else {
	        break;
	      }
	
	      index++;
	    }
	
	    if (size >= TAB_SIZE) {
	      indented = true;
	    }
	
	    if (item && size >= item.indent) {
	      indented = true;
	    }
	
	    character = value.charAt(index);
	    currentMarker = null;
	
	    if (!indented) {
	      if (LIST_UNORDERED_MARKERS[character] === true) {
	        currentMarker = character;
	        index++;
	        size++;
	      } else {
	        queue = '';
	
	        while (index < length) {
	          character = value.charAt(index);
	
	          if (!decimal(character)) {
	            break;
	          }
	
	          queue += character;
	          index++;
	        }
	
	        character = value.charAt(index);
	        index++;
	
	        if (queue && markers[character] === true) {
	          currentMarker = character;
	          size += queue.length + 1;
	        }
	      }
	
	      if (currentMarker) {
	        character = value.charAt(index);
	
	        if (character === C_TAB) {
	          size += TAB_SIZE - (size % TAB_SIZE);
	          index++;
	        } else if (character === C_SPACE) {
	          end = index + TAB_SIZE;
	
	          while (index < end) {
	            if (value.charAt(index) !== C_SPACE) {
	              break;
	            }
	
	            index++;
	            size++;
	          }
	
	          if (index === end && value.charAt(index) === C_SPACE) {
	            index -= TAB_SIZE - 1;
	            size -= TAB_SIZE - 1;
	          }
	        } else if (character !== C_NEWLINE && character !== '') {
	          currentMarker = null;
	        }
	      }
	    }
	
	    if (currentMarker) {
	      if (!pedantic && marker !== currentMarker) {
	        break;
	      }
	
	      prefixed = true;
	    } else {
	      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
	        indented = true;
	      } else if (commonmark && item) {
	        indented = size >= item.indent || size > TAB_SIZE;
	      }
	
	      prefixed = false;
	      index = startIndex;
	    }
	
	    line = value.slice(startIndex, nextIndex);
	    content = startIndex === index ? line : value.slice(index, nextIndex);
	
	    if (
	      currentMarker === C_ASTERISK ||
	      currentMarker === C_UNDERSCORE ||
	      currentMarker === C_DASH
	    ) {
	      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
	        break;
	      }
	    }
	
	    prevEmpty = empty;
	    empty = !trim(content).length;
	
	    if (indented && item) {
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (prefixed) {
	      if (emptyLines.length !== 0) {
	        item.value.push('');
	        item.trail = emptyLines.concat();
	      }
	
	      item = {
	        value: [line],
	        indent: size,
	        trail: []
	      };
	
	      items.push(item);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (empty) {
	      if (prevEmpty) {
	        break;
	      }
	
	      emptyLines.push(line);
	    } else {
	      if (prevEmpty) {
	        break;
	      }
	
	      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
	        break;
	      }
	
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    }
	
	    index = nextIndex + 1;
	  }
	
	  node = eat(allLines.join(C_NEWLINE)).reset({
	    type: 'list',
	    ordered: ordered,
	    start: start,
	    loose: null,
	    children: []
	  });
	
	  enterTop = self.enterList();
	  exitBlockquote = self.enterBlock();
	  isLoose = false;
	  index = -1;
	  length = items.length;
	
	  while (++index < length) {
	    item = items[index].value.join(C_NEWLINE);
	    now = eat.now();
	
	    item = eat(item)(listItem(self, item, now), node);
	
	    if (item.loose) {
	      isLoose = true;
	    }
	
	    item = items[index].trail.join(C_NEWLINE);
	
	    if (index !== length - 1) {
	      item += C_NEWLINE;
	    }
	
	    eat(item);
	  }
	
	  enterTop();
	  exitBlockquote();
	
	  node.loose = isLoose;
	
	  return node;
	}
	
	function listItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
	  var checked = null;
	  var task;
	  var indent;
	
	  value = fn.apply(null, arguments);
	
	  if (ctx.options.gfm) {
	    task = value.match(EXPRESSION_TASK_ITEM);
	
	    if (task) {
	      indent = task[0].length;
	      checked = task[1].toLowerCase() === C_X_LOWER;
	      offsets[position.line] += indent;
	      value = value.slice(indent);
	    }
	  }
	
	  return {
	    type: 'listItem',
	    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
	      value.charAt(value.length - 1) === C_NEWLINE,
	    checked: checked,
	    children: ctx.tokenizeBlock(value, position)
	  };
	}
	
	/* Create a list-item using overly simple mechanics. */
	function pedanticListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
	
	  /* The initial line was also matched by the below, so
	   * we reset the `line`. */
	  line = position.line;
	
	  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
	
	  /* A simple replacer which removed all matches,
	   * and adds their length to `offset`. */
	  function replacer($0) {
	    offsets[line] = (offsets[line] || 0) + $0.length;
	    line++;
	
	    return '';
	  }
	}
	
	/* Create a list-item using sane mechanics. */
	function normalListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	  var max;
	  var bullet;
	  var rest;
	  var lines;
	  var trimmedLines;
	  var index;
	  var length;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_BULLET, replacer);
	
	  lines = value.split(C_NEWLINE);
	
	  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);
	
	  /* We replaced the initial bullet with something
	   * else above, which was used to trick
	   * `removeIndentation` into removing some more
	   * characters when possible.  However, that could
	   * result in the initial line to be stripped more
	   * than it should be. */
	  trimmedLines[0] = rest;
	
	  offsets[line] = (offsets[line] || 0) + bullet.length;
	  line++;
	
	  index = 0;
	  length = lines.length;
	
	  while (++index < length) {
	    offsets[line] = (offsets[line] || 0) +
	      lines[index].length - trimmedLines[index].length;
	    line++;
	  }
	
	  return trimmedLines.join(C_NEWLINE);
	
	  function replacer($0, $1, $2, $3, $4) {
	    bullet = $1 + $2 + $3;
	    rest = $4;
	
	    /* Make sure that the first nine numbered list items
	     * can indent with an extra space.  That is, when
	     * the bullet did not receive an extra final space. */
	    if (Number($2) < 10 && bullet.length % 2 === 1) {
	      $2 = C_SPACE + $2;
	    }
	
	    max = $1 + repeat(C_SPACE, $2.length) + $3;
	
	    return max + rest;
	  }
	}


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	
	module.exports = newline;
	
	/* Tokenise newline. */
	function newline(eat, value, silent) {
	  var character = value.charAt(0);
	  var length;
	  var subvalue;
	  var queue;
	  var index;
	
	  if (character !== '\n') {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  index = 1;
	  length = value.length;
	  subvalue = character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	
	    if (character === '\n') {
	      subvalue += queue;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  eat(subvalue);
	}


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(6);
	var decimal = __webpack_require__(9);
	var trimTrailingLines = __webpack_require__(28);
	var interrupt = __webpack_require__(25);
	
	module.exports = paragraph;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var TAB_SIZE = 4;
	
	/* Tokenise paragraph. */
	function paragraph(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var commonmark = settings.commonmark;
	  var gfm = settings.gfm;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptParagraph;
	  var index = value.indexOf(C_NEWLINE);
	  var length = value.length;
	  var position;
	  var subvalue;
	  var character;
	  var size;
	  var now;
	
	  while (index < length) {
	    /* Eat everything if there’s no following newline. */
	    if (index === -1) {
	      index = length;
	      break;
	    }
	
	    /* Stop if the next character is NEWLINE. */
	    if (value.charAt(index + 1) === C_NEWLINE) {
	      break;
	    }
	
	    /* In commonmark-mode, following indented lines
	     * are part of the paragraph. */
	    if (commonmark) {
	      size = 0;
	      position = index + 1;
	
	      while (position < length) {
	        character = value.charAt(position);
	
	        if (character === C_TAB) {
	          size = TAB_SIZE;
	          break;
	        } else if (character === C_SPACE) {
	          size++;
	        } else {
	          break;
	        }
	
	        position++;
	      }
	
	      if (size >= TAB_SIZE) {
	        index = value.indexOf(C_NEWLINE, index + 1);
	        continue;
	      }
	    }
	
	    subvalue = value.slice(index + 1);
	
	    /* Check if the following code contains a possible
	     * block. */
	    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
	      break;
	    }
	
	    /* Break if the following line starts a list, when
	     * already in a list, or when in commonmark, or when
	     * in gfm mode and the bullet is *not* numeric. */
	    if (
	      tokenizers.list.call(self, eat, subvalue, true) &&
	      (
	        self.inList ||
	        commonmark ||
	        (gfm && !decimal(trim.left(subvalue).charAt(0)))
	      )
	    ) {
	      break;
	    }
	
	    position = index;
	    index = value.indexOf(C_NEWLINE, index + 1);
	
	    if (index !== -1 && trim(value.slice(position, index)) === '') {
	      index = position;
	      break;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  if (trim(subvalue) === '') {
	    eat(subvalue);
	
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  subvalue = trimTrailingLines(subvalue);
	
	  return eat(subvalue)({
	    type: 'paragraph',
	    children: self.tokenizeInline(subvalue, now)
	  });
	}


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	var locate = __webpack_require__(48);
	var normalize = __webpack_require__(26);
	
	module.exports = reference;
	reference.locator = locate;
	
	var T_LINK = 'link';
	var T_IMAGE = 'image';
	var T_FOOTNOTE = 'footnote';
	var REFERENCE_TYPE_SHORTCUT = 'shortcut';
	var REFERENCE_TYPE_COLLAPSED = 'collapsed';
	var REFERENCE_TYPE_FULL = 'full';
	var C_CARET = '^';
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	
	function reference(eat, value, silent) {
	  var self = this;
	  var character = value.charAt(0);
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var intro = '';
	  var type = T_LINK;
	  var referenceType = REFERENCE_TYPE_SHORTCUT;
	  var content;
	  var identifier;
	  var now;
	  var node;
	  var exit;
	  var queue;
	  var bracketed;
	  var depth;
	
	  /* Check whether we’re eating an image. */
	  if (character === '!') {
	    type = T_IMAGE;
	    intro = character;
	    character = value.charAt(++index);
	  }
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  intro += character;
	  queue = '';
	
	  /* Check whether we’re eating a footnote. */
	  if (self.options.footnotes && value.charAt(index) === C_CARET) {
	    /* Exit if `![^` is found, so the `!` will be seen as text after this,
	     * and we’ll enter this function again when `[^` is found. */
	    if (type === T_IMAGE) {
	      return;
	    }
	
	    intro += C_CARET;
	    index++;
	    type = T_FOOTNOTE;
	  }
	
	  /* Eat the text. */
	  depth = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_OPEN) {
	      bracketed = true;
	      depth++;
	    } else if (character === C_BRACKET_CLOSE) {
	      if (!depth) {
	        break;
	      }
	
	      depth--;
	    }
	
	    if (character === C_BACKSLASH) {
	      queue += C_BACKSLASH;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  subvalue = queue;
	  content = queue;
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_CLOSE) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  /* Inline footnotes cannot have an identifier. */
	  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
	    identifier = '';
	    queue += character;
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
	        break;
	      }
	
	      if (character === C_BACKSLASH) {
	        identifier += C_BACKSLASH;
	        character = value.charAt(++index);
	      }
	
	      identifier += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
	      queue += identifier + character;
	      index++;
	    } else {
	      identifier = '';
	    }
	
	    subvalue += queue;
	    queue = '';
	  } else {
	    if (!content) {
	      return;
	    }
	
	    identifier = content;
	  }
	
	  /* Brackets cannot be inside the identifier. */
	  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
	    return;
	  }
	
	  subvalue = intro + subvalue;
	
	  if (type === T_LINK && self.inLink) {
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
	    return eat(subvalue)({
	      type: 'footnote',
	      children: this.tokenizeInline(content, eat.now())
	    });
	  }
	
	  now = eat.now();
	  now.column += intro.length;
	  now.offset += intro.length;
	  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
	
	  node = {
	    type: type + 'Reference',
	    identifier: normalize(identifier)
	  };
	
	  if (type === T_LINK || type === T_IMAGE) {
	    node.referenceType = referenceType;
	  }
	
	  if (type === T_LINK) {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  } else if (type === T_IMAGE) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  }
	
	  return eat(subvalue)(node);
	}


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(6);
	var whitespace = __webpack_require__(2);
	var locate = __webpack_require__(159);
	
	module.exports = strong;
	strong.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function strong(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (
	    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
	    value.charAt(++index) !== character
	  ) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  marker = character;
	  subvalue = marker + marker;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (
	      character === marker &&
	      value.charAt(index + 1) === marker &&
	      (!pedantic || !whitespace(prev))
	    ) {
	      character = value.charAt(index + 2);
	
	      if (character !== marker) {
	        if (!trim(queue)) {
	          return;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column += 2;
	        now.offset += 2;
	
	        return eat(subvalue + queue + subvalue)({
	          type: 'strong',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(2);
	
	module.exports = table;
	
	var C_BACKSLASH = '\\';
	var C_TICK = '`';
	var C_DASH = '-';
	var C_PIPE = '|';
	var C_COLON = ':';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	var MIN_TABLE_COLUMNS = 1;
	var MIN_TABLE_ROWS = 2;
	
	var TABLE_ALIGN_LEFT = 'left';
	var TABLE_ALIGN_CENTER = 'center';
	var TABLE_ALIGN_RIGHT = 'right';
	var TABLE_ALIGN_NONE = null;
	
	function table(eat, value, silent) {
	  var self = this;
	  var index;
	  var alignments;
	  var alignment;
	  var subvalue;
	  var row;
	  var length;
	  var lines;
	  var queue;
	  var character;
	  var hasDash;
	  var align;
	  var cell;
	  var preamble;
	  var count;
	  var opening;
	  var now;
	  var position;
	  var lineCount;
	  var line;
	  var rows;
	  var table;
	  var lineIndex;
	  var pipeIndex;
	  var first;
	
	  /* Exit when not in gfm-mode. */
	  if (!self.options.gfm) {
	    return;
	  }
	
	  /* Get the rows.
	   * Detecting tables soon is hard, so there are some
	   * checks for performance here, such as the minimum
	   * number of rows, and allowed characters in the
	   * alignment row. */
	  index = 0;
	  lineCount = 0;
	  length = value.length + 1;
	  lines = [];
	
	  while (index < length) {
	    lineIndex = value.indexOf(C_NEWLINE, index);
	    pipeIndex = value.indexOf(C_PIPE, index + 1);
	
	    if (lineIndex === -1) {
	      lineIndex = value.length;
	    }
	
	    if (pipeIndex === -1 || pipeIndex > lineIndex) {
	      if (lineCount < MIN_TABLE_ROWS) {
	        return;
	      }
	
	      break;
	    }
	
	    lines.push(value.slice(index, lineIndex));
	    lineCount++;
	    index = lineIndex + 1;
	  }
	
	  /* Parse the alignment row. */
	  subvalue = lines.join(C_NEWLINE);
	  alignments = lines.splice(1, 1)[0] || [];
	  index = 0;
	  length = alignments.length;
	  lineCount--;
	  alignment = false;
	  align = [];
	
	  while (index < length) {
	    character = alignments.charAt(index);
	
	    if (character === C_PIPE) {
	      hasDash = null;
	
	      if (alignment === false) {
	        if (first === false) {
	          return;
	        }
	      } else {
	        align.push(alignment);
	        alignment = false;
	      }
	
	      first = false;
	    } else if (character === C_DASH) {
	      hasDash = true;
	      alignment = alignment || TABLE_ALIGN_NONE;
	    } else if (character === C_COLON) {
	      if (alignment === TABLE_ALIGN_LEFT) {
	        alignment = TABLE_ALIGN_CENTER;
	      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
	        alignment = TABLE_ALIGN_RIGHT;
	      } else {
	        alignment = TABLE_ALIGN_LEFT;
	      }
	    } else if (!whitespace(character)) {
	      return;
	    }
	
	    index++;
	  }
	
	  if (alignment !== false) {
	    align.push(alignment);
	  }
	
	  /* Exit when without enough columns. */
	  if (align.length < MIN_TABLE_COLUMNS) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  /* Parse the rows. */
	  position = -1;
	  rows = [];
	
	  table = eat(subvalue).reset({
	    type: 'table',
	    align: align,
	    children: rows
	  });
	
	  while (++position < lineCount) {
	    line = lines[position];
	    row = {type: 'tableRow', children: []};
	
	    /* Eat a newline character when this is not the
	     * first row. */
	    if (position) {
	      eat(C_NEWLINE);
	    }
	
	    /* Eat the row. */
	    eat(line).reset(row, table);
	
	    length = line.length + 1;
	    index = 0;
	    queue = '';
	    cell = '';
	    preamble = true;
	    count = null;
	    opening = null;
	
	    while (index < length) {
	      character = line.charAt(index);
	
	      if (character === C_TAB || character === C_SPACE) {
	        if (cell) {
	          queue += character;
	        } else {
	          eat(character);
	        }
	
	        index++;
	        continue;
	      }
	
	      if (character === '' || character === C_PIPE) {
	        if (preamble) {
	          eat(character);
	        } else {
	          if (character && opening) {
	            queue += character;
	            index++;
	            continue;
	          }
	
	          if ((cell || character) && !preamble) {
	            subvalue = cell;
	
	            if (queue.length > 1) {
	              if (character) {
	                subvalue += queue.slice(0, queue.length - 1);
	                queue = queue.charAt(queue.length - 1);
	              } else {
	                subvalue += queue;
	                queue = '';
	              }
	            }
	
	            now = eat.now();
	
	            eat(subvalue)({
	              type: 'tableCell',
	              children: self.tokenizeInline(cell, now)
	            }, row);
	          }
	
	          eat(queue + character);
	
	          queue = '';
	          cell = '';
	        }
	      } else {
	        if (queue) {
	          cell += queue;
	          queue = '';
	        }
	
	        cell += character;
	
	        if (character === C_BACKSLASH && index !== length - 2) {
	          cell += line.charAt(index + 1);
	          index++;
	        }
	
	        if (character === C_TICK) {
	          count = 1;
	
	          while (line.charAt(index + 1) === character) {
	            cell += character;
	            index++;
	            count++;
	          }
	
	          if (!opening) {
	            opening = count;
	          } else if (count >= opening) {
	            opening = 0;
	          }
	        }
	      }
	
	      preamble = false;
	      index++;
	    }
	
	    /* Eat the alignment row. */
	    if (!position) {
	      eat(C_NEWLINE + alignments);
	    }
	  }
	
	  return table;
	}


/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = text;
	
	function text(eat, value, silent) {
	  var self = this;
	  var methods;
	  var tokenizers;
	  var index;
	  var length;
	  var subvalue;
	  var position;
	  var tokenizer;
	  var name;
	  var min;
	  var now;
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  methods = self.inlineMethods;
	  length = methods.length;
	  tokenizers = self.inlineTokenizers;
	  index = -1;
	  min = value.length;
	
	  while (++index < length) {
	    name = methods[index];
	
	    if (name === 'text' || !tokenizers[name]) {
	      continue;
	    }
	
	    tokenizer = tokenizers[name].locator;
	
	    if (!tokenizer) {
	      eat.file.fail('Missing locator: `' + name + '`');
	    }
	
	    position = tokenizer.call(self, value, 1);
	
	    if (position !== -1 && position < min) {
	      min = position;
	    }
	  }
	
	  subvalue = value.slice(0, min);
	  now = eat.now();
	
	  self.decode(subvalue, now, function (content, position, source) {
	    eat(source || content)({
	      type: 'text',
	      value: content
	    });
	  });
	}


/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = thematicBreak;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_DASH = '-';
	
	var THEMATIC_BREAK_MARKER_COUNT = 3;
	
	function thematicBreak(eat, value, silent) {
	  var index = -1;
	  var length = value.length + 1;
	  var subvalue = '';
	  var character;
	  var marker;
	  var markerCount;
	  var queue;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  if (
	    character !== C_ASTERISK &&
	    character !== C_DASH &&
	    character !== C_UNDERSCORE
	  ) {
	    return;
	  }
	
	  marker = character;
	  subvalue += character;
	  markerCount = 1;
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === marker) {
	      markerCount++;
	      subvalue += queue + marker;
	      queue = '';
	    } else if (character === C_SPACE) {
	      queue += character;
	    } else if (
	      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
	      (!character || character === C_NEWLINE)
	    ) {
	      subvalue += queue;
	
	      if (silent) {
	        return true;
	      }
	
	      return eat(subvalue)({type: 'thematicBreak'});
	    } else {
	      return;
	    }
	  }
	}


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var decode = __webpack_require__(17);
	var whitespace = __webpack_require__(2);
	var locate = __webpack_require__(160);
	
	module.exports = url;
	url.locator = locate;
	url.notInLink = true;
	
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_AT_SIGN = '@';
	
	var HTTP_PROTOCOL = 'http://';
	var HTTPS_PROTOCOL = 'https://';
	var MAILTO_PROTOCOL = 'mailto:';
	
	var PROTOCOLS = [
	  HTTP_PROTOCOL,
	  HTTPS_PROTOCOL,
	  MAILTO_PROTOCOL
	];
	
	var PROTOCOLS_LENGTH = PROTOCOLS.length;
	
	function url(eat, value, silent) {
	  var self = this;
	  var subvalue;
	  var content;
	  var character;
	  var index;
	  var position;
	  var protocol;
	  var match;
	  var length;
	  var queue;
	  var parenCount;
	  var nextCharacter;
	  var exit;
	
	  if (!self.options.gfm) {
	    return;
	  }
	
	  subvalue = '';
	  index = -1;
	  length = PROTOCOLS_LENGTH;
	
	  while (++index < length) {
	    protocol = PROTOCOLS[index];
	    match = value.slice(0, protocol.length);
	
	    if (match.toLowerCase() === protocol) {
	      subvalue = match;
	      break;
	    }
	  }
	
	  if (!subvalue) {
	    return;
	  }
	
	  index = subvalue.length;
	  length = value.length;
	  queue = '';
	  parenCount = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_LT) {
	      break;
	    }
	
	    if (
	      character === '.' ||
	      character === ',' ||
	      character === ':' ||
	      character === ';' ||
	      character === '"' ||
	      character === '\'' ||
	      character === ')' ||
	      character === ']'
	    ) {
	      nextCharacter = value.charAt(index + 1);
	
	      if (!nextCharacter || whitespace(nextCharacter)) {
	        break;
	      }
	    }
	
	    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
	      parenCount++;
	    }
	
	    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
	      parenCount--;
	
	      if (parenCount < 0) {
	        break;
	      }
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue += queue;
	  content = subvalue;
	
	  if (protocol === MAILTO_PROTOCOL) {
	    position = queue.indexOf(C_AT_SIGN);
	
	    if (position === -1 || position === length - 1) {
	      return;
	    }
	
	    content = content.substr(MAILTO_PROTOCOL.length);
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  exit = self.enterLink();
	  content = self.tokenizeInline(content, eat.now());
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(subvalue, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	var MERGEABLE_NODES = {
	  text: mergeText,
	  blockquote: mergeBlockquote
	};
	
	/* Check whether a node is mergeable with adjacent nodes. */
	function mergeable(node) {
	  var start;
	  var end;
	
	  if (node.type !== 'text' || !node.position) {
	    return true;
	  }
	
	  start = node.position.start;
	  end = node.position.end;
	
	  /* Only merge nodes which occupy the same size as their
	   * `value`. */
	  return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	}
	
	/* Merge two text nodes: `node` into `prev`. */
	function mergeText(prev, node) {
	  prev.value += node.value;
	
	  return prev;
	}
	
	/* Merge two blockquotes: `node` into `prev`, unless in
	 * CommonMark mode. */
	function mergeBlockquote(prev, node) {
	  if (this.options.commonmark) {
	    return node;
	  }
	
	  prev.children = prev.children.concat(node.children);
	
	  return prev;
	}
	
	/* Construct a tokenizer.  This creates both
	 * `tokenizeInline` and `tokenizeBlock`. */
	function factory(type) {
	  return tokenize;
	
	  /* Tokenizer for a bound `type`. */
	  function tokenize(value, location) {
	    var self = this;
	    var offset = self.offset;
	    var tokens = [];
	    var methods = self[type + 'Methods'];
	    var tokenizers = self[type + 'Tokenizers'];
	    var line = location.line;
	    var column = location.column;
	    var index;
	    var length;
	    var method;
	    var name;
	    var matched;
	    var valueLength;
	
	    /* Trim white space only lines. */
	    if (!value) {
	      return tokens;
	    }
	
	    /* Expose on `eat`. */
	    eat.now = now;
	    eat.file = self.file;
	
	    /* Sync initial offset. */
	    updatePosition('');
	
	    /* Iterate over `value`, and iterate over all
	     * tokenizers.  When one eats something, re-iterate
	     * with the remaining value.  If no tokenizer eats,
	     * something failed (should not happen) and an
	     * exception is thrown. */
	    while (value) {
	      index = -1;
	      length = methods.length;
	      matched = false;
	
	      while (++index < length) {
	        name = methods[index];
	        method = tokenizers[name];
	
	        if (
	          method &&
	          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
	          (!method.notInList || !self.inList) &&
	          (!method.notInBlock || !self.inBlock) &&
	          (!method.notInLink || !self.inLink)
	        ) {
	          valueLength = value.length;
	
	          method.apply(self, [eat, value]);
	
	          matched = valueLength !== value.length;
	
	          if (matched) {
	            break;
	          }
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!matched) {
	        self.file.fail(new Error('Infinite loop'), eat.now());
	      }
	    }
	
	    self.eof = now();
	
	    return tokens;
	
	    /* Update line, column, and offset based on
	     * `value`. */
	    function updatePosition(subvalue) {
	      var lastIndex = -1;
	      var index = subvalue.indexOf('\n');
	
	      while (index !== -1) {
	        line++;
	        lastIndex = index;
	        index = subvalue.indexOf('\n', index + 1);
	      }
	
	      if (lastIndex === -1) {
	        column += subvalue.length;
	      } else {
	        column = subvalue.length - lastIndex;
	      }
	
	      if (line in offset) {
	        if (lastIndex !== -1) {
	          column += offset[line];
	        } else if (column <= offset[line]) {
	          column = offset[line] + 1;
	        }
	      }
	    }
	
	    /* Get offset.  Called before the first character is
	     * eaten to retrieve the range's offsets. */
	    function getOffset() {
	      var indentation = [];
	      var pos = line + 1;
	
	      /* Done.  Called when the last character is
	       * eaten to retrieve the range’s offsets. */
	      return function () {
	        var last = line + 1;
	
	        while (pos < last) {
	          indentation.push((offset[pos] || 0) + 1);
	
	          pos++;
	        }
	
	        return indentation;
	      };
	    }
	
	    /* Get the current position. */
	    function now() {
	      var pos = {line: line, column: column};
	
	      pos.offset = self.toOffset(pos);
	
	      return pos;
	    }
	
	    /* Store position information for a node. */
	    function Position(start) {
	      this.start = start;
	      this.end = now();
	    }
	
	    /* Throw when a value is incorrectly eaten.
	     * This shouldn’t happen but will throw on new,
	     * incorrect rules. */
	    function validateEat(subvalue) {
	      /* istanbul ignore if */
	      if (value.substring(0, subvalue.length) !== subvalue) {
	        /* Capture stack-trace. */
	        self.file.fail(
	          new Error(
	            'Incorrectly eaten value: please report this ' +
	            'warning on http://git.io/vg5Ft'
	          ),
	          now()
	        );
	      }
	    }
	
	    /* Mark position and patch `node.position`. */
	    function position() {
	      var before = now();
	
	      return update;
	
	      /* Add the position to a node. */
	      function update(node, indent) {
	        var prev = node.position;
	        var start = prev ? prev.start : before;
	        var combined = [];
	        var n = prev && prev.end.line;
	        var l = before.line;
	
	        node.position = new Position(start);
	
	        /* If there was already a `position`, this
	         * node was merged.  Fixing `start` wasn’t
	         * hard, but the indent is different.
	         * Especially because some information, the
	         * indent between `n` and `l` wasn’t
	         * tracked.  Luckily, that space is
	         * (should be?) empty, so we can safely
	         * check for it now. */
	        if (prev && indent && prev.indent) {
	          combined = prev.indent;
	
	          if (n < l) {
	            while (++n < l) {
	              combined.push((offset[n] || 0) + 1);
	            }
	
	            combined.push(before.column);
	          }
	
	          indent = combined.concat(indent);
	        }
	
	        node.position.indent = indent || [];
	
	        return node;
	      }
	    }
	
	    /* Add `node` to `parent`s children or to `tokens`.
	     * Performs merges where possible. */
	    function add(node, parent) {
	      var children = parent ? parent.children : tokens;
	      var prev = children[children.length - 1];
	
	      if (
	        prev &&
	        node.type === prev.type &&
	        node.type in MERGEABLE_NODES &&
	        mergeable(prev) &&
	        mergeable(node)
	      ) {
	        node = MERGEABLE_NODES[node.type].call(self, prev, node);
	      }
	
	      if (node !== prev) {
	        children.push(node);
	      }
	
	      if (self.atStart && tokens.length !== 0) {
	        self.exitStart();
	      }
	
	      return node;
	    }
	
	    /* Remove `subvalue` from `value`.
	     * `subvalue` must be at the start of `value`. */
	    function eat(subvalue) {
	      var indent = getOffset();
	      var pos = position();
	      var current = now();
	
	      validateEat(subvalue);
	
	      apply.reset = reset;
	      reset.test = test;
	      apply.test = test;
	
	      value = value.substring(subvalue.length);
	
	      updatePosition(subvalue);
	
	      indent = indent();
	
	      return apply;
	
	      /* Add the given arguments, add `position` to
	       * the returned node, and return the node. */
	      function apply(node, parent) {
	        return pos(add(pos(node), parent), indent);
	      }
	
	      /* Functions just like apply, but resets the
	       * content:  the line and column are reversed,
	       * and the eaten value is re-added.
	       * This is useful for nodes with a single
	       * type of content, such as lists and tables.
	       * See `apply` above for what parameters are
	       * expected. */
	      function reset() {
	        var node = apply.apply(null, arguments);
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return node;
	      }
	
	      /* Test the position, after eating, and reverse
	       * to a not-eaten state. */
	      function test() {
	        var result = pos({});
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return result.position;
	      }
	    }
	  }
	}


/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	/* Factory to de-escape a value, based on a list at `key`
	 * in `ctx`. */
	function factory(ctx, key) {
	  return unescape;
	
	  /* De-escape a string using the expression at `key`
	   * in `ctx`. */
	  function unescape(value) {
	    var prev = 0;
	    var index = value.indexOf('\\');
	    var escape = ctx[key];
	    var queue = [];
	    var character;
	
	    while (index !== -1) {
	      queue.push(value.slice(prev, index));
	      prev = index + 1;
	      character = value.charAt(prev);
	
	      /* If the following character is not a valid escape,
	       * add the slash. */
	      if (!character || escape.indexOf(character) === -1) {
	        queue.push('\\');
	      }
	
	      index = value.indexOf('\\', prev);
	    }
	
	    queue.push(value.slice(prev));
	
	    return queue.join('');
	  }
	}


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(6);
	var repeat = __webpack_require__(27);
	var getIndent = __webpack_require__(50);
	
	module.exports = indentation;
	
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	/* Remove the minimum indent from every line in `value`.
	 * Supports both tab, spaced, and mixed indentation (as
	 * well as possible). */
	function indentation(value, maximum) {
	  var values = value.split(C_NEWLINE);
	  var position = values.length + 1;
	  var minIndent = Infinity;
	  var matrix = [];
	  var index;
	  var indentation;
	  var stops;
	  var padding;
	
	  values.unshift(repeat(C_SPACE, maximum) + '!');
	
	  while (position--) {
	    indentation = getIndent(values[position]);
	
	    matrix[position] = indentation.stops;
	
	    if (trim(values[position]).length === 0) {
	      continue;
	    }
	
	    if (indentation.indent) {
	      if (indentation.indent > 0 && indentation.indent < minIndent) {
	        minIndent = indentation.indent;
	      }
	    } else {
	      minIndent = Infinity;
	
	      break;
	    }
	  }
	
	  if (minIndent !== Infinity) {
	    position = values.length;
	
	    while (position--) {
	      stops = matrix[position];
	      index = minIndent;
	
	      while (index && !(index in stops)) {
	        index--;
	      }
	
	      if (
	        trim(values[position]).length !== 0 &&
	        minIndent &&
	        index !== minIndent
	      ) {
	        padding = C_TAB;
	      } else {
	        padding = '';
	      }
	
	      values[position] = padding + values[position].slice(
	        index in stops ? stops[index] + 1 : 0
	      );
	    }
	  }
	
	  values.shift();
	
	  return values.join(C_NEWLINE);
	}


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(43);
	
	function replaceExt(npath, ext) {
	  if (typeof npath !== 'string') {
	    return npath;
	  }
	
	  if (npath.length === 0) {
	    return npath;
	  }
	
	  var nFileName = path.basename(npath, path.extname(npath)) + ext;
	  return path.join(path.dirname(npath), nFileName);
	}
	
	module.exports = replaceExt;


/***/ },
/* 193 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(193);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	// Construct a state `toggler`: a function which inverses `property` in context
	// based on its current value.
	// The by `toggler` returned function restores that value.
	function factory(key, state, ctx) {
	  return enter
	
	  function enter() {
	    var context = ctx || this
	    var current = context[key]
	
	    context[key] = !state
	
	    return exit
	
	    function exit() {
	      context[key] = current
	    }
	  }
	}


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var wrap = __webpack_require__(197)
	
	module.exports = trough
	
	trough.wrap = wrap
	
	var slice = [].slice
	
	// Create new middleware.
	function trough() {
	  var fns = []
	  var middleware = {}
	
	  middleware.run = run
	  middleware.use = use
	
	  return middleware
	
	  // Run `fns`.  Last argument must be a completion handler.
	  function run() {
	    var index = -1
	    var input = slice.call(arguments, 0, -1)
	    var done = arguments[arguments.length - 1]
	
	    if (typeof done !== 'function') {
	      throw new Error('Expected function as last argument, not ' + done)
	    }
	
	    next.apply(null, [null].concat(input))
	
	    // Run the next `fn`, if any.
	    function next(err) {
	      var fn = fns[++index]
	      var params = slice.call(arguments, 0)
	      var values = params.slice(1)
	      var length = input.length
	      var pos = -1
	
	      if (err) {
	        done(err)
	        return
	      }
	
	      // Copy non-nully input into values.
	      while (++pos < length) {
	        if (values[pos] === null || values[pos] === undefined) {
	          values[pos] = input[pos]
	        }
	      }
	
	      input = values
	
	      // Next or done.
	      if (fn) {
	        wrap(fn, next).apply(null, input)
	      } else {
	        done.apply(null, [null].concat(input))
	      }
	    }
	  }
	
	  // Add `fn` to the list.
	  function use(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Expected `fn` to be a function, not ' + fn)
	    }
	
	    fns.push(fn)
	
	    return middleware
	  }
	}


/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict'
	
	var slice = [].slice
	
	module.exports = wrap
	
	// Wrap `fn`.
	// Can be sync or async; return a promise, receive a completion handler, return
	// new values and errors.
	function wrap(fn, callback) {
	  var invoked
	
	  return wrapped
	
	  function wrapped() {
	    var params = slice.call(arguments, 0)
	    var callback = fn.length > params.length
	    var result
	
	    if (callback) {
	      params.push(done)
	    }
	
	    try {
	      result = fn.apply(null, params)
	    } catch (error) {
	      // Well, this is quite the pickle.
	      // `fn` received a callback and invoked it (thus continuing the pipeline),
	      // but later also threw an error.
	      // We’re not about to restart the pipeline again, so the only thing left
	      // to do is to throw the thing instead.
	      if (callback && invoked) {
	        throw error
	      }
	
	      return done(error)
	    }
	
	    if (!callback) {
	      if (result && typeof result.then === 'function') {
	        result.then(then, done)
	      } else if (result instanceof Error) {
	        done(result)
	      } else {
	        then(result)
	      }
	    }
	  }
	
	  // Invoke `next`, only once.
	  function done() {
	    if (!invoked) {
	      invoked = true
	
	      callback.apply(null, arguments)
	    }
	  }
	
	  // Invoke `done` with one value.
	  // Tracks if an error is passed, too.
	  function then(value) {
	    done(null, value)
	  }
	}


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(3)
	var inherits = __webpack_require__(78)
	
	module.exports = unherit
	
	// Create a custom constructor which can be modified without affecting the
	// original class.
	function unherit(Super) {
	  var result
	  var key
	  var value
	
	  inherits(Of, Super)
	  inherits(From, Of)
	
	  // Clone values.
	  result = Of.prototype
	
	  for (key in result) {
	    value = result[key]
	
	    if (value && typeof value === 'object') {
	      result[key] = 'concat' in value ? value.concat() : xtend(value)
	    }
	  }
	
	  return Of
	
	  // Constructor accepting a single argument, which itself is an `arguments`
	  // object.
	  function From(parameters) {
	    return Super.apply(this, parameters)
	  }
	
	  // Constructor accepting variadic arguments.
	  function Of() {
	    if (!(this instanceof Of)) {
	      return new From(arguments)
	    }
	
	    return Super.apply(this, arguments)
	  }
	}


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict'
	
	/* Dependencies. */
	var extend = __webpack_require__(66)
	var bail = __webpack_require__(55)
	var vfile = __webpack_require__(208)
	var trough = __webpack_require__(196)
	var string = __webpack_require__(209)
	var plain = __webpack_require__(82)
	
	/* Expose a frozen processor. */
	module.exports = unified().freeze()
	
	var slice = [].slice
	var own = {}.hasOwnProperty
	
	/* Process pipeline. */
	var pipeline = trough()
	  .use(pipelineParse)
	  .use(pipelineRun)
	  .use(pipelineStringify)
	
	function pipelineParse(p, ctx) {
	  ctx.tree = p.parse(ctx.file)
	}
	
	function pipelineRun(p, ctx, next) {
	  p.run(ctx.tree, ctx.file, done)
	
	  function done(err, tree, file) {
	    if (err) {
	      next(err)
	    } else {
	      ctx.tree = tree
	      ctx.file = file
	      next()
	    }
	  }
	}
	
	function pipelineStringify(p, ctx) {
	  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
	}
	
	/* Function to create the first processor. */
	function unified() {
	  var attachers = []
	  var transformers = trough()
	  var namespace = {}
	  var frozen = false
	  var freezeIndex = -1
	
	  /* Data management. */
	  processor.data = data
	
	  /* Lock. */
	  processor.freeze = freeze
	
	  /* Plug-ins. */
	  processor.attachers = attachers
	  processor.use = use
	
	  /* API. */
	  processor.parse = parse
	  processor.stringify = stringify
	  processor.run = run
	  processor.runSync = runSync
	  processor.process = process
	  processor.processSync = processSync
	
	  /* Expose. */
	  return processor
	
	  /* Create a new processor based on the processor
	   * in the current scope. */
	  function processor() {
	    var destination = unified()
	    var length = attachers.length
	    var index = -1
	
	    while (++index < length) {
	      destination.use.apply(null, attachers[index])
	    }
	
	    destination.data(extend(true, {}, namespace))
	
	    return destination
	  }
	
	  /* Freeze: used to signal a processor that has finished
	   * configuration.
	   *
	   * For example, take unified itself.  It’s frozen.
	   * Plug-ins should not be added to it.  Rather, it should
	   * be extended, by invoking it, before modifying it.
	   *
	   * In essence, always invoke this when exporting a
	   * processor. */
	  function freeze() {
	    var values
	    var plugin
	    var options
	    var transformer
	
	    if (frozen) {
	      return processor
	    }
	
	    while (++freezeIndex < attachers.length) {
	      values = attachers[freezeIndex]
	      plugin = values[0]
	      options = values[1]
	      transformer = null
	
	      if (options === false) {
	        continue
	      }
	
	      if (options === true) {
	        values[1] = undefined
	      }
	
	      transformer = plugin.apply(processor, values.slice(1))
	
	      if (typeof transformer === 'function') {
	        transformers.use(transformer)
	      }
	    }
	
	    frozen = true
	    freezeIndex = Infinity
	
	    return processor
	  }
	
	  /* Data management.
	   * Getter / setter for processor-specific informtion. */
	  function data(key, value) {
	    if (string(key)) {
	      /* Set `key`. */
	      if (arguments.length === 2) {
	        assertUnfrozen('data', frozen)
	
	        namespace[key] = value
	
	        return processor
	      }
	
	      /* Get `key`. */
	      return (own.call(namespace, key) && namespace[key]) || null
	    }
	
	    /* Set space. */
	    if (key) {
	      assertUnfrozen('data', frozen)
	      namespace = key
	      return processor
	    }
	
	    /* Get space. */
	    return namespace
	  }
	
	  /* Plug-in management.
	   *
	   * Pass it:
	   * *   an attacher and options,
	   * *   a preset,
	   * *   a list of presets, attachers, and arguments (list
	   *     of attachers and options). */
	  function use(value) {
	    var settings
	
	    assertUnfrozen('use', frozen)
	
	    if (value === null || value === undefined) {
	      /* Empty */
	    } else if (typeof value === 'function') {
	      addPlugin.apply(null, arguments)
	    } else if (typeof value === 'object') {
	      if ('length' in value) {
	        addList(value)
	      } else {
	        addPreset(value)
	      }
	    } else {
	      throw new Error('Expected usable value, not `' + value + '`')
	    }
	
	    if (settings) {
	      namespace.settings = extend(namespace.settings || {}, settings)
	    }
	
	    return processor
	
	    function addPreset(result) {
	      addList(result.plugins)
	
	      if (result.settings) {
	        settings = extend(settings || {}, result.settings)
	      }
	    }
	
	    function add(value) {
	      if (typeof value === 'function') {
	        addPlugin(value)
	      } else if (typeof value === 'object') {
	        if ('length' in value) {
	          addPlugin.apply(null, value)
	        } else {
	          addPreset(value)
	        }
	      } else {
	        throw new Error('Expected usable value, not `' + value + '`')
	      }
	    }
	
	    function addList(plugins) {
	      var length
	      var index
	
	      if (plugins === null || plugins === undefined) {
	        /* Empty */
	      } else if (typeof plugins === 'object' && 'length' in plugins) {
	        length = plugins.length
	        index = -1
	
	        while (++index < length) {
	          add(plugins[index])
	        }
	      } else {
	        throw new Error('Expected a list of plugins, not `' + plugins + '`')
	      }
	    }
	
	    function addPlugin(plugin, value) {
	      var entry = find(plugin)
	
	      if (entry) {
	        if (plain(entry[1]) && plain(value)) {
	          value = extend(entry[1], value)
	        }
	
	        entry[1] = value
	      } else {
	        attachers.push(slice.call(arguments))
	      }
	    }
	  }
	
	  function find(plugin) {
	    var length = attachers.length
	    var index = -1
	    var entry
	
	    while (++index < length) {
	      entry = attachers[index]
	
	      if (entry[0] === plugin) {
	        return entry
	      }
	    }
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the
	   * processor. */
	  function parse(doc) {
	    var file = vfile(doc)
	    var Parser
	
	    freeze()
	    Parser = processor.Parser
	    assertParser('parse', Parser)
	
	    if (newable(Parser)) {
	      return new Parser(String(file), file).parse()
	    }
	
	    return Parser(String(file), file) // eslint-disable-line new-cap
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), async. */
	  function run(node, file, cb) {
	    assertNode(node)
	    freeze()
	
	    if (!cb && typeof file === 'function') {
	      cb = file
	      file = null
	    }
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      transformers.run(node, vfile(file), done)
	
	      function done(err, tree, file) {
	        tree = tree || node
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(tree)
	        } else {
	          cb(null, tree, file)
	        }
	      }
	    }
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), sync. */
	  function runSync(node, file) {
	    var complete = false
	    var result
	
	    run(node, file, done)
	
	    assertDone('runSync', 'run', complete)
	
	    return result
	
	    function done(err, tree) {
	      complete = true
	      bail(err)
	      result = tree
	    }
	  }
	
	  /* Stringify a Unist node representation of a file
	   * (in string or VFile representation) into a string
	   * using the `Compiler` on the processor. */
	  function stringify(node, doc) {
	    var file = vfile(doc)
	    var Compiler
	
	    freeze()
	    Compiler = processor.Compiler
	    assertCompiler('stringify', Compiler)
	    assertNode(node)
	
	    if (newable(Compiler)) {
	      return new Compiler(node, file).compile()
	    }
	
	    return Compiler(node, file) // eslint-disable-line new-cap
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the processor,
	   * then run transforms on that node, and compile the
	   * resulting node using the `Compiler` on the processor,
	   * and store that result on the VFile. */
	  function process(doc, cb) {
	    freeze()
	    assertParser('process', processor.Parser)
	    assertCompiler('process', processor.Compiler)
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      var file = vfile(doc)
	
	      pipeline.run(processor, {file: file}, done)
	
	      function done(err) {
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(file)
	        } else {
	          cb(null, file)
	        }
	      }
	    }
	  }
	
	  /* Process the given document (in string or VFile
	   * representation), sync. */
	  function processSync(doc) {
	    var complete = false
	    var file
	
	    freeze()
	    assertParser('processSync', processor.Parser)
	    assertCompiler('processSync', processor.Compiler)
	    file = vfile(doc)
	
	    process(file, done)
	
	    assertDone('processSync', 'process', complete)
	
	    return file
	
	    function done(err) {
	      complete = true
	      bail(err)
	    }
	  }
	}
	
	/* Check if `func` is a constructor. */
	function newable(value) {
	  return typeof value === 'function' && keys(value.prototype)
	}
	
	/* Check if `value` is an object with keys. */
	function keys(value) {
	  var key
	  for (key in value) {
	    return true
	  }
	  return false
	}
	
	/* Assert a parser is available. */
	function assertParser(name, Parser) {
	  if (typeof Parser !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Parser`')
	  }
	}
	
	/* Assert a compiler is available. */
	function assertCompiler(name, Compiler) {
	  if (typeof Compiler !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Compiler`')
	  }
	}
	
	/* Assert the processor is not frozen. */
	function assertUnfrozen(name, frozen) {
	  if (frozen) {
	    throw new Error(
	      [
	        'Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ',
	        'processor first, by invoking it: use `processor()` instead of ',
	        '`processor`.'
	      ].join('')
	    )
	  }
	}
	
	/* Assert `node` is a Unist node. */
	function assertNode(node) {
	  if (!node || !string(node.type)) {
	    throw new Error('Expected node, got `' + node + '`')
	  }
	}
	
	/* Assert that `complete` is `true`. */
	function assertDone(name, asyncName, complete) {
	  if (!complete) {
	    throw new Error(
	      '`' + name + '` finished async. Use `' + asyncName + '` instead'
	    )
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = convert
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	// Utility assert each property in `test` is represented in `node`, and each
	// values are strictly equal.
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	// Utility to convert a string into a function which checks a given node’s type
	// for said string.
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	// Utility to return true.
	function ok() {
	  return true
	}


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var visit = __webpack_require__(8)
	
	module.exports = removePosition
	
	function removePosition(node, force) {
	  visit(node, force ? hard : soft)
	  return node
	}
	
	function hard(node) {
	  delete node.position
	}
	
	function soft(node) {
	  node.position = undefined
	}


/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict'
	
	var own = {}.hasOwnProperty
	
	module.exports = stringify
	
	function stringify(value) {
	  /* Nothing. */
	  if (!value || typeof value !== 'object') {
	    return null
	  }
	
	  /* Node. */
	  if (own.call(value, 'position') || own.call(value, 'type')) {
	    return position(value.position)
	  }
	
	  /* Position. */
	  if (own.call(value, 'start') || own.call(value, 'end')) {
	    return position(value)
	  }
	
	  /* Point. */
	  if (own.call(value, 'line') || own.call(value, 'column')) {
	    return point(value)
	  }
	
	  /* ? */
	  return null
	}
	
	function point(point) {
	  if (!point || typeof point !== 'object') {
	    point = {}
	  }
	
	  return index(point.line) + ':' + index(point.column)
	}
	
	function position(pos) {
	  if (!pos || typeof pos !== 'object') {
	    pos = {}
	  }
	
	  return point(pos.start) + '-' + point(pos.end)
	}
	
	function index(value) {
	  return value && typeof value === 'number' ? value : 1
	}


/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = visitParents
	
	/* Visit. */
	function visitParents(tree, type, visitor) {
	  var stack = []
	
	  if (typeof type === 'function') {
	    visitor = type
	    type = null
	  }
	
	  one(tree)
	
	  /* Visit a single node. */
	  function one(node) {
	    var result
	
	    if (!type || node.type === type) {
	      result = visitor(node, stack.concat())
	    }
	
	    if (node.children && result !== false) {
	      return all(node.children, node)
	    }
	
	    return result
	  }
	
	  /* Visit children in `parent`. */
	  function all(children, parent) {
	    var length = children.length
	    var index = -1
	    var child
	
	    stack.push(parent)
	
	    while (++index < length) {
	      child = children[index]
	
	      if (child && one(child) === false) {
	        return false
	      }
	    }
	
	    stack.pop()
	
	    return true
	  }
	}


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visitParents
	
	var convert = __webpack_require__(200)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visitParents.CONTINUE = CONTINUE
	visitParents.SKIP = SKIP
	visitParents.EXIT = EXIT
	
	function visitParents(tree, test, visitor, reverse) {
	  var is
	
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  is = convert(test)
	
	  one(tree, null, [])
	
	  // Visit a single node.
	  function one(node, index, parents) {
	    var result = []
	    var subresult
	
	    if (!test || is(node, index, parents[parents.length - 1] || null)) {
	      result = toResult(visitor(node, parents))
	
	      if (result[0] === EXIT) {
	        return result
	      }
	    }
	
	    if (node.children && result[0] !== SKIP) {
	      subresult = toResult(all(node.children, parents.concat(node)))
	      return subresult[0] === EXIT ? subresult : result
	    }
	
	    return result
	  }
	
	  // Visit children in `parent`.
	  function all(children, parents) {
	    var min = -1
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : min) + step
	    var result
	
	    while (index > min && index < children.length) {
	      result = one(children[index], index, parents)
	
	      if (result[0] === EXIT) {
	        return result
	      }
	
	      index = typeof result[1] === 'number' ? result[1] : index + step
	    }
	  }
	}
	
	function toResult(value) {
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    return value
	  }
	
	  if (typeof value === 'number') {
	    return [CONTINUE, value]
	  }
	
	  return [value]
	}


/***/ },
/* 205 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	function factory(file) {
	  var contents = indices(String(file))
	
	  return {
	    toPosition: offsetToPositionFactory(contents),
	    toOffset: positionToOffsetFactory(contents)
	  }
	}
	
	// Factory to get the line and column-based `position` for `offset` in the bound
	// indices.
	function offsetToPositionFactory(indices) {
	  return offsetToPosition
	
	  // Get the line and column-based `position` for `offset` in the bound indices.
	  function offsetToPosition(offset) {
	    var index = -1
	    var length = indices.length
	
	    if (offset < 0) {
	      return {}
	    }
	
	    while (++index < length) {
	      if (indices[index] > offset) {
	        return {
	          line: index + 1,
	          column: offset - (indices[index - 1] || 0) + 1,
	          offset: offset
	        }
	      }
	    }
	
	    return {}
	  }
	}
	
	// Factory to get the `offset` for a line and column-based `position` in the
	// bound indices.
	function positionToOffsetFactory(indices) {
	  return positionToOffset
	
	  // Get the `offset` for a line and column-based `position` in the bound
	  // indices.
	  function positionToOffset(position) {
	    var line = position && position.line
	    var column = position && position.column
	
	    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
	      return (indices[line - 2] || 0) + column - 1 || 0
	    }
	
	    return -1
	  }
	}
	
	// Get indices of line-breaks in `value`.
	function indices(value) {
	  var result = []
	  var index = value.indexOf('\n')
	
	  while (index !== -1) {
	    result.push(index + 1)
	    index = value.indexOf('\n', index + 1)
	  }
	
	  result.push(value.length + 1)
	
	  return result
	}


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var stringify = __webpack_require__(202)
	
	module.exports = VMessage
	
	// Inherit from `Error#`.
	function VMessagePrototype() {}
	VMessagePrototype.prototype = Error.prototype
	VMessage.prototype = new VMessagePrototype()
	
	// Message properties.
	var proto = VMessage.prototype
	
	proto.file = ''
	proto.name = ''
	proto.reason = ''
	proto.message = ''
	proto.stack = ''
	proto.fatal = null
	proto.column = null
	proto.line = null
	
	// Construct a new VMessage.
	//
	// Note: We cannot invoke `Error` on the created context, as that adds readonly
	// `line` and `column` attributes on Safari 9, thus throwing and failing the
	// data.
	function VMessage(reason, position, origin) {
	  var parts
	  var range
	  var location
	
	  if (typeof position === 'string') {
	    origin = position
	    position = null
	  }
	
	  parts = parseOrigin(origin)
	  range = stringify(position) || '1:1'
	
	  location = {
	    start: {line: null, column: null},
	    end: {line: null, column: null}
	  }
	
	  // Node.
	  if (position && position.position) {
	    position = position.position
	  }
	
	  if (position) {
	    // Position.
	    if (position.start) {
	      location = position
	      position = position.start
	    } else {
	      // Point.
	      location.start = position
	    }
	  }
	
	  if (reason.stack) {
	    this.stack = reason.stack
	    reason = reason.message
	  }
	
	  this.message = reason
	  this.name = range
	  this.reason = reason
	  this.line = position ? position.line : null
	  this.column = position ? position.column : null
	  this.location = location
	  this.source = parts[0]
	  this.ruleId = parts[1]
	}
	
	function parseOrigin(origin) {
	  var result = [null, null]
	  var index
	
	  if (typeof origin === 'string') {
	    index = origin.indexOf(':')
	
	    if (index === -1) {
	      result[1] = origin
	    } else {
	      result[0] = origin.slice(0, index)
	      result[1] = origin.slice(index + 1)
	    }
	  }
	
	  return result
	}


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var path = __webpack_require__(43);
	var replace = __webpack_require__(192);
	var buffer = __webpack_require__(80);
	
	module.exports = VFile;
	
	var own = {}.hasOwnProperty;
	var proto = VFile.prototype;
	
	proto.toString = toString;
	
	/* Order of setting (least specific to most), we need this because
	 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
	 * is needed before a stem can be set. */
	var order = [
	  'history',
	  'path',
	  'basename',
	  'stem',
	  'extname',
	  'dirname'
	];
	
	/* Construct a new file. */
	function VFile(options) {
	  var prop;
	  var index;
	  var length;
	
	  if (!options) {
	    options = {};
	  } else if (typeof options === 'string' || buffer(options)) {
	    options = {contents: options};
	  } else if ('message' in options && 'messages' in options) {
	    return options;
	  }
	
	  if (!(this instanceof VFile)) {
	    return new VFile(options);
	  }
	
	  this.data = {};
	  this.messages = [];
	  this.history = [];
	  this.cwd = process.cwd();
	
	  /* Set path related properties in the correct order. */
	  index = -1;
	  length = order.length;
	
	  while (++index < length) {
	    prop = order[index];
	
	    if (own.call(options, prop)) {
	      this[prop] = options[prop];
	    }
	  }
	
	  /* Set non-path related properties. */
	  for (prop in options) {
	    if (order.indexOf(prop) === -1) {
	      this[prop] = options[prop];
	    }
	  }
	}
	
	/* Access full path (`~/index.min.js`). */
	Object.defineProperty(proto, 'path', {
	  get: function () {
	    return this.history[this.history.length - 1];
	  },
	  set: function (path) {
	    assertNonEmpty(path, 'path');
	
	    if (path !== this.path) {
	      this.history.push(path);
	    }
	  }
	});
	
	/* Access parent path (`~`). */
	Object.defineProperty(proto, 'dirname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
	  },
	  set: function (dirname) {
	    assertPath(this.path, 'dirname');
	    this.path = path.join(dirname || '', this.basename);
	  }
	});
	
	/* Access basename (`index.min.js`). */
	Object.defineProperty(proto, 'basename', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
	  },
	  set: function (basename) {
	    assertNonEmpty(basename, 'basename');
	    assertPart(basename, 'basename');
	    this.path = path.join(this.dirname || '', basename);
	  }
	});
	
	/* Access extname (`.js`). */
	Object.defineProperty(proto, 'extname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
	  },
	  set: function (extname) {
	    var ext = extname || '';
	
	    assertPart(ext, 'extname');
	    assertPath(this.path, 'extname');
	
	    if (ext) {
	      if (ext.charAt(0) !== '.') {
	        throw new Error('`extname` must start with `.`');
	      }
	
	      if (ext.indexOf('.', 1) !== -1) {
	        throw new Error('`extname` cannot contain multiple dots');
	      }
	    }
	
	    this.path = replace(this.path, ext);
	  }
	});
	
	/* Access stem (`index.min`). */
	Object.defineProperty(proto, 'stem', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
	  },
	  set: function (stem) {
	    assertNonEmpty(stem, 'stem');
	    assertPart(stem, 'stem');
	    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
	  }
	});
	
	/* Get the value of the file. */
	function toString(encoding) {
	  var value = this.contents || '';
	  return buffer(value) ? value.toString(encoding) : String(value);
	}
	
	/* Assert that `part` is not a path (i.e., does
	 * not contain `path.sep`). */
	function assertPart(part, name) {
	  if (part.indexOf(path.sep) !== -1) {
	    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
	  }
	}
	
	/* Assert that `part` is not empty. */
	function assertNonEmpty(part, name) {
	  if (!part) {
	    throw new Error('`' + name + '` cannot be empty');
	  }
	}
	
	/* Assert `path` exists. */
	function assertPath(path, name) {
	  if (!path) {
	    throw new Error('Setting `' + name + '` requires `path` to be set too');
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var VMessage = __webpack_require__(206);
	var VFile = __webpack_require__(207);
	
	module.exports = VFile;
	
	var proto = VFile.prototype;
	
	proto.message = message;
	proto.info = info;
	proto.fail = fail;
	
	/* Slight backwards compatibility.  Remove in the future. */
	proto.warn = message;
	
	/* Create a message with `reason` at `position`.
	 * When an error is passed in as `reason`, copies the stack. */
	function message(reason, position, origin) {
	  var filePath = this.path;
	  var message = new VMessage(reason, position, origin);
	
	  if (filePath) {
	    message.name = filePath + ':' + message.name;
	    message.file = filePath;
	  }
	
	  message.fatal = false;
	
	  this.messages.push(message);
	
	  return message;
	}
	
	/* Fail. Creates a vmessage, associates it with the file,
	 * and throws it. */
	function fail() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = true;
	
	  throw message;
	}
	
	/* Info. Creates a vmessage, associates it with the file,
	 * and marks the fatality as null. */
	function info() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = null;
	
	  return message;
	}


/***/ },
/* 209 */
/***/ function(module, exports) {

	var toString = Object.prototype.toString
	
	module.exports = isString
	
	function isString(obj) {
	    return toString.call(obj) === "[object String]"
	}


/***/ },
/* 210 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.2874fdb7.js